/* POZCA UX V2 DIRECT - local preview only */
/* Pozca — Anı Kutusu Design Builder */
(function () {
  'use strict';

  /* Google Arama Poster / Ani Gazetesi / Ani Takvimi / Askin Kalbi — hepsinin
     "Boyut" secenegine gore (15x21=A5, 21x30=A4, digerleri A3) GERCEKTEN
     farkli piksel boyutunda ayri bir sablonu var (netflix-poster-tablo'nun
     a3/a4/a5 ucluesuyle ayni desen — bkz. _applyPosterSizeFromVariant).
     Asagidaki her listeye bu 12 id'yi (4 urun x 3 boy) tek tek elle yazmak
     yerine, hepsini bu tek noktadan turetiyoruz — yeni bir "coklu boy" urunu
     eklerken sadece POSTER_MULTI_SIZE_BASE_IDS'e eklemek yeterli olur. */
  var POSTER_MULTI_SIZE_BASE_IDS = ['google_arama_poster', 'ani_gazetesi_poster', 'ani_takvimi_poster', 'askin_kalbi_poster'];
  var POSTER_MULTI_SIZE_ALL_IDS = [];
  POSTER_MULTI_SIZE_BASE_IDS.forEach(function (id) {
    POSTER_MULTI_SIZE_ALL_IDS.push(id, id + '_a4', id + '_a5');
  });

  /* Backend'de gercek sablonu olan urunler — hangi photoTemplateId'nin PDF
     yerine dogrudan Flask API'ye yukleme yapacagini belirler. Yeni bir boy/
     urun eklerken sadece burasi + iz-builder.liquid'deki data-photo-template-id
     guncellenir. */
  var BACKEND_TEMPLATE_IDS = [
    'pozca_custom_90bae70c3306',
    'ani_kutusu', 'netflix_posteri_a3', 'netflix_posteri_a4', 'netflix_posteri_a5',
    'palo_kart_6x9', 'palo_kart_7x10', 'palo_kart_9x11',
    'foto_kart_10x10', 'foto_kart_5x20', 'foto_kart_5x7',
    'foto_kart_6x6', 'foto_kart_8x8', 'foto_kart_9x13', 'foto_kart_13x18',
  ].concat(POSTER_MULTI_SIZE_ALL_IDS);
  /* Bu urunlerde caption/not alani yok (sablonlarinda text_areas/caption_area
     tanimli degil) — yazi kutusunu gostermek musteriye yaziginin bir yere
     basilacagini dusundurur ama hicbir zaman basilmaz. Bu yuzden bu urunlerde
     not/font alanini tamamen gizliyoruz. Google Arama Poster / Ani Gazetesi /
     Ani Takvimi'nin KENDI ozel alanlari var, generic caption/font kutusuna
     ihtiyaci yok. */
  var NO_CAPTION_TEMPLATE_IDS = [
    'foto_kart_10x10', 'foto_kart_5x20', 'foto_kart_5x7',
    'foto_kart_6x6', 'foto_kart_8x8', 'foto_kart_9x13', 'foto_kart_13x18',
  ].concat(POSTER_MULTI_SIZE_ALL_IDS);
  /* Yon-uyumlu "klasik foto kart" boyutlari — musteri yatay bir foto
     yuklerse, canli onizleme kutusu da yatay olur ve backend'e yatay
     basilmasi gerektigi bildirilir (bkz. ORIENTATION_ADAPTIVE_TEMPLATE_IDS
     kullanildigi yerler). Backend'de her biri icin "<id>_yatay" adinda
     kardes bir sablon var (polaroid_project/templates). Palo kart bilerek
     bu listede degil. */
  var ORIENTATION_ADAPTIVE_TEMPLATE_IDS = [
    'foto_kart_5x7', 'foto_kart_9x13', 'foto_kart_13x18',
  ];
  /* Ayni anda en fazla bu kadar foto yuklenir (hem erken/arka plan yukleme
     hem sepete ekleme aninda) — hepsini paralel atmak (orn. 64 fotoluk bir
     siparişte) sunucuyu asiri yukleyip yukleme hatasina/hiz sinirina
     takilmaya yol aciyordu. Bu uc nokta (sadece al+kaydet) tam kompozisyon
     islemine gore cok daha hafif oldugu icin kompozisyonda guvenli bulunan
     sinirdan (2) biraz daha yuksek tutuyoruz. */
  var UPLOAD_CONCURRENCY = 10;

  /* ── Font menu ──
     "k" = backend'e gonderilen font anahtari (composite.py'deki
     CAPTION_FONT_CHOICES ile eslesir). k yoksa bu urun tipinde secilen font
     sadece kozmetik onizlemede kullanilir, backend'e gonderilmez (eski
     davranis — ani_kutusu/polaroid_tek hep sabit el yazisi fontuyla basar). */
  var DEFAULT_FONTS = [
    { v: "'Fraunces', Georgia, serif",           l: 'Fraunces' },
    { v: "'Hanken Grotesk', Arial, sans-serif",  l: 'Hanken Grotesk' },
    { v: 'Georgia, serif',                       l: 'Georgia' },
    { v: "'Palatino Linotype', Palatino, serif", l: 'Palatino Linotype' },
    { v: "'Courier New', Courier, monospace",    l: 'Courier New' }
  ];
  /* Palo kart urunleri (6x9/7x10/9x11) icin: gercekten basilan, sadece 2
     secenekli font listesi. data-caption-fonts="roboto,pacifico" ile
     tetiklenir (bkz. init()). */
  var RESTRICTED_FONTS = {
    roboto:   { v: "'Roboto', Arial, sans-serif", l: 'Roboto',   k: 'roboto' },
    pacifico: { v: "'Pacifico', cursive",          l: 'Pacifico', k: 'pacifico' },
  };
  var FONTS = DEFAULT_FONTS;

  /* ── State ── */
  var MAX_SLOTS  = 20;
  var slots      = [];   // { dataUrl, naturalW, naturalH, offX, offY, caption, font, done }
  var editIdx    = -1;

  /* Coklu SABIT foto alanli sablonlar (orn. 5x20 kitap ayraci — tek fiziksel
     kartta 4 foto alani var). Bu urunlerde musteri otomatik siraya gore
     yerlesim istemiyor: once TUM fotograflari yukler (uploadPool), sonra
     her "kagit" (grup) icin hangi fotografin hangi alana gidecegini kendisi
     secer — tek ekranda: kart sagda sabit, foto havuzu solda (bkz.
     openGroupOverview/assignPoolPhotoToActiveSlot). Diger tum urunlerde
     (grup boyutu=1) bu degiskenler hic kullanilmaz, eski davranis aynen
     surer. */
  /* google_arama_poster: TEK fiziksel poster ama 5 FARKLI boyutlu sabit
     foto alani var — musteri "hangi foto hangi alana gitsin" secimini
     kendisi yapmak istedigi icin (5x20 ile ayni istek) bu urun de gruplu
     akisi kullanir. Grup boyutu = sablonun toplam slot sayisi (5) ve
     MAX_SLOTS da hep 5 (Liquid'de sabit) oldugu icin grup sayisi dogal
     olarak HEP 1 olur — yani "1 kagit" = "1 poster", ozel bir kod
     gerekmeden mevcut mekanizma aynen calisir. */
  var GROUP_SIZE_BY_TEMPLATE = { foto_kart_5x20: 4 };
  /* Google Arama Poster / Ani Gazetesi / Askin Kalbi: grup boyutu (foto alani
     sayisi) A3/A4/A5 boyutlarinin UCUNDE de aynidir (sadece piksel olcegi
     degisir, foto alani sayisi degil) — bu yuzden 3 boyut da ayni grup
     boyutunu paylasir. Askin Kalbi'nde 9 foto alani FARKLI boyutlarda (kucuk
     kenar kareleri + orta buyuk "hero" kare) — musteri hangi fotonun hangi
     alana (orn. en buyuk orta alana) gidecegini onemser, bu yuzden Google/
     Gazete gibi manuel havuz-secim (gruplu) akis kullanir. */
  [
    ['google_arama_poster', 5],
    ['ani_gazetesi_poster', 2],
    ['askin_kalbi_poster', 9],
  ].forEach(function (pair) {
    GROUP_SIZE_BY_TEMPLATE[pair[0]] = pair[1];
    GROUP_SIZE_BY_TEMPLATE[pair[0] + '_a4'] = pair[1];
    GROUP_SIZE_BY_TEMPLATE[pair[0] + '_a5'] = pair[1];
  });
  /* ani_takvimi_poster: 27 foto alani var ama HEPSI AYNI boyutta (300x300) —
     musteri hangi fotonun hangi alana gittigini onemsemedigi (ve 27 tanesini
     tek tek elle atamak yorucu olacagi) icin BU urun gruplu akis KULLANMAZ,
     eski (sirayla otomatik yerlesim) davranisa doner. Ama yine de TEK cikitli
     coklu-slotlu bir sablon oldugu icin (5 foto/2 foto'lu Google/Gazete
     posterleri gibi), son onizlemede TUM fotograflarin birlikte yerlesmis
     oldugu TEK bir poster gorunmeli — grid/final'da 27 ayri "tek foto dolu"
     kart gibi degil. */
  var SINGLE_MULTI_SLOT_TEMPLATE_IDS = ['ani_takvimi_poster', 'ani_takvimi_poster_a4', 'ani_takvimi_poster_a5'];
  function isSingleMultiSlotFlow() {
    return SINGLE_MULTI_SLOT_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1;
  }
  /* Askin Kalbi'nde denenip onaylanan YENI duzenleme deneyimi: kucuk "kagit"
     onizlemesi + yandaki havuz yerine, sablonun TAMAMI buyuk gosterilir; bir
     foto alanina dokununca TAM EKRAN bir foto secim penceresi acilir,
     secilince otomatik kapanip buyuk sablona doner — kirpma/konumlandirma
     da AYNI buyuk sablon uzerinde yapilir (ayri bir yakinlastirma ekranina
     gecmeden). Musterinin acik istegiyle: COKLU-foto (gruplu) posterlerin
     HEPSINE uygulanir, ANCAK Ani Takvimi (mevcut hali zaten begenildi) ve
     tek-fotolu urunler (ani-kutusu, palo-kart, netflix vb. — bu sisteme
     zaten ihtiyaclari yok) HARIC. */
  var BIG_CANVAS_PICKER_TEMPLATE_IDS = [
    'askin_kalbi_poster', 'askin_kalbi_poster_a4', 'askin_kalbi_poster_a5',
    'google_arama_poster', 'google_arama_poster_a4', 'google_arama_poster_a5',
    'ani_gazetesi_poster', 'ani_gazetesi_poster_a4', 'ani_gazetesi_poster_a5',
  ];
  function usesBigCanvasPicker() {
    return false; /* POZCA: eski yan yana foto secimi; tam ekran picker devre disi */
  }
  /* "Boy"/"Boyut" gibi FIZIKSEL BASKI BOYU secenegi olan, "Adet" (miktar)
     secenegi HIC OLMAYAN urunler — genel data-slots-map (miktar) haritasi
     bu urunlerde varyant basligindaki sayiyi ("15x21" -> 15) yanlislikla
     foto sayisi saniyor, bu yuzden JS'in canli varyant-degisim izleyicileri
     bu urunlerde haritayi hic kullanmaz (MAX_SLOTS hep Liquid'in verdigi
     sabit degerde kalir). */
  var FIXED_SLOT_COUNT_PRODUCT_TYPES = [
    'netflix-poster-tablo', 'google-arama-poster-tablo', 'ani-gazetesi-poster-tablo',
    'kalbimdeki-anilar-sarkili-takvim-tablosu', 'askin-kalbi-i̇simli-ve-sarkili-poster-tablo',
  ];
  var draftGeneration = 0;
  var resetOnPageRestore = false;
  var uploadPool   = [];  // grupla mod: ham yuklenmis fotograflar (henuz bir alana atanmamis olabilir)
  var activeGroupIdx    = -1; // grup genel gorunumunde su an acik olan kagit
  var activeSlotInGroup = -1; // acik kagidin hangi fiziksel alani "secili" (tiklanabilir hedef)
  var drag       = { on: false, sx: 0, sy: 0, bx: 0, by: 0 };
  var printStyle    = 'polaroid'; /* polaroid | borderless */
  var paperSize     = 'a4';      /* a4 | a3 | a3p | custom */
  var cardW         = 90;        /* printed card width mm */
  var cardH         = 110;       /* printed card height mm */
  var customPaperW  = 130;       /* custom paper width mm */
  var customPaperH  = 180;       /* custom paper height mm */
  var strictCount   = true;      /* require exact slot count from variant */
  var productType   = 'ani-kutusu';
  var hasSpotify    = false;
  var templateConfig = null;     /* foto-builder: {template, slots:[{x,y,w,h,r}], paperW, paperH} */
  var spotifyTrackId  = '';
  var spotifyTitle    = '';
  var spotifyArtist   = '';
  var spotifyAlbumArt = '';
  var bgChoice        = 'photo'; /* photo | album | g1 | g2 | g3 */
  var posterName      = '';     /* posterde gösterilecek isim */
  var googleArama     = '';     /* Google Arama Poster: aranan cumle */
  var googleIsim      = '';     /* Google Arama Poster: "bunu mu demek istediniz" ismi */
  var gazeteFields = { tarih: '', sehir: '', baslik: '', paragraf1_baslik: '', paragraf1: '', paragraf2_baslik: '', paragraf2: '' }; /* Ani Gazetesi Poster */
  var takvimFields = { ay: '', yil: '', gun: '', spotify: '' }; /* Ani Takvimi Poster (Kalbimdeki Anılar) */
  var kalpFields = { isim1: '', isim2: '', alt_yazi: '', spotify: '' }; /* Askin Kalbi Poster */

  /* Yeni (kalite kaybetmeyen) backend entegrasyonu — sadece ani-kutusu icin.
     PDF/canvas ile ikinci kez sikistirmak yerine orijinal dosyayi Flask API'ye
     yukleyip sunucu tarafinda 300 DPI PNG uretiyoruz. */
  var photoApiBase     = '';
  var photoTemplateId  = 'ani_kutusu';

  /* Afis/tablo urunleri icin canli sablon canvas motoru — gercek arkaplan/onkat
     PNG'lerini ve text_areas semasini backend'den cekip canvas'ta gercek
     zamanli (foto + yazilar) onizleme cizer. Sadece text_areas iceren
     sablonlarda (su an: netflix-poster-tablo) devreye girer. */
  var posterTemplateCache = {}; /* templateId -> {bg,fg,slot,textAreas,srcW,srcH} */
  var posterFrameW = 220;       /* editor canvas'in CSS genisligi (px) — sabit */
  var posterFrameH = 240;       /* sablonun gercek slot en-boy oranina gore hesaplanir */
  var posterDrag   = { on: false, sx: 0, sy: 0, bx: 0, by: 0 };

  /* ── Cached DOM refs ── */
  var modalEl, phaseEls = {};
  var dropZone, thumbsRow, filePickerInput;
  var gridEl, progressEl;
  var editorCounter, photoFrame, photoImg;
  var captionInput, fontSelect, captionPreview;
  var fontListEl, fontBtnLabelEl;
  var finalGridEl;
  var formEl, submitBtn;
  var triggerBtn;
  var stickerToggleBtn, stickerCountEl, stickerPanelEl, stickerTabsEl, stickerGridEl;
  var stickerBackdropEl, stickerCloseBtn;
  var stickerZoomEl, stickerZoomRangeEl, stickerZoomDelBtn;
  var stickerActiveCategory = null;
  var stickerSelectedIdx = -1;   /* canvas'ta su an "secili" (tutamacli) sticker'in slot.stickers[] indexi */
  var stickerImageCache = {};    /* file -> HTMLImageElement, tekrar tekrar yuklenmesin diye */

  /* ─────────────────────────────────────────────── */
  /*  Utility                                         */
  /* ─────────────────────────────────────────────── */
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function q(sel, ctx)      { return (ctx || document).querySelector(sel); }

  function makeSlot() {
    return {
      dataUrl: null, naturalW: 0, naturalH: 0, offX: 0, offY: 0, caption: '', font: FONTS[0].v, done: false,
      /* Netflix-tarzi afis alanlari (sadece netflix-poster-tablo icin kullanilir) */
      posterIsim: '', posterBaslik: '', posterHikaye: '', posterTur: '',
      /* Palo kart yazi alanina eklenen dekoratif sticker'lar — her biri
         {file, x, y, scale} (bkz. drawStickersOnCanvas / STICKER_MANIFEST). */
      stickers: [],
    };
  }

  function currentDraftCallback(cb) {
    var generation = draftGeneration;
    return function () {
      if (generation === draftGeneration) return cb.apply(this, arguments);
    };
  }

  function loadImage(src, cb) {
    cb = currentDraftCallback(cb);
    var img = new Image();
    img.onload  = function () { cb(null, img); };
    img.onerror = function () { cb(new Error('load')); };
    img.src = src;
  }

  /* Musterinin telefon fotograflari genelde 8-15MP (base64 olarak birkac MB
     metin) — bunu dogrudan onizleme icin (kucuk kart canvas'i, foto havuzu,
     grid kareleri) her cizimde tekrar tekrar decode etmek, ozellikle 24-96
     foto yuklenen gruplu urunlerde ("5x20" gibi) gozle gorulur bir yavaslama/
     kasmaya sebep oluyordu. Bu yuzden yukleme aninda KUCUK bir onizleme
     kopyasi (uzun kenar maxDim) uretilip sadece ekran ici onizlemelerde
     kullaniliyor — gercek yukleme/baski hala orijinal tam cozunurlukten
     yapiliyor, kalite kaybi yok. */
  function makePreviewDataUrl(dataUrl, maxDim, cb) {
    var img = new Image();
    img.onload = function () {
      var scale = Math.min(1, maxDim / Math.max(img.naturalWidth, img.naturalHeight));
      var w = Math.max(1, Math.round(img.naturalWidth * scale));
      var h = Math.max(1, Math.round(img.naturalHeight * scale));
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      try { cb(canvas.toDataURL('image/jpeg', 0.72)); }
      catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = dataUrl;
  }

  function getXY(e) {
    if (e.touches && e.touches[0]) return [e.touches[0].clientX, e.touches[0].clientY];
    return [e.clientX, e.clientY];
  }

  /* ─────────────────────────────────────────────── */
  /*  Modal HTML                                      */
  /* ─────────────────────────────────────────────── */
  function getModalHTML() {
    return [
      '<div class="iz-bld__backdrop" id="iz-bld-backdrop"></div>',
      '<div class="iz-bld__panel" role="document">',

        /* Top bar */
        '<div class="iz-bld__topbar">',
          '<button class="iz-bld__back-btn" id="iz-bld-back" aria-label="Geri">',
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>',
          '</button>',
          '<div class="iz-bld__title" id="iz-bld-title">Tasarımlarını Oluştur</div>',
          '<button class="iz-bld__close" id="iz-bld-close" aria-label="Kapat">',
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
        '</div>',

        /* Phase 1: Upload */
        '<div class="iz-bld__phase" id="iz-bld-phase-upload" data-pozca-ux="2">',
      '<div class="iz-bld__upload-intro">',
        '<div class="iz-bld__eyebrow">POZCA TASARIM ATÖLYESİ</div>',
        '<h2 class="iz-bld__upload-heading">Anılarını birlikte hazırlayalım.</h2>',
        '<p class="iz-bld__upload-subtitle">Fotoğraflarını seç, sırala ve baskıdan önce tasarımını kontrol et.</p>',
        '<div class="iz-bld__steps"><span class="is-active">1 · Fotoğraflar</span><span>2 · Düzenle</span><span>3 · Önizle</span></div>',
      '</div>',
          '<div class="iz-bld__upload-zone" id="iz-bld-dropzone" tabindex="0" role="button" aria-label="Fotoğraf yükle">',
            '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
            '<div class="iz-bld__zone-text">Fotoğraflarını buraya bırak</div>',
      '<div class="iz-bld__zone-secondary">Ya da telefonundan / bilgisayarından seç</div>',
      '<span class="iz-bld__choose-photo">+ Fotoğraf Seç</span>',
            '<div class="iz-bld__zone-hint" id="iz-bld-zone-hint">En fazla <strong id="iz-bld-max-label">20</strong> fotoğraf · JPG, PNG, WEBP</div>',
          '</div>',
          '<input type="file" id="iz-bld-file-input" accept="image/jpeg,image/png,image/webp" multiple style="display:none">',
          '<div class="iz-bld__selection">',
      '<div class="iz-bld__selection-heading"><div><div class="iz-bld__eyebrow">SEÇİLEN FOTOĞRAFLAR</div><div class="iz-bld__upload-summary" id="iz-bld-upload-summary" aria-live="polite">0 fotoğraf seçildi</div></div><strong id="iz-bld-ux-count">0 / 0</strong></div>',
      '<div class="iz-bld__slot-track"><span id="iz-bld-ux-bar"></span></div>',
      '<div id="iz-bld-ux-status" class="iz-bld__selection-status">Fotoğraflarını ekleyerek başla.</div>',
    '</div>',
          '<div class="iz-bld__read-progress" id="iz-bld-read-progress" style="display:none" aria-live="polite">',
            '<span id="iz-bld-read-progress-label">Fotoğraflar hazırlanıyor…</span>',
            '<div class="iz-bld__read-track" role="progressbar" aria-label="Fotoğraf hazırlama" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span id="iz-bld-read-bar"></span></div>',
          '</div>',
          '<div class="iz-bld__upload-errors" id="iz-bld-upload-errors" role="alert" style="display:none"></div>',
          '<p class="iz-bld__upload-order-help">Fotoğrafların sırasını oklarla değiştirebilir veya tek tek yenileyebilirsin.</p>',
          '<div class="iz-bld__upload-thumbs" id="iz-bld-thumbs"></div>',
    '<button type="button" class="iz-bld__add-more" id="iz-bld-add-more" style="display:none">+ Daha fazla fotoğraf ekle</button>',
          '<input type="file" id="iz-bld-replace-input" accept="image/jpeg,image/png,image/webp" style="display:none">',

          /* Müzik Posteri — Şarkı Bilgileri */
          '<div class="iz-bld__spotify-section" id="iz-bld-spotify-section" style="display:none;padding:12px 16px 16px;border-top:1px solid rgba(231,222,206,0.45);margin-top:8px">',
            '<p style="font-size:10.5px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#C2872E;margin:0 0 12px">Şarkı Bilgileri</p>',

            /* İsim — zorunlu */
            '<div class="iz-bld__field">',
              '<label class="iz-bld__label" for="iz-bld-poster-name">Posterde Görünecek İsimler <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-poster-name" class="iz-bld__input" placeholder="Veli &amp; Cansu" autocomplete="off" maxlength="40" style="margin-top:5px">',
              '<label style="display:flex;align-items:center;gap:6px;margin-top:7px;cursor:pointer;font-size:11px;color:#7B8398">',
                '<input type="checkbox" id="iz-bld-no-name" style="cursor:pointer;width:13px;height:13px">',
                'İsim istemiyorum',
              '</label>',
              '<div id="iz-name-err" style="font-size:10px;color:#e63946;margin-top:3px;display:none">Lütfen isim girin veya "İsim istemiyorum" seçeneğini işaretleyin</div>',
            '</div>',

            /* Spotify linki */
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-spotify-url">Spotify Linki <span style="font-weight:400;color:#7B8398;font-size:11px">(otomatik doldurur)</span></label>',
              '<input type="text" id="iz-bld-spotify-url" class="iz-bld__input" placeholder="https://open.spotify.com/track/…" autocomplete="off" style="margin-top:5px">',
            '</div>',

            '<div id="iz-bld-sp-art-row" style="display:none;margin-top:10px;padding:10px;background:rgba(30,42,68,0.06);border-radius:8px;align-items:center;gap:10px">',
              '<img id="iz-bld-sp-art-img" src="" alt="" style="width:44px;height:44px;border-radius:5px;object-fit:cover;flex-shrink:0">',
              '<div style="flex:1;min-width:0">',
                '<div id="iz-bld-sp-art-title" style="font-size:12px;font-weight:600;color:#1E2A44;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"></div>',
                '<div style="font-size:10.5px;color:#7B8398;margin-top:2px">Spotify\'dan bulundu</div>',
              '</div>',
            '</div>',

            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-song-title">Şarkı Adı</label>',
              '<input type="text" id="iz-bld-song-title" class="iz-bld__input" placeholder="Güzel bir şarkı…" autocomplete="off" style="margin-top:5px">',
            '</div>',

            '<div class="iz-bld__field" style="margin-top:8px">',
              '<label class="iz-bld__label" for="iz-bld-artist-name">Sanatçı</label>',
              '<input type="text" id="iz-bld-artist-name" class="iz-bld__input" placeholder="Sanatçı adı…" autocomplete="off" style="margin-top:5px">',
            '</div>',

            /* Arka plan seçici — zorunlu */
            '<div style="margin-top:14px">',
              '<p style="font-size:10px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#7B8398;margin:0 0 8px">Poster Arka Planı <span style="color:#e63946">*</span></p>',
              '<div style="display:grid;grid-template-columns:repeat(5,1fr);gap:5px">',
                /* Fotoğrafın kendisi */
                '<div style="text-align:center">',
                  '<button type="button" id="iz-bg-photo" data-bg="photo" style="width:100%;aspect-ratio:1/1;border-radius:7px;border:2px solid transparent;background:rgba(30,42,68,0.10);cursor:pointer;display:flex;align-items:center;justify-content:center">',
                    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
                  '</button>',
                  '<div style="font-size:8px;color:#555;margin-top:3px;font-weight:600;line-height:1.2">Fotoğrafın</div>',
                '</div>',
                /* Albüm kapağı */
                '<div style="text-align:center">',
                  '<button type="button" id="iz-bg-album" data-bg="album" style="width:100%;aspect-ratio:1/1;border-radius:7px;border:2px solid transparent;background:linear-gradient(135deg,#0d2137,#091220);cursor:pointer;display:flex;align-items:center;justify-content:center">',
                    '<span style="font-size:16px">🎵</span>',
                  '</button>',
                  '<div style="font-size:8px;color:#555;margin-top:3px;font-weight:600;line-height:1.2">Albüm</div>',
                '</div>',
                /* Gece mavisi */
                '<div style="text-align:center">',
                  '<button type="button" id="iz-bg-g1" data-bg="g1" style="width:100%;aspect-ratio:1/1;border-radius:7px;border:2px solid transparent;background:linear-gradient(135deg,#0a0a2e,#1a2a5e);cursor:pointer"></button>',
                  '<div style="font-size:8px;color:#555;margin-top:3px;font-weight:600;line-height:1.2">Gece</div>',
                '</div>',
                /* Mor */
                '<div style="text-align:center">',
                  '<button type="button" id="iz-bg-g2" data-bg="g2" style="width:100%;aspect-ratio:1/1;border-radius:7px;border:2px solid transparent;background:linear-gradient(135deg,#140a28,#3a1060);cursor:pointer"></button>',
                  '<div style="font-size:8px;color:#555;margin-top:3px;font-weight:600;line-height:1.2">Mor</div>',
                '</div>',
                /* Kırmızı */
                '<div style="text-align:center">',
                  '<button type="button" id="iz-bg-g3" data-bg="g3" style="width:100%;aspect-ratio:1/1;border-radius:7px;border:2px solid transparent;background:linear-gradient(135deg,#140505,#440f0f);cursor:pointer"></button>',
                  '<div style="font-size:8px;color:#555;margin-top:3px;font-weight:600;line-height:1.2">Kırmızı</div>',
                '</div>',
              '</div>',
              '<div id="iz-bg-err" style="font-size:10px;color:#e63946;margin-top:4px;display:none">Lütfen bir arka plan seçiniz</div>',
            '</div>',
          '</div>',

          /* Google Arama Poster — arama cumlesi + isim (postere ozel, tek
             seferlik alanlar; 5 farkli fotografin HER BIRININ duzenleme
             ekraninda tekrar tekrar sormak yerine, tum fotograflari yuklemeden
             ONCE burada bir kez soruluyor). */
          '<div class="iz-bld__spotify-section" id="iz-bld-google-section" style="display:none;padding:12px 16px 16px;border-top:1px solid rgba(231,222,206,0.45);margin-top:8px">',
            '<p style="font-size:10.5px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#C2872E;margin:0 0 12px">Arama Metni</p>',
            '<div class="iz-bld__field">',
              '<label class="iz-bld__label" for="iz-bld-google-arama">Google\'da Aranan Cümle <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-google-arama" class="iz-bld__input" placeholder="Dünyanın En Güzel Kızı" autocomplete="off" maxlength="60" style="margin-top:5px">',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-google-isim">"Bunu mu demek istediniz?" İsmi <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-google-isim" class="iz-bld__input" placeholder="Tuna Çitoğlu" autocomplete="off" maxlength="40" style="margin-top:5px">',
            '</div>',
            '<div id="iz-google-err" style="font-size:10px;color:#e63946;margin-top:6px;display:none">Devam etmeden önce her iki alanı da doldurun.</div>',
          '</div>',

          /* Ani Gazetesi Poster — 7 sabit metin alani (tarih/sehir/baslik +
             2 paragraf basligi + 2 paragraf), Google Arama Poster ile ayni
             mantik: tum fotograflari yuklemeden ONCE burada bir kez soruluyor. */
          '<div class="iz-bld__spotify-section" id="iz-bld-gazete-section" style="display:none;padding:12px 16px 16px;border-top:1px solid rgba(231,222,206,0.45);margin-top:8px">',
            '<p style="font-size:10.5px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#C2872E;margin:0 0 12px">Gazete Metinleri</p>',
            '<div style="display:flex;gap:10px">',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-gazete-tarih">Tarih <span style="color:#e63946">*</span></label>',
                '<input type="text" id="iz-bld-gazete-tarih" class="iz-bld__input" placeholder="14 Eylül 2025" autocomplete="off" maxlength="20" style="margin-top:5px">',
              '</div>',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-gazete-sehir">Şehir <span style="color:#e63946">*</span></label>',
                '<input type="text" id="iz-bld-gazete-sehir" class="iz-bld__input" placeholder="İstanbul" autocomplete="off" maxlength="16" style="margin-top:5px">',
              '</div>',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-gazete-baslik">Ana Başlık <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-gazete-baslik" class="iz-bld__input" placeholder="Birlikte Yazdığımız Hikaye" autocomplete="off" maxlength="60" style="margin-top:5px">',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-gazete-paragraf1_baslik">1. Paragraf Başlığı <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-gazete-paragraf1_baslik" class="iz-bld__input" placeholder="İlk Günden Beri Aynı Heyecanla" autocomplete="off" maxlength="60" style="margin-top:5px">',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-gazete-paragraf1">1. Paragraf <span style="color:#e63946">*</span> <span class="iz-bld__charcount" id="iz-bld-gazete-paragraf1-count">0/420</span></label>',
              '<textarea id="iz-bld-gazete-paragraf1" class="iz-bld__input" rows="4" placeholder="Hikayenizi buraya yazın…" maxlength="420" style="margin-top:5px;resize:vertical;font-family:inherit"></textarea>',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-gazete-paragraf2_baslik">2. Paragraf Başlığı <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-gazete-paragraf2_baslik" class="iz-bld__input" placeholder="Yıllara Meydan Okuyan Sevgi" autocomplete="off" maxlength="60" style="margin-top:5px">',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-gazete-paragraf2">2. Paragraf <span style="color:#e63946">*</span> <span class="iz-bld__charcount" id="iz-bld-gazete-paragraf2-count">0/420</span></label>',
              '<textarea id="iz-bld-gazete-paragraf2" class="iz-bld__input" rows="4" placeholder="Hikayenizi buraya yazın…" maxlength="420" style="margin-top:5px;resize:vertical;font-family:inherit"></textarea>',
            '</div>',
            '<div id="iz-gazete-err" style="font-size:10px;color:#e63946;margin-top:6px;display:none">Devam etmeden önce tüm alanları doldurun.</div>',
          '</div>',

          /* Ani Takvimi Poster (Kalbimdeki Anılar) — ay/yil/gun (dinamik
             takvim + secili gunu kalp ile isaretleme) + Spotify linki, upload
             fazinda BIR KEZ sorulur. */
          '<div class="iz-bld__spotify-section" id="iz-bld-takvim-section" style="display:none;padding:12px 16px 16px;border-top:1px solid rgba(231,222,206,0.45);margin-top:8px">',
            '<p style="font-size:10.5px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#C2872E;margin:0 0 12px">Anı Tarihi</p>',
            '<div style="display:flex;gap:10px">',
              '<div class="iz-bld__field" style="flex:1.4">',
                '<label class="iz-bld__label" for="iz-bld-takvim-ay">Ay <span style="color:#e63946">*</span></label>',
                '<select id="iz-bld-takvim-ay" class="iz-bld__input" style="margin-top:5px">',
                  '<option value="">Seçin…</option>',
                  /* Posterde ay adi HER ZAMAN tam buyuk harfle basilsin
                     istendigi icin secenek degeri de dogrudan buyuk harfle
                     tutuluyor (musterinin secimi = postere basilacak metin). */
                  ['OCAK','ŞUBAT','MART','NİSAN','MAYIS','HAZİRAN','TEMMUZ','AĞUSTOS','EYLÜL','EKİM','KASIM','ARALIK'].map(function (m) {
                    return '<option value="' + m + '">' + m + '</option>';
                  }).join(''),
                '</select>',
              '</div>',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-takvim-yil">Yıl <span style="color:#e63946">*</span></label>',
                '<input type="number" id="iz-bld-takvim-yil" class="iz-bld__input" placeholder="2025" min="1950" max="2100" style="margin-top:5px">',
              '</div>',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-takvim-gun">Gün <span style="color:#e63946">*</span></label>',
                '<select id="iz-bld-takvim-gun" class="iz-bld__input" style="margin-top:5px">',
                  '<option value="">Seçin…</option>',
                  Array.from({ length: 31 }, function (_, i) { return i + 1; }).map(function (d) {
                    return '<option value="' + d + '">' + d + '</option>';
                  }).join(''),
                '</select>',
              '</div>',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-takvim-spotify">Spotify Şarkı Linki <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-takvim-spotify" class="iz-bld__input" placeholder="https://open.spotify.com/track/…" autocomplete="off" style="margin-top:5px">',
            '</div>',
            '<div id="iz-takvim-err" style="font-size:10px;color:#e63946;margin-top:6px;display:none">Devam etmeden önce tüm alanları doldurun.</div>',
          '</div>',

          /* Askin Kalbi Poster — iki isim (aralarina & otomatik ve tam
             ortali eklenir) + alt yazi + Spotify linki, upload fazinda
             BIR KEZ sorulur. */
          '<div class="iz-bld__spotify-section" id="iz-bld-kalp-section" style="display:none;padding:12px 16px 16px;border-top:1px solid rgba(231,222,206,0.45);margin-top:8px">',
            '<p style="font-size:10.5px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#C2872E;margin:0 0 12px">İsimler & Notunuz</p>',
            '<div style="display:flex;gap:10px">',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-kalp-isim1">1. İsim <span style="color:#e63946">*</span></label>',
                '<input type="text" id="iz-bld-kalp-isim1" class="iz-bld__input" placeholder="Yusuf" autocomplete="off" maxlength="24" style="margin-top:5px">',
              '</div>',
              '<div class="iz-bld__field" style="flex:1">',
                '<label class="iz-bld__label" for="iz-bld-kalp-isim2">2. İsim <span style="color:#e63946">*</span></label>',
                '<input type="text" id="iz-bld-kalp-isim2" class="iz-bld__input" placeholder="Aleyna" autocomplete="off" maxlength="24" style="margin-top:5px">',
              '</div>',
            '</div>',
            '<p style="font-size:10.5px;color:#9a927e;margin:6px 0 0">İsimlerin arasına "&" işaretini biz otomatik ve tam ortalı ekleriz.</p>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-kalp-alt_yazi">Alt Yazı <span style="color:#e63946">*</span> <span class="iz-bld__charcount" id="iz-bld-kalp-alt_yazi-count">0/40</span></label>',
              '<input type="text" id="iz-bld-kalp-alt_yazi" class="iz-bld__input" placeholder="Seni Çok Seviyorum Sevgilim" autocomplete="off" maxlength="40" style="margin-top:5px">',
            '</div>',
            '<div class="iz-bld__field" style="margin-top:10px">',
              '<label class="iz-bld__label" for="iz-bld-kalp-spotify">Spotify Şarkı Linki <span style="color:#e63946">*</span></label>',
              '<input type="text" id="iz-bld-kalp-spotify" class="iz-bld__input" placeholder="https://open.spotify.com/track/…" autocomplete="off" style="margin-top:5px">',
            '</div>',
            '<div id="iz-kalp-err" style="font-size:10px;color:#e63946;margin-top:6px;display:none">Devam etmeden önce tüm alanları doldurun.</div>',
          '</div>',

          '<div class="iz-bld__phase-footer">',
            '<button class="iz-bld__btn iz-bld__btn--primary" id="iz-bld-to-grid" disabled>',
              'Devam — Tasarımları Düzenle',
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>',
            '</button>',
          '</div>',
        '</div>',

        /* Phase 2: Grid */
        '<div class="iz-bld__phase" id="iz-bld-phase-grid" style="display:none">',
          '<div class="iz-bld__progress" id="iz-bld-progress">0 / 0 tamamlandı</div>',
          '<div class="iz-bld__grid" id="iz-bld-grid" style="margin-top:14px"></div>',
          '<div class="iz-bld__phase-footer iz-bld__phase-footer--space">',
            '<button class="iz-bld__btn iz-bld__btn--ghost" id="iz-bld-grid-back">← Fotoğrafları Değiştir</button>',
            '<button class="iz-bld__btn iz-bld__btn--primary" id="iz-bld-to-final" disabled>Ön İzlemeye Geç →</button>',
          '</div>',
        '</div>',

        /* Phase 2b: Grup (kagit) genel gorunumu — sadece coklu sabit foto
           alanli sablonlarda (orn. 5x20 kitap ayraci, 4 alan) kullanilir.
           Musteri otomatik yerlesim yerine hangi fotografin hangi alana
           gidecegini kendisi secer. Kart sagda SABIT durur, foto havuzu
           solda — sayfa kaydirmadan, ayri bir ekrana gecmeden hizlica
           tiklayip yerlestirebilmesi icin hepsi tek ekranda yan yana. */
        '<div class="iz-bld__phase" id="iz-bld-phase-group" style="display:none">',
          '<div class="iz-bld__editor-nav">',
            '<button class="iz-bld__btn iz-bld__btn--ghost" id="iz-bld-group-back" style="padding:7px 14px;font-size:13px">← Geri</button>',
            '<div class="iz-bld__editor-counter" id="iz-bld-group-counter" style="display:' + (usesBigCanvasPicker() ? 'none' : '') + '">Kağıt 1 / 1</div>',
            '<div style="width:66px"></div>',
          '</div>',
          '<div class="iz-bld__group-hint">' + (usesBigCanvasPicker()
            ? 'Bir foto alanına dokunun, açılan pencereden yüklediğiniz fotoğraflardan birini seçin. Konumlandırmak için şablon üzerinde dokunup sürükleyin.'
            : 'Önce soldaki bir alana dokunun, sağdan o alana koyacağınız fotoğrafı seçin. Fotoğrafı konumlandırmak için kart üzerinde bir kez dokunup sürükleyin.') + '</div>',
          '<div style="display:flex;flex-wrap:' + (usesBigCanvasPicker() ? 'wrap' : 'nowrap') + ';gap:14px;align-items:flex-start;justify-content:center;margin-top:10px">',
            '<div style="flex-shrink:0;' + (usesBigCanvasPicker() ? 'width:min(94vw,640px)' : 'width:250px') + ';text-align:center;position:sticky;top:0">',
              '<canvas id="iz-bld-group-canvas" style="width:' + (usesBigCanvasPicker() ? 'min(94vw,640px)' : '250px') + ';max-width:100%;height:auto;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.25);cursor:pointer;display:block;margin:0 auto"></canvas>',
              '<button class="iz-bld__btn iz-bld__btn--sm iz-bld__btn--ghost" id="iz-bld-group-slot-remove" style="margin-top:8px;display:none;width:100%">Bu alanı boşalt</button>',
            '</div>',
            '<div id="iz-bld-group-pool" class="iz-bld__group-pool" style="display:' + (usesBigCanvasPicker() ? 'none' : '') + '"></div>',
          '</div>',
          '<div class="iz-bld__phase-footer">',
            '<button class="iz-bld__btn iz-bld__btn--primary" id="iz-bld-group-confirm" style="width:100%" disabled>Bu Kağıdı Onayla ✓</button>',
          '</div>',
        '</div>',

        /* Tam ekran foto secim penceresi — sadece BIG_CANVAS_PICKER_TEMPLATE_IDS
           icin: bir foto alanina dokununca acilir, musterinin yukledigi TUM
           fotograflari buyuk karolar halinde gosterir, secince o alana atar
           ve otomatik kapanir. */
        '<div id="iz-bld-pool-picker" class="iz-bld__pool-picker-overlay" style="display:none">',
          '<div class="iz-bld__pool-picker-header">',
            '<span>Bir Fotoğraf Seçin</span>',
            '<button type="button" id="iz-bld-pool-picker-close" class="iz-bld__pool-picker-close" aria-label="Kapat">✕</button>',
          '</div>',
          '<div id="iz-bld-pool-picker-grid" class="iz-bld__pool-picker-grid"></div>',
        '</div>',

        /* Phase 3: Editor */
        '<div class="iz-bld__phase" id="iz-bld-phase-editor" style="display:none">',
          '<div class="iz-bld__editor-nav">',
            '<button class="iz-bld__btn iz-bld__btn--ghost" id="iz-bld-editor-back" style="padding:7px 14px;font-size:13px">← Geri</button>',
            '<div class="iz-bld__editor-counter" id="iz-bld-editor-counter">1 / 20</div>',
            '<button class="iz-bld__btn iz-bld__btn--ghost" id="iz-bld-editor-next" style="padding:7px 14px;font-size:13px" disabled>İleri →</button>',
          '</div>',
          '<div class="iz-bld__editor-body">',
            /* Polaroid */
            '<div class="iz-bld__polaroid-wrap" id="iz-bld-polaroid-wrap">',
              '<div class="iz-bld__polaroid">',
                '<div class="iz-bld__photo-frame" id="iz-bld-photo-frame">',
                  '<img class="iz-bld__photo-img" id="iz-bld-photo-img" src="" alt="" draggable="false">',
                '</div>',
                '<div class="iz-bld__polaroid-caption" id="iz-bld-cap-preview">Not ekle…</div>',
              '</div>',
              '<div class="iz-bld__pan-hint">',
                '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"/></svg>',
                'Fotoğrafı parmağınızla/fareyle sürükleyerek konumlandırabilirsiniz',
              '</div>',
            '</div>',
            /* Afis/tablo urunleri: gercek sablonu canli gosteren canvas */
            '<div class="iz-bld__polaroid-wrap" id="iz-bld-poster-canvas-wrap" style="display:none">',
              '<canvas id="iz-bld-poster-editor-canvas" style="width:220px;max-width:100%;height:auto;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.25);cursor:grab;touch-action:none;display:block;margin:0 auto"></canvas>',
              '<div class="iz-bld__pan-hint">',
                '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"/></svg>',
                'Fotoğrafı parmağınızla/fareyle sürükleyerek konumlandırabilirsiniz',
              '</div>',
              /* Bir sticker secildiginde gorunur olur — PDF gorunuculerindeki
                 yakinlastirma cubugu gibi, canvas uzerinde kucuk bir tutamaci
                 tutturmaya calismak yerine net/rahat bir surgu ile boyut
                 ayarlanir. */
              '<div class="iz-bld__sticker-zoom" id="iz-bld-sticker-zoom" hidden>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/></svg>',
                '<input type="range" id="iz-bld-sticker-zoom-range" min="0" max="1000" value="500" step="1" aria-label="Sticker boyutu">',
                '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>',
                '<button type="button" class="iz-bld__sticker-zoom-del" id="iz-bld-sticker-zoom-del" aria-label="Sticker\'ı kaldır">',
                  '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m2 0v14a1 1 0 01-1 1H7a1 1 0 01-1-1V6h12z"/></svg>',
                '</button>',
              '</div>',
            '</div>',
            /* Fields */
            '<div class="iz-bld__editor-fields">',
              '<div id="iz-bld-caption-font-fields">',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label" for="iz-bld-caption">Not / Alıntı <span style="font-weight:400;color:#7B8398;font-size:11.5px">(isteğe bağlı)</span></label>',
                  '<input class="iz-bld__input" id="iz-bld-caption" type="text" placeholder="Bir anıyı not düş…" maxlength="120">',
                '</div>',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label">Yazı Fontu</label>',
                  '<div class="iz-bld__font-picker" id="iz-bld-font-picker">',
                    '<button class="iz-bld__font-btn" id="iz-bld-font-btn" type="button" aria-haspopup="listbox" aria-expanded="false">',
                      '<span class="iz-bld__font-btn-label" id="iz-bld-font-btn-label">Fraunces</span>',
                      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>',
                    '</button>',
                    '<div class="iz-bld__font-list" id="iz-bld-font-list" role="listbox" aria-label="Font seç" hidden></div>',
                  '</div>',
                  '<input type="hidden" id="iz-bld-font" value="">',
                  '<div class="iz-bld__font-preview" id="iz-bld-font-preview">Anı &amp; Sevgi — örnek metin</div>',
                '</div>',
                '<div class="iz-bld__field">',
                  '<button class="iz-bld__sticker-toggle-btn" id="iz-bld-sticker-toggle" type="button" aria-expanded="false">',
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-2 7a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm-5 5.5c1 1.2 2.2 1.5 3 1.5s2-.3 3-1.5"/></svg>',
                    '<span>Sticker Ekle</span>',
                    '<span class="iz-bld__sticker-count" id="iz-bld-sticker-count" hidden></span>',
                  '</button>',
                  '<div class="iz-bld__sticker-backdrop" id="iz-bld-sticker-backdrop"></div>',
                  '<div class="iz-bld__sticker-panel" id="iz-bld-sticker-panel">',
                    '<div class="iz-bld__sticker-sheet-handle"></div>',
                    '<div class="iz-bld__sticker-sheet-header">',
                      '<span>Sticker Ekle</span>',
                      '<button type="button" class="iz-bld__sticker-sheet-close" id="iz-bld-sticker-close" aria-label="Kapat">',
                        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 6l12 12M18 6L6 18"/></svg>',
                      '</button>',
                    '</div>',
                    '<div class="iz-bld__sticker-tabs" id="iz-bld-sticker-tabs"></div>',
                    '<div class="iz-bld__sticker-grid" id="iz-bld-sticker-grid"></div>',
                  '</div>',
                '</div>',
              '</div>',
              /* Netflix-tarzi afis: isim/baslik/hikaye/tur alanlari (sadece netflix-poster-tablo icin gosterilir) */
              '<div id="iz-bld-poster-fields" style="display:none">',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label" for="iz-bld-poster-isim">İsim(ler) <span class="iz-bld__charcount" id="iz-bld-poster-isim-count">0/60</span></label>',
                  '<input class="iz-bld__input" id="iz-bld-poster-isim" type="text" placeholder="Örn. İbrahim &amp; Sude" maxlength="60">',
                '</div>',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label" for="iz-bld-poster-baslik">Başlık <span class="iz-bld__charcount" id="iz-bld-poster-baslik-count">0/40</span></label>',
                  '<input class="iz-bld__input" id="iz-bld-poster-baslik" type="text" placeholder="Örn. Sonsuz Hikayemiz" maxlength="40">',
                '</div>',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label" for="iz-bld-poster-hikaye">Hikayeniz <span class="iz-bld__charcount" id="iz-bld-poster-hikaye-count">0/400</span></label>',
                  '<textarea class="iz-bld__input" id="iz-bld-poster-hikaye" rows="4" placeholder="Hikayenizi buraya yazın…" maxlength="400" style="resize:vertical;font-family:inherit"></textarea>',
                '</div>',
                '<div class="iz-bld__field">',
                  '<label class="iz-bld__label" for="iz-bld-poster-tur">Tür <span class="iz-bld__charcount" id="iz-bld-poster-tur-count">0/30</span></label>',
                  '<input class="iz-bld__input" id="iz-bld-poster-tur" type="text" placeholder="Örn. Romantik Komedi" maxlength="30">',
                '</div>',
                '<div id="iz-bld-poster-err" style="font-size:11px;color:#e63946;margin-top:6px;display:none">Devam etmeden önce tüm alanları doldurun.</div>',
              '</div>',
              '<button class="iz-bld__btn iz-bld__btn--primary" id="iz-bld-confirm-edit" style="margin-top:8px;width:100%">',
                'Bu Tasarımı Onayla ✓',
              '</button>',
            '</div>',
          '</div>',
        '</div>',

        /* Phase 4: Final */
        '<div class="iz-bld__phase" id="iz-bld-phase-final" style="display:none">',
          '<div class="iz-bld__final-title">Tüm tasarımların — sipariş vermeden önce kontrol et</div>',

          /* Müzik posteri canlı ön izleme */
          '<div id="iz-bld-poster-preview-wrap" style="display:none;margin:0 auto 16px;width:210px">',
            '<div style="position:relative;width:210px;height:297px;border-radius:10px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,0.35)">',
              /* Canvas: arka plan + fotoğraf */
              '<canvas id="iz-bld-preview-canvas" width="630" height="891" style="position:absolute;inset:0;width:210px;height:297px;display:block"></canvas>',
              /* HTML katmanı: tüm metin/ikon */
              '<div id="iz-bld-preview-overlay" style="position:absolute;inset:0;display:flex;flex-direction:column;padding:8px 10px 7px;box-sizing:border-box;pointer-events:none">',
                /* Üst bar: chevron | isim | 3 nokta */
                '<div style="display:flex;align-items:center;justify-content:space-between;height:14px;flex-shrink:0">',
                  '<svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2.5" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>',
                  '<span id="iz-pvw-name" style="font-size:5.5px;font-weight:500;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:66%;text-align:center"></span>',
                  '<div style="display:flex;gap:2px">',
                    '<div style="width:2.5px;height:2.5px;border-radius:50%;background:rgba(255,255,255,0.7)"></div>',
                    '<div style="width:2.5px;height:2.5px;border-radius:50%;background:rgba(255,255,255,0.7)"></div>',
                    '<div style="width:2.5px;height:2.5px;border-radius:50%;background:rgba(255,255,255,0.7)"></div>',
                  '</div>',
                '</div>',
                /* Fotoğraf alanı (canvas çizer) */
                '<div style="flex:1"></div>',
                /* Şarkı + yeşil check */
                '<div style="display:flex;align-items:center;justify-content:space-between;gap:4px;margin-top:6px">',
                  '<div id="iz-pvw-song" style="font-size:8.5px;font-weight:800;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1">Şarkı Adı</div>',
                  '<div style="width:10px;height:10px;border-radius:50%;background:#1ED760;flex-shrink:0;display:flex;align-items:center;justify-content:center">',
                    '<svg width="6" height="6" viewBox="0 0 12 12" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="2,6 5,9 10,3"/></svg>',
                  '</div>',
                '</div>',
                /* Sanatçı */
                '<div id="iz-pvw-artist" style="font-size:5.5px;color:#ccc;margin-top:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Sanatçı</div>',
                /* Progress bar */
                '<div style="margin-top:5px;position:relative;height:1.5px;background:rgba(255,255,255,0.2);border-radius:1px">',
                  '<div style="position:absolute;left:0;top:0;height:100%;width:24%;background:#fff;border-radius:1px"></div>',
                  '<div style="position:absolute;top:50%;left:24%;transform:translate(-50%,-50%);width:6px;height:6px;background:#fff;border-radius:50%"></div>',
                '</div>',
                '<div style="display:flex;justify-content:space-between;margin-top:2px">',
                  '<span style="font-size:4px;color:#aaa">1:03</span>',
                  '<span style="font-size:4px;color:#aaa">4:44</span>',
                '</div>',
                /* Kontrol ikonları: shuffle | prev | pause | next | queue */
                '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:7px;padding:0 1px">',
                  /* shuffle - yeşil */
                  '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1ED760" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>',
                  /* prev */
                  '<svg width="11" height="11" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="19,4 8,12 19,20"/><rect x="4" y="4" width="3.5" height="16"/></svg>',
                  /* pause dairesi */
                  '<div style="width:20px;height:20px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0">',
                    '<svg width="9" height="9" viewBox="0 0 24 24" fill="#000" stroke="none"><rect x="5" y="4" width="4" height="16" rx="1"/><rect x="15" y="4" width="4" height="16" rx="1"/></svg>',
                  '</div>',
                  /* next */
                  '<svg width="11" height="11" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5,4 16,12 5,20"/><rect x="16.5" y="4" width="3.5" height="16"/></svg>',
                  /* queue */
                  '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="2.2" stroke-linecap="round"><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="15" y2="17"/></svg>',
                '</div>',
                /* Alt 3 ikon */
                '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:5px;padding:0 1px">',
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.45)" stroke-width="2" stroke-linecap="round"><rect x="2" y="2" width="8" height="8" rx="1"/><rect x="14" y="2" width="8" height="8" rx="1"/><rect x="14" y="14" width="8" height="8" rx="1"/><rect x="2" y="14" width="8" height="8" rx="1"/></svg>',
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.45)" stroke-width="2" stroke-linecap="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>',
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.45)" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="15" y2="18"/></svg>',
                '</div>',
                /* Barkod en altta */
                '<div style="margin-top:6px;text-align:center;flex-shrink:0">',
                  '<img id="iz-pvw-barcode" src="" alt="" style="height:15px;max-width:100%;object-fit:contain;display:none">',
                '</div>',
              '</div>',
            '</div>',
            '<p style="text-align:center;font-size:10px;color:#7B8398;margin:8px 0 0">Gerçek poster baskıda bu tasarımda çıkacak</p>',
          '</div>',

          /* Foto-builder şablon önizlemesi */
          '<div id="iz-bld-foto-preview-wrap" style="display:none;margin:0 auto 16px;max-width:300px;width:100%">',
            '<div style="position:relative;border-radius:8px;overflow:hidden;box-shadow:0 6px 24px rgba(0,0,0,0.25)">',
              '<canvas id="iz-bld-foto-canvas" style="display:block;width:100%;height:auto"></canvas>',
            '</div>',
            '<p style="text-align:center;font-size:10px;color:#7B8398;margin:8px 0 0">Gerçek baskıda bu tasarımda çıkacak — kenar payları dahil değil</p>',
          '</div>',

          '<div id="iz-bld-lowres-warning" style="display:none;font-size:12px;font-weight:600;color:#8A5A00;background:rgba(194,135,46,0.12);border:1px solid rgba(194,135,46,0.35);border-radius:8px;padding:9px 12px;margin-bottom:12px;text-align:center;line-height:1.4">',
            '⚠ Bazı fotoğraflarınız düşük çözünürlükte — baskıda bulanık/pikselli çıkabilir. Yine de devam edebilirsiniz.',
          '</div>',
          '<div class="iz-bld__final-grid" id="iz-bld-final-grid"></div>',
          '<div class="iz-bld__phase-footer">',
            '<label style="display:flex;align-items:flex-start;gap:8px;font-size:12px;color:var(--iz-ink-2,#46506A);line-height:1.45;margin-bottom:12px;cursor:pointer">',
              '<input type="checkbox" id="iz-bld-copyright-ok" style="margin-top:2px;flex-shrink:0;width:16px;height:16px">',
              '<span>Yüklediğim fotoğrafların telif haklarına sahip olduğumu veya bunları kullanma iznim olduğunu onaylıyorum.</span>',
            '</label>',
            '<div style="display:flex;justify-content:space-between;align-items:center;gap:12px">',
              '<button class="iz-bld__btn iz-bld__btn--ghost" id="iz-bld-final-back">← Tekrar Düzenle</button>',
              '<button class="iz-bld__btn iz-bld__btn--green" id="iz-bld-cart" disabled>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
                'Tasarımı Onayla &amp; Sipariş Ver',
              '</button>',
            '</div>',
          '</div>',
        '</div>',

      '</div>' /* panel */
    ].join('');
  }

  /* ─────────────────────────────────────────────── */
  /*  Build & mount modal                             */
  /* ─────────────────────────────────────────────── */
  function buildModal() {
    modalEl = document.createElement('div');
    modalEl.className = 'iz-bld iz-bld--hidden';
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.innerHTML = getModalHTML();
    document.body.appendChild(modalEl);

    /* Cache refs */
    phaseEls.upload  = q('#iz-bld-phase-upload',  modalEl);
    phaseEls.grid    = q('#iz-bld-phase-grid',    modalEl);
    phaseEls.group   = q('#iz-bld-phase-group',   modalEl);
    phaseEls.editor  = q('#iz-bld-phase-editor',  modalEl);
    phaseEls.final   = q('#iz-bld-phase-final',   modalEl);

    dropZone      = q('#iz-bld-dropzone',    modalEl);
    thumbsRow     = q('#iz-bld-thumbs',      modalEl);
    filePickerInput = q('#iz-bld-file-input',  modalEl);
    var uxAddMore = q('#iz-bld-add-more', modalEl);
    if (uxAddMore) uxAddMore.addEventListener('click', function () {
      if (!_pendingFileCount && !_pendingReplacement) filePickerInput.click();
    });
    progressEl    = q('#iz-bld-progress',    modalEl);
    gridEl        = q('#iz-bld-grid',        modalEl);
    editorCounter = q('#iz-bld-editor-counter', modalEl);
    photoFrame    = q('#iz-bld-photo-frame', modalEl);
    photoImg      = q('#iz-bld-photo-img',   modalEl);
    captionInput   = q('#iz-bld-caption',          modalEl);
    fontSelect     = q('#iz-bld-font',             modalEl);
    fontListEl     = q('#iz-bld-font-list',        modalEl);
    fontBtnLabelEl = q('#iz-bld-font-btn-label',   modalEl);
    captionPreview = q('#iz-bld-cap-preview',      modalEl);
    finalGridEl    = q('#iz-bld-final-grid',       modalEl);
    stickerToggleBtn   = q('#iz-bld-sticker-toggle',   modalEl);
    stickerCountEl     = q('#iz-bld-sticker-count',    modalEl);
    stickerPanelEl     = q('#iz-bld-sticker-panel',    modalEl);
    stickerTabsEl      = q('#iz-bld-sticker-tabs',     modalEl);
    stickerGridEl      = q('#iz-bld-sticker-grid',     modalEl);
    stickerBackdropEl  = q('#iz-bld-sticker-backdrop', modalEl);
    stickerCloseBtn    = q('#iz-bld-sticker-close',    modalEl);
    stickerZoomEl      = q('#iz-bld-sticker-zoom',       modalEl);
    stickerZoomRangeEl = q('#iz-bld-sticker-zoom-range', modalEl);
    stickerZoomDelBtn  = q('#iz-bld-sticker-zoom-del',   modalEl);
    if (stickerBackdropEl) stickerBackdropEl.addEventListener('click', closeStickerPanel);
    if (stickerCloseBtn)   stickerCloseBtn.addEventListener('click', closeStickerPanel);
    if (stickerZoomRangeEl) stickerZoomRangeEl.addEventListener('input', onStickerZoomInput);
    if (stickerZoomDelBtn)  stickerZoomDelBtn.addEventListener('click', deleteSelectedSticker);
    if (stickerTabsEl) {
      /* Mobilde parmakla yatay kaydirma zaten dogal calisiyor; masaustunde
         ise dokunmatik olmayan bir fare tekerlegi bu kutuyu HIC hareket
         ettirmiyordu (tekerlek varsayilan olarak DIKEY kaydirir) — kategoriler
         PC'de "sikismis" gorunuyordu. Dikey tekerlek hareketini yataya
         ceviriyoruz (trackpad'in kendi native yatay hareketini ezmemek icin
         sadece dikey delta baskinken). */
      stickerTabsEl.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          stickerTabsEl.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });
    }
    q('#iz-bld-max-label', modalEl).textContent = MAX_SLOTS;

    /* Navigation buttons */
    q('#iz-bld-backdrop', modalEl).addEventListener('click', closeModal);
    q('#iz-bld-close',    modalEl).addEventListener('click', closeModal);
    q('#iz-bld-back',     modalEl).addEventListener('click', handleBackBtn);
    q('#iz-bld-to-grid',  modalEl).addEventListener('click', function() {
      if (_pendingFileCount || _pendingReplacement) return;
      ensureGroupSlotsArray();
      /* Askin Kalbi'nin buyuk-sablon deneyiminde tek bir "kagit" oldugu icin
         (grup boyutu = MAX_SLOTS) ayri bir kagit-listesi ekrani gostermeye
         gerek yok — dogrudan buyuk sablona geciyoruz. */
      if (usesBigCanvasPicker() && isGroupedFlow()) {
        openGroupOverview(0);
        return;
      }
      buildGrid();
      showPhase('grid');
    });
    q('#iz-bld-grid-back',modalEl).addEventListener('click', function() { showPhase('upload'); });
    q('#iz-bld-to-final', modalEl).addEventListener('click', function() { renderFinal(); showPhase('final'); });
    q('#iz-bld-editor-back', modalEl).addEventListener('click', function() { saveCurrentSlot(); showPhase('grid'); });
    q('#iz-bld-editor-next', modalEl).addEventListener('click', editorGoNext);
    q('#iz-bld-confirm-edit', modalEl).addEventListener('click', confirmEdit);
    q('#iz-bld-final-back', modalEl).addEventListener('click', function() {
      if (usesBigCanvasPicker() && isGroupedFlow()) { openGroupOverview(0); return; }
      showPhase('grid');
    });
    q('#iz-bld-cart',     modalEl).addEventListener('click', submitCart);
    var poolPickerCloseBtn = q('#iz-bld-pool-picker-close', modalEl);
    if (poolPickerCloseBtn) poolPickerCloseBtn.addEventListener('click', closePoolPicker);

    /* Telif hakki onay kutusu isaretlenmeden "Sepete Ekle" pasif kalir —
       tum urunlerde (mevcut/gelecek) ayni davranis. */
    var copyrightChk = q('#iz-bld-copyright-ok', modalEl);
    if (copyrightChk) {
      copyrightChk.addEventListener('change', function () {
        var cartBtn = q('#iz-bld-cart', modalEl);
        if (cartBtn) cartBtn.disabled = !copyrightChk.checked;
      });
    }

    /* Grup (kagit) genel gorunumu — sadece coklu sabit foto alanli sablonlar */
    var groupBackBtn = q('#iz-bld-group-back', modalEl);
    if (groupBackBtn) groupBackBtn.addEventListener('click', function () {
      showPhase((usesBigCanvasPicker() && isGroupedFlow()) ? 'upload' : 'grid');
    });
    var groupConfirmBtn = q('#iz-bld-group-confirm', modalEl);
    if (groupConfirmBtn) groupConfirmBtn.addEventListener('click', confirmGroup);
    setupGroupCanvasInteraction();

    /* Spotify alanı — sadece muzik-tablosu */
    if (hasSpotify) {
      var _spSec = q('#iz-bld-spotify-section', modalEl);
      if (_spSec) _spSec.style.display = '';

      /* İsim alanı — zorunlu */
      var _nameInp   = q('#iz-bld-poster-name', modalEl);
      var _noNameChk = q('#iz-bld-no-name', modalEl);
      if (_nameInp) {
        _nameInp.addEventListener('input', function () {
          posterName = this.value.trim();
          updatePreviewName();
          validateUploadPhase();
        });
        _nameInp.addEventListener('blur', function () {
          if (this.value.trim()) {
            posterName = formatPosterName(this.value.trim());
            this.value = posterName;
            updatePreviewName();
          }
        });
      }
      if (_noNameChk) {
        _noNameChk.addEventListener('change', function () {
          if (_nameInp) _nameInp.disabled = this.checked;
          if (this.checked) { posterName = ''; updatePreviewName(); }
          validateUploadPhase();
        });
      }

      /* Spotify linki */
      var _spInp = q('#iz-bld-spotify-url', modalEl);
      if (_spInp) _spInp.addEventListener('input', function () { handleSpotifyInput(this.value.trim()); });

      /* Şarkı / Sanatçı manuel düzenleme */
      var _titleInp  = q('#iz-bld-song-title',  modalEl);
      var _artistInp = q('#iz-bld-artist-name', modalEl);
      if (_titleInp)  _titleInp.addEventListener('input',  function () { spotifyTitle  = this.value.trim(); updatePreviewText(); });
      if (_artistInp) _artistInp.addEventListener('input', function () { spotifyArtist = this.value.trim(); updatePreviewText(); });

      /* Arka plan seçici */
      ['iz-bg-photo','iz-bg-album','iz-bg-g1','iz-bg-g2','iz-bg-g3'].forEach(function (id) {
        var btn = q('#' + id, modalEl);
        if (!btn) return;
        btn.addEventListener('click', function () {
          bgChoice = this.getAttribute('data-bg');
          ['iz-bg-photo','iz-bg-album','iz-bg-g1','iz-bg-g2','iz-bg-g3'].forEach(function (bid) {
            var b = q('#' + bid, modalEl);
            if (b) b.style.border = '2px solid transparent';
          });
        this.style.border = '2px solid #1ED760';
          var bgErr = q('#iz-bg-err', modalEl);
          if (bgErr) bgErr.style.display = 'none';
          validateUploadPhase();
          /* Ön izlemeyi yenile (final fazındaysa) */
          var pvWrap = q('#iz-bld-poster-preview-wrap', modalEl);
          if (pvWrap && pvWrap.style.display !== 'none') renderMuzikPreview();
        });
      });
    }

    /* Google Arama Poster — arama cumlesi + isim, upload fazinda BIR KEZ
       sorulur (5 farkli fotografin her birinde tekrarlamak yerine). */
    if (productType === 'google-arama-poster-tablo') {
      var _googleSec = q('#iz-bld-google-section', modalEl);
      if (_googleSec) _googleSec.style.display = '';
      var _gAramaInp = q('#iz-bld-google-arama', modalEl);
      var _gIsimInp  = q('#iz-bld-google-isim',  modalEl);
      if (_gAramaInp) _gAramaInp.addEventListener('input', function () { googleArama = this.value.trim(); validateUploadPhase(); });
      if (_gIsimInp)  _gIsimInp.addEventListener('input',  function () { googleIsim  = this.value.trim(); validateUploadPhase(); });
    }

    /* Ani Gazetesi Poster — 7 sabit metin alani, upload fazinda BIR KEZ sorulur. */
    if (productType === 'ani-gazetesi-poster-tablo') {
      var _gazeteSec = q('#iz-bld-gazete-section', modalEl);
      if (_gazeteSec) _gazeteSec.style.display = '';
      [
        ['tarih', 'iz-bld-gazete-tarih'],
        ['sehir', 'iz-bld-gazete-sehir'],
        ['baslik', 'iz-bld-gazete-baslik'],
        ['paragraf1_baslik', 'iz-bld-gazete-paragraf1_baslik'],
        ['paragraf1', 'iz-bld-gazete-paragraf1'],
        ['paragraf2_baslik', 'iz-bld-gazete-paragraf2_baslik'],
        ['paragraf2', 'iz-bld-gazete-paragraf2'],
      ].forEach(function (pair) {
        var field = pair[0], id = pair[1];
        var el = q('#' + id, modalEl);
        if (!el) return;
        var countEl = q('#' + id + '-count', modalEl);
        el.addEventListener('input', function () {
          gazeteFields[field] = this.value.trim();
          if (countEl) countEl.textContent = this.value.length + '/' + this.getAttribute('maxlength');
          validateUploadPhase();
        });
      });
    }

    /* Ani Takvimi Poster (Kalbimdeki Anılar) — ay/yil/gun/spotify, upload
       fazinda BIR KEZ sorulur. Ay/yil/gun degisince takvim onizlemesi de
       (acikken) yenilenir. */
    if (productType === 'kalbimdeki-anilar-sarkili-takvim-tablosu') {
      var _takvimSec = q('#iz-bld-takvim-section', modalEl);
      if (_takvimSec) _takvimSec.style.display = '';
      [
        ['ay', 'iz-bld-takvim-ay', 'change'],
        ['yil', 'iz-bld-takvim-yil', 'input'],
        ['gun', 'iz-bld-takvim-gun', 'change'],
        ['spotify', 'iz-bld-takvim-spotify', 'input'],
      ].forEach(function (triple) {
        var field = triple[0], id = triple[1], evt = triple[2];
        var el = q('#' + id, modalEl);
        if (!el) return;
        el.addEventListener(evt, function () {
          takvimFields[field] = this.value.trim();
          validateUploadPhase();
          renderPosterEditorCanvas();
        });
      });
    }

    /* Askin Kalbi Poster — iki isim/alt yazi/spotify, upload fazinda BIR
       KEZ sorulur. İsim degisince yay uzerindeki onizleme de (acikken)
       yenilenir. */
    if (productType === 'askin-kalbi-i̇simli-ve-sarkili-poster-tablo') {
      var _kalpSec = q('#iz-bld-kalp-section', modalEl);
      if (_kalpSec) _kalpSec.style.display = '';
      [
        ['isim1', 'iz-bld-kalp-isim1'],
        ['isim2', 'iz-bld-kalp-isim2'],
        ['alt_yazi', 'iz-bld-kalp-alt_yazi'],
        ['spotify', 'iz-bld-kalp-spotify'],
      ].forEach(function (pair) {
        var field = pair[0], id = pair[1];
        var el = q('#' + id, modalEl);
        if (!el) return;
        var countEl = q('#' + id + '-count', modalEl);
        el.addEventListener('input', function () {
          kalpFields[field] = this.value.trim();
          if (countEl) countEl.textContent = this.value.length + '/' + this.getAttribute('maxlength');
          validateUploadPhase();
          renderPosterEditorCanvas();
        });
      });
    }

    /* Upload zone */
    setupDropZone();

    /* Caption live update */
    captionInput.addEventListener('input', updateCaptionPreview);

    /* Font picker */
    buildFontPicker();
    document.addEventListener('click', function (e) {
      var picker = q('#iz-bld-font-picker', modalEl);
      if (picker && !picker.contains(e.target)) closeFontPicker();
    });

    /* Keyboard close */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modalEl.classList.contains('iz-bld--hidden')) {
        if (fontListEl && !fontListEl.hidden) { closeFontPicker(); return; }
        closeModal();
      }
    });

    /* Pan on photo */
    setupPhotoPan();

    /* Backend'de gercek sablonu olan TUM urunler (netflix-poster-tablo,
       ani-kutusu, palo-kart, foto-kart...) jenerik CSS polaroid mockup'i
       yerine gercek sablonu (arkaplan+onkat+foto+varsa yazi) canli gosteren
       bir canvas kullanir — boylece duzenleme ekraninda gordugu ile
       basilacak tasarim birebir ayni olur. */
    if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1) {
      var polaroidWrap = q('#iz-bld-polaroid-wrap', modalEl);
      var posterCanvasWrap = q('#iz-bld-poster-canvas-wrap', modalEl);
      if (polaroidWrap) polaroidWrap.style.display = 'none';
      if (posterCanvasWrap) posterCanvasWrap.style.display = '';
      setupPosterPhotoPan();
      setupStickerInteraction();
      if (stickerToggleBtn) stickerToggleBtn.addEventListener('click', toggleStickerPanel);

      if (productType === 'netflix-poster-tablo') {
        /* isim/baslik/hikaye/tur alanlari — not/font kutusu yerine gosterilir */
        var posterWrap  = q('#iz-bld-poster-fields', modalEl);
        var capFontWrap = q('#iz-bld-caption-font-fields', modalEl);
        if (capFontWrap) capFontWrap.style.display = 'none';
        if (posterWrap)  posterWrap.style.display  = '';

        ['iz-bld-poster-isim', 'iz-bld-poster-baslik', 'iz-bld-poster-hikaye', 'iz-bld-poster-tur'].forEach(function (id) {
          var el = q('#' + id, modalEl);
          var countEl = q('#' + id + '-count', modalEl);
          if (!el) return;
          var updateCount = function () {
            if (countEl) countEl.textContent = el.value.length + '/' + el.getAttribute('maxlength');
          };
          el.addEventListener('input', renderPosterEditorCanvas);
          el.addEventListener('input', updateCount);
          updateCount();
        });
        /* Hikaye kutusu yazdikca otomatik buyusun (sabit 4 satirda kalip
           metnin gorsel olarak "tasiyormus" gibi hissettirmemesi icin) */
        var hikayeEl = q('#iz-bld-poster-hikaye', modalEl);
        if (hikayeEl) {
          var autoGrow = function () {
            hikayeEl.style.height = 'auto';
            hikayeEl.style.height = Math.min(hikayeEl.scrollHeight, 260) + 'px';
          };
          hikayeEl.addEventListener('input', autoGrow);
          autoGrow();
        }
      } else if (NO_CAPTION_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1) {
        /* Bu sablonlarda hic caption_area/text_areas yok — not/font alanini
           gostermek musteriye yaziginin bir yere basilacagini dusundurur ama
           hicbir zaman basilmaz, bu yuzden tamamen gizliyoruz. */
        var capFontWrapNoCaption = q('#iz-bld-caption-font-fields', modalEl);
        if (capFontWrapNoCaption) capFontWrapNoCaption.style.display = 'none';
      } else {
        /* ani-kutusu/palo-kart gibi tek satir not (caption_area) kullanan
           urunlerde not/font alani goruntude kalir, ama artik yazdikca ve
           font degistirdikce canli canvas'ta da GERCEK yerinde/fontla
           goruntulenir (eskiden jenerik bir polaroid mockup'inin altinda
           duz metin olarak gosteriliyordu, gercek tasarimla alakasizdi). */
        if (captionInput) captionInput.addEventListener('input', renderPosterEditorCanvas);
      }
    }
  }

  /* ─────────────────────────────────────────────── */
  /*  Coklu sabit foto alanli sablonlar (grup) yardimcilari  */
  /* ─────────────────────────────────────────────── */
  function currentGroupSize() {
    return GROUP_SIZE_BY_TEMPLATE[photoTemplateId] || 1;
  }
  function isGroupedFlow() {
    return currentGroupSize() > 1;
  }
  function currentUploadPool() {
    return isGroupedFlow() ? uploadPool : slots;
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase management                                */
  /* ─────────────────────────────────────────────── */
  function showPhase(name) {
    Object.keys(phaseEls).forEach(function (k) {
      phaseEls[k].style.display = k === name ? 'flex' : 'none';
    });
    var titles = {
      upload: 'Fotoğraf Yükle',
      grid:   isGroupedFlow() ? 'Kağıtları Düzenle' : 'Tasarımları Düzenle',
      group:  'Kağıdı Düzenle',
      editor: 'Fotoğrafı Konumlandır',
      final:  'Son Önizleme'
    };
    var titleEl = q('#iz-bld-title', modalEl);
    if (titleEl) titleEl.textContent = titles[name] || 'Tasarım';

    var backBtn = q('#iz-bld-back', modalEl);
    if (backBtn) backBtn.style.visibility = name === 'upload' ? 'hidden' : 'visible';
  }

  function handleBackBtn() {
    var current = Object.keys(phaseEls).find(function (k) {
      return phaseEls[k].style.display !== 'none';
    });
    if (current === 'editor') { saveCurrentSlot(); showPhase('grid'); return; }
    if (current === 'group')  { showPhase((usesBigCanvasPicker() && isGroupedFlow()) ? 'upload' : 'grid'); return; }
    if (current === 'final' && usesBigCanvasPicker() && isGroupedFlow()) { openGroupOverview(0); return; }
    var order = ['upload', 'grid', 'final'];
    var idx = order.indexOf(current);
    if (idx > 0) showPhase(order[idx - 1]);
  }

  /* ─────────────────────────────────────────────── */
  /*  Modal open / close                              */
  /* ─────────────────────────────────────────────── */
  function openModal() {
    if (cartSubmissionPending) return;
    resetOnPageRestore = false;
    /* Gruplu urunlerde (5x20 vb.) Adet varyanti degisip atama oturumu
       sifirlandiysa (slots bos, ama uploadPool dolu kalabilir) yine de
       upload fazina donduruyoruz — yoksa musteri bos bir grid/kagit
       ekraniyla karsilasir. */
    var groupedSessionReset = isGroupedFlow() && slots.length === 0 && uploadPool.length > 0;
    if (currentUploadPool().length === 0 || groupedSessionReset) {
      showPhase('upload');
    }
    modalEl.classList.remove('iz-bld--hidden');
    document.body.style.overflow = 'hidden';
    /* Preload jsPDF in background so it's ready when customer finishes designing */
    loadJsPDF().catch(function () {});
  }

  function closeModal() {
    modalEl.classList.add('iz-bld--hidden');
    document.body.style.overflow = '';
  }

  function handleSpotifyInput(url) {
    var match = url.match(/track\/([A-Za-z0-9]+)/);
    var artRow = q('#iz-bld-sp-art-row', modalEl);
    if (!match) {
      spotifyTrackId = ''; spotifyAlbumArt = '';
      if (artRow) artRow.style.display = 'none';
      return;
    }
    var trackId = match[1];
    if (trackId === spotifyTrackId) return;
    spotifyTrackId = trackId;

    var spotifyGeneration = draftGeneration;
    fetch('https://open.spotify.com/oembed?url=https://open.spotify.com/track/' + trackId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (spotifyGeneration !== draftGeneration || trackId !== spotifyTrackId) return;
        spotifyAlbumArt = data.thumbnail_url || '';
        var artImg   = q('#iz-bld-sp-art-img',   modalEl);
        var artTitle = q('#iz-bld-sp-art-title',  modalEl);
        if (artImg && spotifyAlbumArt) artImg.src = spotifyAlbumArt;
        if (artTitle) artTitle.textContent = data.title || '';
        if (artRow)   artRow.style.display = 'flex';

        /* Auto-fill title / artist from oEmbed */
        var song   = data.title || '';
        var artist = data.author_name || '';
        var titleInp  = q('#iz-bld-song-title',  modalEl);
        var artistInp = q('#iz-bld-artist-name', modalEl);
        if (titleInp  && !titleInp.value.trim())  { titleInp.value  = song;   spotifyTitle  = song; }
        if (artistInp && !artistInp.value.trim()) { artistInp.value = artist; spotifyArtist = artist; }
        updatePreviewText();
      })
      .catch(function () { if (artRow) artRow.style.display = 'none'; });
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase 1: Upload                                 */
  /* Bir foto slota eklenir eklenmez (musteri henuz kirpma/yazi ile
     ugrasirken) arka planda backend'e yuklemeye baslar. Sonuc slot uzerinde
     saklanir; sepete ekleme aninda (buildBackendPropsAndUpload) bu is zaten
     bitmisse tekrar yuklenmez, sadece sonucu kullanilir. Boylece 30-60+
     fotoluk siparislerde yukleme suresi, musterinin duzenleme ekraninda
     gecirdigi sureyle ORTUSUR — hepsi en sonda tek seferde patlamaz. */
  /* Arka plan yuklemeleri de (sepete ekleme anindaki gibi) UPLOAD_CONCURRENCY
     ile sinirli bir kuyruktan gecer. Ilk versiyon her fotoyu eklendigi an
     dogrudan (sinirsiz) yukluyordu — musteri 64 fotoyu TEK SEFERDE secince
     hepsi ayni anda istek atip hem sunucuyu zorluyor hem hiz sinirini
     asiyordu. */
  var _bgUploadQueue = [];
  var _bgUploadActive = 0;

  function _startBackgroundUpload(slot, idx) {
    if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) === -1 || !photoApiBase) return;
    slot._uploadPromise = new Promise(function (resolve, reject) {
      slot._uploadResolve = resolve;
      slot._uploadReject = reject;
    });
    _bgUploadQueue.push({ slot: slot, idx: idx });
    _pumpBgUploadQueue();
  }

  /* Islem basina ayri lexical kapsam: eszamanli isteklerin sonuclari
     baska fotografin promise/lowRes alanina yazilamaz. */
  function _runBackgroundUploadItem(item) {
    var slot = item.slot;
    _bgUploadActive++;
    loadBackendSlotDims()
      .then(function () {
        var dims = getSlotDimsAt(item.idx, slot);
        return uploadPhotoWithRetry(dataUrlToBlob(slot.dataUrl), dims.width, dims.height, slot.naturalW, slot.naturalH);
      })
      .then(function (res) {
        slot.lowRes = !!res.low_resolution;
        slot._uploadResolve(res);
      })
      .catch(function (err) {
        console.error('[İz Builder] Arka plan yükleme hatası:', err);
        slot._uploadReject(err);
      })
      .then(function () {
        _bgUploadActive--;
        _pumpBgUploadQueue();
      });
  }

  function _pumpBgUploadQueue() {
    while (_bgUploadActive < UPLOAD_CONCURRENCY && _bgUploadQueue.length) {
      _runBackgroundUploadItem(_bgUploadQueue.shift());
    }
  }

  /* UX V1: dosya okuma asenkron olsa da batch ve dosya secim sirasi sabit.
     Birden cok "Dosya sec" islemi ayni anda tamamlanabilir; batch kuyrugu
     onceki partinin tamamlanmasini bekleyerek sirayi korur. */
  var _fileReadBatches = [];
  var _pendingFileCount = 0;
  var _pendingReplacement = false;
  var _replaceTarget = null;
  var _uploadMessages = [];

  function _uploadMessage(message) {
    _uploadMessages.push(message);
    if (_uploadMessages.length > 4) _uploadMessages.shift();
    updateUploadStatus();
  }

  function updateUploadStatus() {
    if (!modalEl) return;
    var pool = currentUploadPool();
    var count = q('#iz-bld-upload-summary', modalEl);
    if (count) count.textContent = pool.length + ' / ' + MAX_SLOTS + ' fotoğraf seçildi';
    var uxCount = q('#iz-bld-ux-count', modalEl);
    if (uxCount) uxCount.textContent = pool.length + ' / ' + MAX_SLOTS;
    var uxBar = q('#iz-bld-ux-bar', modalEl);
    if (uxBar) uxBar.style.width = Math.round(100 * pool.length / Math.max(1, MAX_SLOTS)) + '%';
    var uxStatus = q('#iz-bld-ux-status', modalEl);
    if (uxStatus) uxStatus.textContent = _pendingFileCount ? 'Fotoğraflar hazırlanıyor…' :
      pool.length === MAX_SLOTS ? 'Fotoğrafların hazır. Sonraki adıma geçebilirsin.' :
      pool.length === 0 ? 'Fotoğraflarını ekleyerek başla.' :
      'Fotoğraflarını sıralayabilir, değiştirebilir veya yenilerini ekleyebilirsin.';
    var uxMore = q('#iz-bld-add-more', modalEl);
    if (uxMore) {
      uxMore.style.display = pool.length > 0 && pool.length < MAX_SLOTS ? 'block' : 'none';
      uxMore.disabled = !!(_pendingFileCount || _pendingReplacement);
    }
    var wrapper = q('#iz-bld-read-progress', modalEl);
    var label = q('#iz-bld-read-progress-label', modalEl);
    var bar = q('#iz-bld-read-bar', modalEl);
    var track = wrapper && wrapper.querySelector('[role="progressbar"]');
    var total = 0, completed = 0;
    _fileReadBatches.forEach(function (batch) {
      total += batch.files.length;
      completed += batch.completed;
    });
    if (_pendingReplacement) { total++; }
    if (wrapper) wrapper.style.display = total ? '' : 'none';
    if (label && total) label.textContent = 'Fotoğraflar hazırlanıyor: ' + completed + ' / ' + total;
    var progress = total ? Math.round(100 * completed / total) : 0;
    if (bar) bar.style.width = progress + '%';
    if (track) track.setAttribute('aria-valuenow', progress);
    var errors = q('#iz-bld-upload-errors', modalEl);
    if (errors) {
      errors.style.display = _uploadMessages.length ? '' : 'none';
      errors.textContent = _uploadMessages.join(' ');
    }
  }

  function readPhotoFile(file, cb) {
    if (!file || !/^(image\/jpeg|image\/png|image\/webp)$/i.test(file.type)) {
      cb(new Error('Yalnızca JPG, PNG ve WEBP fotoğrafları destekleniyor.'));
      return;
    }
    var reader = new FileReader();
    reader.onerror = function () { cb(new Error('Fotoğraf okunamadı.')); };
    reader.onload = function (e) {
      var dataUrl = e.target.result;
      loadImage(dataUrl, function (err, img) {
        if (err || !img || !img.naturalWidth || !img.naturalHeight) {
          cb(new Error('Fotoğraf açılamadı. Dosyayı kontrol edin.'));
          return;
        }
        var slot = makeSlot();
        slot.dataUrl = dataUrl;
        slot.naturalW = img.naturalWidth;
        slot.naturalH = img.naturalHeight;
        cb(null, slot);
      });
    };
    try { reader.readAsDataURL(file); }
    catch (err) { cb(new Error('Fotoğraf okunamadı.')); }
  }

  function addPreviewToSlot(slot) {
    /* Baskida her zaman orijinal tam cozunurluklu dataUrl kullanilir. */
    makePreviewDataUrl(slot.dataUrl, 480, function (previewUrl) {
      slot.previewDataUrl = previewUrl || slot.dataUrl;
      /* Gruplu akista onceden atanmis fotografin onizleme kopyasini da
         guncelle; baskiya giden orijinal dataUrl'ye dokunma. */
      if (isGroupedFlow()) {
        slots.forEach(function (assigned) {
          if (assigned && assigned.dataUrl === slot.dataUrl) assigned.previewDataUrl = slot.previewDataUrl;
        });
      }
      if (phaseEls.upload && phaseEls.upload.style.display !== 'none') renderUploadThumbs();
      if (phaseEls.group && phaseEls.group.style.display !== 'none') renderGroupPool();
    });
  }

  function _flushFileBatches() {
    while (_fileReadBatches.length && _fileReadBatches[0].completed === _fileReadBatches[0].files.length) {
      var batch = _fileReadBatches.shift();
      var pool = currentUploadPool();
      batch.results.forEach(function (slot) {
        if (!slot) return;
        pool.push(slot);
        _startBackgroundUpload(slot, pool.length - 1);
        addPreviewToSlot(slot);
      });
      _pendingFileCount -= batch.files.length;
    }
    renderUploadThumbs();
    updateUploadStatus();
    validateUploadPhase();
  }

  function setupDropZone() {
    ['dragenter','dragover'].forEach(function (ev) {
      dropZone.addEventListener(ev, function (e) { e.preventDefault(); dropZone.classList.add('iz-bld__upload-zone--over'); });
    });
    ['dragleave','drop'].forEach(function (ev) {
      dropZone.addEventListener(ev, function (e) { e.preventDefault(); dropZone.classList.remove('iz-bld__upload-zone--over'); });
    });
    dropZone.addEventListener('drop', function (e) { handleFiles(e.dataTransfer.files); });
    dropZone.addEventListener('click', function () { filePickerInput.click(); });
    dropZone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); filePickerInput.click(); }
    });
    filePickerInput.addEventListener('change', function () {
      handleFiles(filePickerInput.files);
      filePickerInput.value = '';
    });
    var replaceInput = q('#iz-bld-replace-input', modalEl);
    replaceInput.addEventListener('change', function () {
      var file = replaceInput.files && replaceInput.files[0];
      var target = _replaceTarget;
      replaceInput.value = '';
      _replaceTarget = null;
      if (file && target) replacePhoto(target, file);
    });
    updateUploadStatus();
  }

  function handleFiles(fileList) {
    _syncMaxSlotsToCurrentVariant();
    var pool = currentUploadPool();
    var available = MAX_SLOTS - pool.length - _pendingFileCount;
    if (available <= 0) {
      _uploadMessage('Bu ürün için en fazla ' + MAX_SLOTS + ' fotoğraf seçebilirsiniz.');
      return;
    }
    var incoming = Array.prototype.slice.call(fileList || []);
    if (!incoming.length) return;
    var files = incoming.slice(0, available);
    if (incoming.length > available) {
      _uploadMessage('Sınır nedeniyle yalnızca ilk ' + available + ' fotoğraf işleme alındı.');
    }
    var batch = { files: files, results: new Array(files.length), completed: 0 };
    _fileReadBatches.push(batch);
    _pendingFileCount += files.length;
    renderUploadThumbs();
    validateUploadPhase();
    updateUploadStatus();
    files.forEach(function (file, index) {
      readPhotoFile(file, function (err, slot) {
        if (err) _uploadMessage('"' + (file.name || 'Dosya') + '": ' + err.message);
        batch.results[index] = slot || null;
        batch.completed++;
        _flushFileBatches();
      });
    });
  }

  function replacePhoto(target, file) {
    if (_pendingReplacement || _pendingFileCount > 0) {
      _uploadMessage('Önce devam eden fotoğraf hazırlama işlemi bitsin.');
      return;
    }
    _pendingReplacement = true;
    renderUploadThumbs();
    updateUploadStatus();
    validateUploadPhase();
    readPhotoFile(file, function (err, newSlot) {
      _pendingReplacement = false;
      var pool = currentUploadPool();
      var index = pool.indexOf(target);
      if (err) _uploadMessage('Fotoğraf değiştirilemedi: ' + err.message);
      if (!err && index !== -1) {
        /* Foto degisince eski foto/baski ID'si yeni dosyaya tasinmaz. */
        pool[index] = newSlot;
        _startBackgroundUpload(newSlot, index);
        addPreviewToSlot(newSlot);
        if (isGroupedFlow()) {
          /* Geri dönülmüş ve alan ataması yapılmışsa, eski görsele ait
             referanslar sessizce sepete gitmesin. */
          slots.forEach(function (assigned, i) {
            if (assigned && assigned.dataUrl === target.dataUrl) {
              slots[i] = Object.assign({}, assigned, {
                dataUrl: newSlot.dataUrl, naturalW: newSlot.naturalW, naturalH: newSlot.naturalH,
                previewDataUrl: null, thumbDataUrl: null, offX: 0, offY: 0,
                _uploadPromise: newSlot._uploadPromise, lowRes: undefined, done: false
              });
            }
          });
        }
      }
      renderUploadThumbs();
      updateUploadStatus();
      validateUploadPhase();
    });
  }

  function renderUploadThumbs() {
    if (!thumbsRow) return;
    thumbsRow.innerHTML = '';
    var pool = currentUploadPool();
    pool.forEach(function (slot, i) {
      var wrap = document.createElement('div');
      wrap.className = 'iz-bld__up-thumb';
      var img = document.createElement('img');
      img.src = slot.previewDataUrl || slot.dataUrl;
      // UX quality checks must measure the original, not the 480px preview.
      img.dataset.pozcaNaturalWidth = String(slot.naturalW || 0);
      img.dataset.pozcaNaturalHeight = String(slot.naturalH || 0);
      img.alt = (i + 1) + '. fotoğraf önizlemesi';
      img.loading = 'lazy';
      var badge = document.createElement('span');
      badge.className = 'iz-bld__up-number';
      badge.textContent = i + 1;
      var controls = document.createElement('div');
      controls.className = 'iz-bld__up-controls';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'iz-bld__up-action';
      prev.textContent = '←'; prev.title = 'Fotoğrafı sola taşı';
      prev.setAttribute('aria-label', (i + 1) + '. fotoğrafı sola taşı');
      prev.disabled = i === 0 || _pendingFileCount > 0 || _pendingReplacement;
      prev.addEventListener('click', function () { moveUploadPhoto(i, -1); });
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'iz-bld__up-action';
      next.textContent = '→'; next.title = 'Fotoğrafı sağa taşı';
      next.setAttribute('aria-label', (i + 1) + '. fotoğrafı sağa taşı');
      next.disabled = i === pool.length - 1 || _pendingFileCount > 0 || _pendingReplacement;
      next.addEventListener('click', function () { moveUploadPhoto(i, 1); });
      var change = document.createElement('button');
      change.type = 'button'; change.className = 'iz-bld__up-action';
      change.textContent = 'Değiştir'; change.title = 'Fotoğrafı değiştir';
      change.disabled = _pendingFileCount > 0 || _pendingReplacement;
      change.addEventListener('click', function () {
        _replaceTarget = slot;
        q('#iz-bld-replace-input', modalEl).click();
      });
      var remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'iz-bld__up-action iz-bld__up-action--remove';
      remove.textContent = 'Sil'; remove.title = 'Fotoğrafı kaldır';
      remove.disabled = _pendingFileCount > 0 || _pendingReplacement;
      remove.addEventListener('click', function () { removePhoto(i); });
      controls.appendChild(prev); controls.appendChild(next);
      controls.appendChild(change); controls.appendChild(remove);
      wrap.appendChild(img); wrap.appendChild(badge); wrap.appendChild(controls);
      thumbsRow.appendChild(wrap);
    });
  }

  function moveUploadPhoto(idx, direction) {
    if (_pendingFileCount || _pendingReplacement) return;
    var pool = currentUploadPool();
    var other = idx + direction;
    if (other < 0 || other >= pool.length) return;
    var item = pool[idx];
    pool[idx] = pool[other];
    pool[other] = item;
    renderUploadThumbs();
    validateUploadPhase();
  }

  function removePhoto(idx) {
    if (_pendingFileCount || _pendingReplacement) return;
    var pool = currentUploadPool();
    var slot = pool[idx];
    if (!slot) return;
    if (isGroupedFlow()) {
      slots.forEach(function (assigned, i) {
        if (assigned && assigned.dataUrl === slot.dataUrl) slots[i] = { dataUrl: null };
      });
    }
    pool.splice(idx, 1);
    renderUploadThumbs();
    updateUploadStatus();
    validateUploadPhase();
  }

  function duplicateSlot(idx) {
    if (slots.length >= MAX_SLOTS) return;
    var o = slots[idx];
    slots.splice(idx + 1, 0, {
      dataUrl:  o.dataUrl,
      naturalW: o.naturalW,
      naturalH: o.naturalH,
      offX:     o.offX,
      offY:     o.offY,
      caption:  o.caption,
      font:     o.font,
      done:     false
    });
    buildGrid();
  }

  function removeSlot(idx) {
    if (slots.length <= 1) return; /* keep at least one */
    slots.splice(idx, 1);
    if (editIdx >= slots.length) editIdx = slots.length - 1;
    buildGrid();
  }

  /* Düzenlenmiş (pan uygulanmış) küçük önizleme oluştur */
  function generateSlotThumb(slot, cb) {
    cb = currentDraftCallback(cb);
    if (!slot || !slot.dataUrl) { cb(null); return; }
    var W = 160, H = 200; /* 4:5 oranı — grid thumb ile aynı */
    var canvas = document.createElement('canvas');
    canvas.width = W; canvas.height = H;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#1E2A44';
    ctx.fillRect(0, 0, W, H);
    var img = new Image();
    img.onload = function () {
      var scale = Math.max(W / img.naturalWidth, H / img.naturalHeight);
      var dw = Math.round(img.naturalWidth  * scale);
      var dh = Math.round(img.naturalHeight * scale);
      /* Pan offset'i editör çerçevesinden (220×240) thumb boyutuna ölçekle */
      var ox = (slot.offX || 0) * (W / 220);
      var oy = (slot.offY || 0) * (H / 240);
      ctx.drawImage(img, Math.round(W / 2 - dw / 2 + ox), Math.round(H / 2 - dh / 2 + oy), dw, dh);
      cb(canvas.toDataURL('image/jpeg', 0.75));
    };
    img.onerror = function () { cb(null); };
    img.src = slot.dataUrl;
  }

  function formatPosterName(val) {
    if (!val) return '';
    return val.trim().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function updatePreviewName() {
    var el = q('#iz-pvw-name', modalEl);
    if (el) el.textContent = posterName || '';
  }

  /* Varyant degisimini "yakalamaya" calisan reaktif dinleyiciler (pubsub/
     DOM-observer/click-oncesi senkron okuma) uc kez denendi ve hala bazen
     kaciriliyor olabilir. Bu yuzden EN SAGLAM cozum: yukleme ekraninin
     sayaci HER CIZILDIGINDE (validateUploadPhase her cagrildiginda), hangi
     mekanizma calisip calismadigina bakmaksizin, MAX_SLOTS'u dogrudan
     sayfadaki GERCEK secili varyanttan yeniden okuyup senkronlar — ekranda
     gorunen sayi boylece HICBIR olay/zamanlamaya bagli kalmadan hep dogru
     olur. */
  function _syncMaxSlotsToCurrentVariant() {
    if (!triggerBtn || FIXED_SLOT_COUNT_PRODUCT_TYPES.indexOf(productType) !== -1) return;
    var liveInput = formEl && formEl.querySelector('[name="id"]');
    var vId = liveInput && liveInput.value;
    var mapStr = triggerBtn.getAttribute('data-slots-map');
    if (!vId || !mapStr) return;
    try {
      var map = JSON.parse(mapStr.replace(/&quot;/g, '"'));
      if (map[String(vId)] !== undefined) {
        MAX_SLOTS = parseInt(map[String(vId)]) || MAX_SLOTS;
        var lbl = q('#iz-bld-max-label', modalEl);
        if (lbl) lbl.textContent = MAX_SLOTS;
      }
    } catch (err) {}
  }

  function validateUploadPhase() {
    _syncMaxSlotsToCurrentVariant();
    var btn  = q('#iz-bld-to-grid', modalEl);
    var hint = q('#iz-bld-zone-hint', modalEl);
    var pool = currentUploadPool();
    var grouped = isGroupedFlow();
    /* Gruplu sablonlarda (5x20, google_arama_poster vb.) TAM olarak
       MAX_SLOTS foto yuklenmis olmali — cunku her alan icin secim
       yapabilmek adina musterinin yukleyecegi butun havuzun elde olmasi
       gerekiyor. Diger urunlerde en az 1 foto yeterli, geri kalani
       grid'deki "+1" ile tamamlanabilir. */
    var needsExactCount = grouped || isSingleMultiSlotFlow();
    var hasPhoto = needsExactCount ? pool.length === MAX_SLOTS : (pool.length > 0 && pool.length <= MAX_SLOTS);
    var spotifyOk = true;
    if (hasSpotify) {
      var noNameChk = q('#iz-bld-no-name', modalEl);
      var nameOk    = (posterName && posterName.trim() !== '') || (noNameChk && noNameChk.checked);
      spotifyOk = nameOk;
    }
    var googleFieldsOk = true;
    if (productType === 'google-arama-poster-tablo') {
      googleFieldsOk = !!(googleArama && googleArama.trim()) && !!(googleIsim && googleIsim.trim());
      var googleErr = q('#iz-google-err', modalEl);
      if (googleErr) googleErr.style.display = (pool.length > 0 && !googleFieldsOk) ? '' : 'none';
    }
    var gazeteFieldsOk = true;
    if (productType === 'ani-gazetesi-poster-tablo') {
      gazeteFieldsOk = Object.keys(gazeteFields).every(function (k) { return gazeteFields[k] && gazeteFields[k].trim(); });
      var gazeteErr = q('#iz-gazete-err', modalEl);
      if (gazeteErr) gazeteErr.style.display = (pool.length > 0 && !gazeteFieldsOk) ? '' : 'none';
    }
    var takvimFieldsOk = true;
    if (productType === 'kalbimdeki-anilar-sarkili-takvim-tablosu') {
      takvimFieldsOk = Object.keys(takvimFields).every(function (k) { return takvimFields[k] && takvimFields[k].trim(); });
      var takvimErr = q('#iz-takvim-err', modalEl);
      if (takvimErr) takvimErr.style.display = (pool.length > 0 && !takvimFieldsOk) ? '' : 'none';
    }
    var kalpFieldsOk = true;
    if (productType === 'askin-kalbi-i̇simli-ve-sarkili-poster-tablo') {
      kalpFieldsOk = Object.keys(kalpFields).every(function (k) { return kalpFields[k] && kalpFields[k].trim(); });
      var kalpErr = q('#iz-kalp-err', modalEl);
      if (kalpErr) kalpErr.style.display = (pool.length > 0 && !kalpFieldsOk) ? '' : 'none';
    }
    if (btn) btn.disabled = !!(_pendingFileCount || _pendingReplacement) || !(hasPhoto && spotifyOk && googleFieldsOk && gazeteFieldsOk && takvimFieldsOk && kalpFieldsOk);
    updateUploadStatus();
    if (hint) {
      var rem = MAX_SLOTS - pool.length;
      hint.style.color = '';
      hint.style.fontWeight = '';
      if (pool.length === 0) {
        hint.textContent = grouped
          ? ('Bu üründe tam olarak ' + MAX_SLOTS + ' fotoğraf yüklemeniz gerekiyor (her kağıt ' + currentGroupSize() + ' foto kullanır)')
          : needsExactCount
          ? ('Bu üründe tam olarak ' + MAX_SLOTS + ' fotoğraf yüklemeniz gerekiyor')
          : ('En fazla ' + MAX_SLOTS + ' fotoğraf · JPG, PNG, WEBP');
      } else if (pool.length > MAX_SLOTS) {
        /* Adet miktari azaltildiginda (orn. 12 -> 6) daha once yuklenen
           fazla fotograflar otomatik silinmiyor — musterinin kendisinin
           fazlaligi kaldirmasi gerekiyor, bunu acikca belirtiyoruz. */
        hint.style.color = '#C0392B';
        hint.style.fontWeight = '600';
        hint.textContent = pool.length + ' / ' + MAX_SLOTS + ' fotoğraf — ' + (pool.length - MAX_SLOTS) +
          ' fotoğraf fazla. Devam edebilmek için aşağıdan ' + (pool.length - MAX_SLOTS) + ' tanesini kaldırın.';
      } else if (pool.length >= MAX_SLOTS) {
        hint.textContent = MAX_SLOTS + ' / ' + MAX_SLOTS + ' fotoğraf ✓';
      } else {
        hint.textContent = pool.length + ' / ' + MAX_SLOTS + ' fotoğraf · ' + rem + ' daha ekleyebilirsiniz';
      }
    }
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase 2: Grid                                   */
  /* ─────────────────────────────────────────────── */
  /* slots[] dizisini gruplu sablonlarda tam MAX_SLOTS uzunlugunda tutar
     (her eleman bir "kagit" icindeki fiziksel bir foto alanini temsil eder,
     yukleme sirasini degil) — mevcut atamalar korunur, dizi buyurse/kuculurse
     bosluklar yeni bos placeholder ile doldurulur. */
  function ensureGroupSlotsArray() {
    if (!isGroupedFlow()) return;
    if (slots.length === MAX_SLOTS) return;
    var old = slots;
    slots = new Array(MAX_SLOTS);
    for (var i = 0; i < MAX_SLOTS; i++) {
      slots[i] = old[i] || { dataUrl: null };
    }
  }

  /* "Adet" varyanti degistiginde (orn. 6 -> 12) MAX_SLOTS degisir ama
     yuklenen fotograflar (uploadPool) hala gecerlidir — sadece "hangi
     fotograf hangi kagida/alana gidecek" atama oturumu (slots[]) ESKI
     sayidan kalma oldugu icin anlamsiz hale gelir (6'lik 4'lu gruplama,
     12'lik gruplamaya uymaz). Bu yuzden atama sifirlanir, musteri
     yukledigi fotograflari KAYBETMEDEN yeniden atama ekranina gececek
     sekilde upload fazina donduruluyor (fotograf sayisi da degisebilir:
     6->12 fazla foto gerekir, 12->6 fazla fotograf varsa kaldirmasi istenir). */
  /* Tarayicinin genel "bu site diyor ki..." uyarisi yerine magazanin kendi
     tasarimiyla uyumlu, ozel stilli bir onay penceresi. Senkron degil —
     musteri Evet/Hayir'a basinca onResult(true/false) cagirir. */
  function showBrandedConfirm(message, onResult) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:100002;background:rgba(30,42,68,0.55);display:flex;align-items:center;justify-content:center;padding:20px';

    var box = document.createElement('div');
    box.style.cssText = 'background:var(--iz-paper,#FAF6EF);border-radius:14px;max-width:380px;width:100%;padding:24px 22px;box-shadow:0 20px 60px rgba(0,0,0,0.35);text-align:center;font-family:inherit';

    var title = document.createElement('div');
    title.style.cssText = 'font-size:15px;font-weight:700;color:var(--iz-ink,#1E2A44);margin-bottom:10px';
    title.textContent = 'Önceki düzenlemeleriniz korunsun mu?';
    box.appendChild(title);

    var msg = document.createElement('div');
    msg.style.cssText = 'font-size:13px;color:var(--iz-ink-2,#46506A);line-height:1.55;white-space:pre-line;margin-bottom:20px';
    msg.textContent = message;
    box.appendChild(msg);

    var btnRow = document.createElement('div');
    btnRow.style.cssText = 'display:flex;gap:10px';

    var noBtn = document.createElement('button');
    noBtn.type = 'button';
    noBtn.className = 'iz-bld__btn iz-bld__btn--ghost';
    noBtn.style.cssText = 'flex:1';
    noBtn.textContent = 'Hayır, baştan başla';

    var yesBtn = document.createElement('button');
    yesBtn.type = 'button';
    yesBtn.className = 'iz-bld__btn iz-bld__btn--primary';
    yesBtn.style.cssText = 'flex:1';
    yesBtn.textContent = 'Evet, koru';

    btnRow.appendChild(noBtn);
    btnRow.appendChild(yesBtn);
    box.appendChild(btnRow);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    function cleanup(result) {
      overlay.remove();
      onResult(result);
    }
    noBtn.addEventListener('click', function () { cleanup(false); });
    yesBtn.addEventListener('click', function () { cleanup(true); });
  }

  function resetGroupedAssignmentSession(onDone) {
    /* Musteri bazi kagitlari zaten duzenleyip onaylamissa (orn. 6'lik
       oturumda 3 kagit onaylandi), Adet degisince bunlari sessizce silmek
       yerine sorup ona gore davraniyoruz. */
    var hadConfirmedWork = slots.some(function (s) { return s && s.done; });

    function proceed(keepAssignments) {
      if (keepAssignments) {
        var old = slots;
        slots = new Array(MAX_SLOTS);
        for (var i = 0; i < MAX_SLOTS; i++) slots[i] = old[i] || { dataUrl: null };
      } else {
        slots = [];
      }
      activeGroupIdx = -1;
      activeSlotInGroup = -1;

      /* Musteri "Evet, koru" veya "Hayır, baştan başla" hangisini secerse
         secsin, HER IKI durumda da upload fazina donulur — Adet degistiyse
         musterinin fotograf havuzunu yeni sayiya tamamlamasi gerekebilir.
         Modal o an gorunur olsun ya da olmasin fazi burada kesinlestiriyoruz
         (modal daha sonra acilirsa zaten bu fazi gosterecek). */
      renderUploadThumbs();
      validateUploadPhase();
      showPhase('upload');
      if (onDone) onDone();
    }

    if (hadConfirmedWork) {
      showBrandedConfirm(
        'Fotoğraf adedini değiştirdiniz. Daha önce düzenleyip onayladığınız ' +
        'kağıtları korursanız sadece eksik fotoğraf/kağıtları tamamlarsınız — ' +
        'baştan başlarsanız yüklediğiniz fotoğraflar yine de silinmez.',
        proceed
      );
    } else {
      proceed(false);
    }
  }

  function buildGrid() {
    gridEl.innerHTML = '';
    if (isGroupedFlow()) { buildGroupGrid(); return; }
    var atMax = slots.length >= MAX_SLOTS;
    slots.forEach(function (slot, i) {
      var item = document.createElement('div');
      item.className = 'iz-bld__grid-item' + (slot.done ? ' iz-bld__grid-item--done' : '');
      item.innerHTML = [
        '<div class="iz-bld__grid-thumb">',
          '<img src="' + (slot.done && slot.thumbDataUrl ? slot.thumbDataUrl : slot.dataUrl) + '" alt="">',
          '<span class="iz-bld__grid-num">' + (i + 1) + '</span>',
          '<button class="iz-bld__grid-remove" data-remove="' + i + '" title="Bu tasarımı kaldır" aria-label="Kaldır">×</button>',
        '</div>',
        '<span class="iz-bld__grid-badge' + (slot.done ? ' iz-bld__grid-badge--done' : '') + '">',
          slot.done ? '✓ Onaylandı' : 'Düzenlenmedi',
        '</span>',
        '<div class="iz-bld__grid-caption"></div>',
        '<div class="iz-bld__grid-actions">',
          '<button class="iz-bld__btn iz-bld__btn--sm" data-edit="' + i + '">Düzenle</button>',
          '<button class="iz-bld__btn iz-bld__btn--sm iz-bld__btn--ghost" data-dup="' + i + '"' + (atMax ? ' disabled title="' + MAX_SLOTS + ' limitine ulaşıldı"' : '') + '>+1</button>',
        '</div>',
      ].join('');
      item.querySelector('.iz-bld__grid-caption').textContent = slot.caption || '\u00a0';
      item.querySelector('[data-edit]').addEventListener('click', function () {
        openEditor(parseInt(this.getAttribute('data-edit')));
      });
      var dupBtn = item.querySelector('[data-dup]');
      if (dupBtn) dupBtn.addEventListener('click', function () {
        duplicateSlot(parseInt(this.getAttribute('data-dup')));
      });
      var removeBtn = item.querySelector('[data-remove]');
      if (removeBtn) removeBtn.addEventListener('click', function () {
        removeSlot(parseInt(this.getAttribute('data-remove')));
      });
      gridEl.appendChild(item);
    });
    updateGridProgress();
  }

  /* Gruplu sablonlarda (5x20 vb.) grid, tek tek fotograflari degil "kagit"
     (grup) kartlarini gosterir — her kagit kendi 4 foto alanini musterinin
     kendisinin secip yerlestirdigi ayri bir ekranda (group-overview) doldurulur. */
  function buildGroupGrid() {
    var gs = currentGroupSize();
    var groupCount = Math.ceil(MAX_SLOTS / gs);
    for (var g = 0; g < groupCount; g++) {
      (function (g) {
        var groupSlots = slots.slice(g * gs, g * gs + gs);
        var filledCount = groupSlots.filter(function (s) { return s && s.dataUrl; }).length;
        var done = groupSlots.length === gs && groupSlots.every(function (s) { return s && s.done; });

        var item = document.createElement('div');
        item.className = 'iz-bld__grid-item' + (done ? ' iz-bld__grid-item--done' : '');
        item.innerHTML = [
          '<div class="iz-bld__grid-thumb iz-bld__grid-thumb--grouped">',
            '<canvas data-group-thumb="' + g + '"></canvas>',
            '<span class="iz-bld__grid-num">' + (g + 1) + '</span>',
          '</div>',
          '<span class="iz-bld__grid-badge' + (done ? ' iz-bld__grid-badge--done' : '') + '">',
            done ? '✓ Onaylandı' : (filledCount + ' / ' + gs + ' foto yerleşti'),
          '</span>',
          '<div class="iz-bld__grid-actions">',
            '<button class="iz-bld__btn iz-bld__btn--sm" data-edit-group="' + g + '">Düzenle</button>',
          '</div>',
        ].join('');
        item.querySelector('[data-edit-group]').addEventListener('click', function () {
          openGroupOverview(g);
        });
        gridEl.appendChild(item);
      })(g);
    }
    updateGridProgress();

    /* Kart onizlemesi, musterinin yerlestirdigi HAM fotografi degil —
       gercek konumlandirma/kirpma uygulanmis gercek tasarimi gostersin diye
       her karonun kucuk canvas'ini gercek sablonla cizer (eskiden ham
       fotograf CSS object-fit:cover ile rastgele kirpiliyor, konumlandirma
       tamamen goz ardi ediliyordu — "duzenledikten sonra bile garip
       goruntuler" sikayetinin sebebi buydu). */
    loadPosterTemplateAssets(function (tmpl) {
      var thumbW = 200;
      var thumbH = Math.round(thumbW * tmpl.srcH / tmpl.srcW);
      gridEl.querySelectorAll('[data-group-thumb]').forEach(function (canvas) {
        var g2 = parseInt(canvas.getAttribute('data-group-thumb'), 10);
        var groupSlots2 = slots.slice(g2 * gs, g2 * gs + gs);
        drawGroupedCanvasFrame(canvas, tmpl, groupSlots2, thumbW, thumbH, -1, true);
      });
    });
  }

  function updateGridProgress() {
    if (isGroupedFlow()) { updateGroupedGridProgress(); return; }
    var done   = slots.filter(function (s) { return s.done; }).length;
    var total  = slots.length;
    var needed = MAX_SLOTS;
    var allDone    = done === total && total > 0;
    var rightCount = total === needed;

    if (progressEl) {
      var msg = done + ' / ' + total + ' onaylandı · Tasarım: ' + total + ' / ' + needed;
      progressEl.textContent = msg;
    }

    var toFinalBtn = q('#iz-bld-to-final', modalEl);
    if (toFinalBtn) {
      var canGo = strictCount ? (allDone && rightCount) : (allDone && total > 0);
      toFinalBtn.disabled = !canGo;

      if (!allDone) {
        toFinalBtn.textContent = 'Tüm tasarımları onaylayın';
      } else if (strictCount && !rightCount) {
        toFinalBtn.textContent = (needed > total ? (needed - total) + ' tasarım daha ekleyin' : 'Ön İzlemeye Geç →');
      } else {
        toFinalBtn.textContent = 'Ön İzlemeye Geç →';
      }
    }
  }

  function updateGroupedGridProgress() {
    var gs = currentGroupSize();
    var groupCount = Math.ceil(MAX_SLOTS / gs);
    var doneGroups = 0;
    for (var g = 0; g < groupCount; g++) {
      var allDoneInGroup = true;
      for (var i = g * gs; i < g * gs + gs; i++) {
        if (!slots[i] || !slots[i].done) { allDoneInGroup = false; break; }
      }
      if (allDoneInGroup) doneGroups++;
    }
    if (progressEl) progressEl.textContent = doneGroups + ' / ' + groupCount + ' kağıt onaylandı';

    var toFinalBtn = q('#iz-bld-to-final', modalEl);
    if (toFinalBtn) {
      var allDone = doneGroups === groupCount;
      toFinalBtn.disabled = !allDone;
      toFinalBtn.textContent = allDone
        ? 'Ön İzlemeye Geç →'
        : (groupCount - doneGroups) + ' kağıt daha düzenleyin';
    }
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase 2b: Grup (kagit) genel gorunumu — tek ekran, sag sabit kart +   */
  /*  sol foto havuzu, ayri bir faz/overlay'e gecmeden hizli atama+konumlandirma */
  /* ─────────────────────────────────────────────── */
  function openGroupOverview(groupIdx) {
    activeGroupIdx = groupIdx;
    activeSlotInGroup = -1;
    var gs = currentGroupSize();
    var groupCount = Math.ceil(MAX_SLOTS / gs);
    var counterEl = q('#iz-bld-group-counter', modalEl);
    if (counterEl) counterEl.textContent = 'Kağıt ' + (groupIdx + 1) + ' / ' + groupCount;
    showPhase('group');
    renderGroupPool();
    renderGroupCanvas();
    updateGroupConfirmState();
    updateGroupSlotRemoveBtn();
  }

  function renderGroupCanvas() {
    var canvas = q('#iz-bld-group-canvas', modalEl);
    if (!canvas || activeGroupIdx < 0) return;
    loadPosterTemplateAssets(function (tmpl) {
      var gs = currentGroupSize();
      var groupSlots = slots.slice(activeGroupIdx * gs, activeGroupIdx * gs + gs);
      /* askin_kalbi_poster gibi FARKLI boyutlu kucuk alanlari olan gruplu
         sablonlarda, bir alan secildiginde (activeSlotInGroup >= 0) TUM
         kagidi degil, SADECE o alani yakinlastirip hem ekranda daha buyuk
         gosteriyoruz — tek-slot editorundeki (renderPosterEditorCanvas)
         zoomToSlot ile ayni mantik/fonksiyonlar kullanilir. Hicbir alan
         secili degilken (once genel gorunum) tum kagit gorunur ki musteri
         hangi alana tiklayacagini secebilsin. */
      var zoom = shouldZoomSlotEditor() && activeSlotInGroup >= 0;
      var big = usesBigCanvasPicker();
      canvas.style.width = zoom ? (ZOOM_EDITOR_CSS_WIDTH + 'px') : (big ? 'min(94vw, 640px)' : '250px');
      /* Ekranda ~250px (zoomsuz/kucuk) / ~380px (zoomlu) / ~640px (Askin
         Kalbi'nin buyuk-sablon deneyimi) genislikte gosteriliyor — 2x
         (retina) icin orantili backing-cozunurluk hem net gorunur hem
         surukleme sirasinda (her karede yeniden ciziliyor) hala hafif kalir. */
      var CW = zoom ? 700 : (big ? 1100 : 500);
      drawGroupedCanvasFrame(canvas, tmpl, groupSlots, CW, Math.round(CW * tmpl.srcH / tmpl.srcW), activeSlotInGroup, true, zoom);
    });
  }

  /* Solda musterinin yukledigi TUM fotograflari kucuk kareler halinde
     gosterir. Zaten baska bir alana atanmis olanlar da tiklanabilir kalir —
     tiklaninca oradan alinip aktif alana TASINIR (fotograf listesini kapatip
     ayri bir ekrana gecmeye gerek kalmadan hizli yeniden duzenleme icin). */
  function renderGroupPool() {
    var poolEl = q('#iz-bld-group-pool', modalEl);
    if (!poolEl) return;
    poolEl.innerHTML = '';

    var usedDataUrls = {};
    slots.forEach(function (s) { if (s && s.dataUrl) usedDataUrls[s.dataUrl] = true; });

    uploadPool.forEach(function (p) {
      var used = !!usedDataUrls[p.dataUrl];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iz-bld__pool-thumb' + (used ? ' iz-bld__pool-thumb--used' : '');
      btn.innerHTML = '<img src="' + (p.previewDataUrl || p.dataUrl) + '" alt="" loading="lazy">' +
        (used ? '<span class="iz-bld__pool-thumb-check">✓</span>' : '');
      btn.addEventListener('click', function () { assignPoolPhotoToActiveSlot(p); });
      poolEl.appendChild(btn);
    });
  }

  /* Askin Kalbi'nin buyuk-sablon deneyimi: bir foto alanina dokununca acilan
     TAM EKRAN secim penceresi. Musterinin yukledigi TUM fotograflari (zaten
     baska bir alanda kullanilanlar da isaretli/tiklanabilir kalir) buyuk
     karolar halinde gosterir; secilince assignPoolPhotoToActiveSlot ile
     ayni atama yapilir ve pencere otomatik kapanir. Alan zaten doluysa en
     basta "Fotoğrafı Kaldır" karosu da gosterilir. */
  function renderPoolPickerGrid() {
    var gridEl2 = q('#iz-bld-pool-picker-grid', modalEl);
    if (!gridEl2) return;
    gridEl2.innerHTML = '';

    var gs = currentGroupSize();
    var globalIdx = activeGroupIdx * gs + activeSlotInGroup;
    var targetSlot = (activeGroupIdx >= 0 && activeSlotInGroup >= 0) ? slots[globalIdx] : null;

    if (targetSlot && targetSlot.dataUrl) {
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'iz-bld__pool-picker-remove';
      removeBtn.innerHTML = '<span style="font-size:22px">✕</span><span>Fotoğrafı Kaldır</span>';
      removeBtn.addEventListener('click', function () {
        slots[globalIdx] = { dataUrl: null };
        renderGroupCanvas();
        updateGroupConfirmState();
        updateGroupSlotRemoveBtn();
        closePoolPicker();
      });
      gridEl2.appendChild(removeBtn);
    }

    var usedDataUrls = {};
    slots.forEach(function (s) { if (s && s.dataUrl) usedDataUrls[s.dataUrl] = true; });

    uploadPool.forEach(function (p) {
      var used = !!usedDataUrls[p.dataUrl];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iz-bld__pool-thumb iz-bld__pool-thumb--big' + (used ? ' iz-bld__pool-thumb--used' : '');
      btn.innerHTML = '<img src="' + (p.previewDataUrl || p.dataUrl) + '" alt="" loading="lazy">' +
        (used ? '<span class="iz-bld__pool-thumb-check">✓</span>' : '');
      btn.addEventListener('click', function () {
        assignPoolPhotoToActiveSlot(p);
        closePoolPicker();
      });
      gridEl2.appendChild(btn);
    });
  }

  function openPoolPicker() {
    var overlay = q('#iz-bld-pool-picker', modalEl);
    if (!overlay) return;
    renderPoolPickerGrid();
    overlay.style.display = 'flex';
  }

  function closePoolPicker() {
    var overlay = q('#iz-bld-pool-picker', modalEl);
    if (overlay) overlay.style.display = 'none';
  }

  /* Aktif secili alana (ya da secili yoksa ilk bos alana) tiklanan fotografi
     yerlestirir. Foto baska bir alanda zaten kullaniliyorsa oradan kaldirilir
     (surukleme yerine "tikla-tasi" davranisi — daha az tiklama, sayfa
     kaydirmadan hizlica tamamlanabilsin diye). Yerlestirdikten sonra
     otomatik olarak siradaki bos alana gecer. */
  function assignPoolPhotoToActiveSlot(poolItem) {
    if (activeGroupIdx < 0) return;
    var gs = currentGroupSize();
    var groupStart = activeGroupIdx * gs;
    var targetSlot = activeSlotInGroup;

    if (targetSlot < 0) {
      for (var i = 0; i < gs; i++) {
        if (!slots[groupStart + i] || !slots[groupStart + i].dataUrl) { targetSlot = i; break; }
      }
      if (targetSlot < 0) return; /* kagit zaten dolu, secili alan da yok */
    }
    var globalIdx = groupStart + targetSlot;

    /* Ayni foto baska bir alanda kullaniliyorsa oradan bosalt */
    slots.forEach(function (s, idx) {
      if (idx !== globalIdx && s && s.dataUrl === poolItem.dataUrl) slots[idx] = { dataUrl: null };
    });

    slots[globalIdx] = {
      dataUrl: poolItem.dataUrl, naturalW: poolItem.naturalW, naturalH: poolItem.naturalH,
      previewDataUrl: poolItem.previewDataUrl,
      offX: 0, offY: 0, caption: '', font: FONTS[0].v,
      _uploadPromise: poolItem._uploadPromise, done: false,
    };

    /* Musterinin acik istegi: fotografi yerlestirdikten sonra siradaki bosa
       OTOMATIK GECME — musteri once bu fotografi (istiyorsa surukleyerek)
       konumlandirsin, sonraki alana kendisi tiklayarak gecsin. */

    renderGroupCanvas();
    renderGroupPool();
    updateGroupConfirmState();
    updateGroupSlotRemoveBtn();
  }

  function updateGroupConfirmState() {
    var btn = q('#iz-bld-group-confirm', modalEl);
    if (!btn || activeGroupIdx < 0) return;
    var gs = currentGroupSize();
    var groupSlots = slots.slice(activeGroupIdx * gs, activeGroupIdx * gs + gs);
    var allFilled = groupSlots.length === gs && groupSlots.every(function (s) { return s && s.dataUrl; });
    btn.disabled = !allFilled;
  }

  function updateGroupSlotRemoveBtn() {
    var btn = q('#iz-bld-group-slot-remove', modalEl);
    if (!btn) return;
    var s = (activeGroupIdx >= 0 && activeSlotInGroup >= 0)
      ? slots[activeGroupIdx * currentGroupSize() + activeSlotInGroup]
      : null;
    if (s && s.dataUrl) {
      btn.style.display = '';
      btn.onclick = function () {
        slots[activeGroupIdx * currentGroupSize() + activeSlotInGroup] = { dataUrl: null };
        renderGroupCanvas();
        renderGroupPool();
        updateGroupConfirmState();
        updateGroupSlotRemoveBtn();
      };
    } else {
      btn.style.display = 'none';
    }
  }

  function confirmGroup() {
    if (activeGroupIdx < 0) return;
    var gs = currentGroupSize();
    for (var i = activeGroupIdx * gs; i < activeGroupIdx * gs + gs; i++) {
      if (slots[i]) slots[i].done = true;
    }
    activeGroupIdx = -1;
    activeSlotInGroup = -1;
    if (usesBigCanvasPicker()) {
      renderFinal();
      showPhase('final');
      return;
    }
    buildGrid();
    showPhase('grid');
  }

  /* Grup canvas'inda hem tiklanan alani "secili" hale getirir (bir sonraki
     foto tikinizde oraya yerlesir), hem de secili alanda foto varsa
     surukleyerek konumlandirmayi (pan) saglar — ayri bir ekrana gecmeden. */
  function setupGroupCanvasInteraction() {
    var canvas = q('#iz-bld-group-canvas', modalEl);
    if (!canvas) return;
    var drag2 = { on: false, sx: 0, sy: 0, bx: 0, by: 0, moved: false };

    function activeSlotState() {
      if (activeGroupIdx < 0 || activeSlotInGroup < 0) return null;
      return slots[activeGroupIdx * currentGroupSize() + activeSlotInGroup];
    }

    function onDown(e) {
      var s = activeSlotState();
      if (!s || !s.dataUrl) return;
      var xy = getXY(e);
      drag2.on = true; drag2.moved = false;
      drag2.sx = xy[0]; drag2.sy = xy[1];
      drag2.bx = s.offX || 0; drag2.by = s.offY || 0;
      /* Bu surukleme oturumunun GERCEK referansini slotun kendisine kaydet
         (bkz. getPosterPanBounds ustundeki not) — Askin Kalbi gibi FARKLI
         boyutlu alanlari olan sablonlarda, ve buyuk-sablon deneyiminde
         (duyarli CSS genislik) bu deger slot/an'a gore degisebiliyor. */
      s.frameW = posterFrameW; s.frameH = posterFrameH;
    }
    function onMove(e) {
      if (!drag2.on) return;
      var s = activeSlotState();
      if (!s) return;
      var xy = getXY(e);
      if (Math.abs(xy[0] - drag2.sx) > 2 || Math.abs(xy[1] - drag2.sy) > 2) drag2.moved = true;
      var dx = xy[0] - drag2.sx + drag2.bx, dy = xy[1] - drag2.sy + drag2.by;
      var b = getPosterPanBounds(s);
      s.offX = clamp(dx, -b.maxX, b.maxX);
      s.offY = clamp(dy, -b.maxY, b.maxY);
      renderGroupCanvas();
      e.preventDefault();
    }
    function onUp() { drag2.on = false; }

    canvas.addEventListener('mousedown', onDown);
    canvas.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);

    canvas.addEventListener('click', function (e) {
      if (drag2.moved) { drag2.moved = false; return; }
      if (activeGroupIdx < 0) return;
      loadPosterTemplateAssets(function (tmpl) {
        var rect = canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var scaleX = canvas.width / rect.width, scaleY = canvas.height / rect.height;
        var px = (e.clientX - rect.left) * scaleX, py = (e.clientY - rect.top) * scaleY;
        var slotDefs = tmpl.slots || [tmpl.slot];

        /* Bir alan secili oldugunda (activeSlotInGroup >= 0) canvas o alana
           YAKINLASTIRILMIS gosteriliyor olabilir (bkz. renderGroupCanvas) —
           bu yuzden tiklama konumunu, HANGI olcek/kirpma kullanildigina
           bakmaksizin once tam sablon (poster) piksel uzayina cevirip, tum
           alanlarla o uzayda karsilastiriyoruz. */
        var zoom = shouldZoomSlotEditor() && activeSlotInGroup >= 0;
        var cropX = 0, cropY = 0, scale;
        if (zoom) {
          var rectCrop = computeZoomCropRect(tmpl, slotDefs[activeSlotInGroup]);
          cropX = rectCrop.cropX; cropY = rectCrop.cropY;
          scale = canvas.width / rectCrop.cropW;
        } else {
          scale = canvas.width / tmpl.srcW;
        }
        var posterX = px / scale + cropX, posterY = py / scale + cropY;

        for (var i = 0; i < slotDefs.length; i++) {
          var s = slotDefs[i];
          if (posterX >= s.x && posterX <= s.x + s.width && posterY >= s.y && posterY <= s.y + s.height) {
            if (usesBigCanvasPicker()) {
              /* Bos alan: dogrudan sec + foto secim penceresini ac. Zaten
                 SECILI (surukleme icin aktif) dolu bir alana TEKRAR
                 dokunulursa fotografi degistirmek istedigi anlasilir, yine
                 pencere acilir. Ilk kez secilen DOLU bir alanda ise sadece
                 secili hale gelir (pencere acilmaz) — boylece surukleyerek
                 konumlandirmak isteyen musteri her dokunuste pencereyle
                 karsilasmaz. */
              var gsBig = currentGroupSize();
              var globalIdxBig = activeGroupIdx * gsBig + i;
              var slotStateBig = slots[globalIdxBig];
              var wasActive = activeSlotInGroup === i;
              activeSlotInGroup = i;
              renderGroupCanvas();
              updateGroupSlotRemoveBtn();
              if (!slotStateBig || !slotStateBig.dataUrl || wasActive) openPoolPicker();
              return;
            }
            activeSlotInGroup = (activeSlotInGroup === i) ? -1 : i;
            renderGroupCanvas();
            updateGroupSlotRemoveBtn();
            return;
          }
        }
        /* Yakinlastirilmis gorunumde alanin DISINA (kenar payina) tiklaninca
           secim kaldirilir — musteri boylece tekrar tum kagidi gorup baska
           bir alan secebilir. */
        if (zoom) {
          activeSlotInGroup = -1;
          renderGroupCanvas();
          updateGroupSlotRemoveBtn();
        }
      });
    });
  }

  function openEditor(idx) {
    editIdx = idx;
    loadEditorSlot(idx);
    showPhase('editor');
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase 3: Editor                                 */
  /* ─────────────────────────────────────────────── */
  function loadEditorSlot(idx) {
    var slot = slots[idx];
    if (!slot) return;

    /* Counter */
    editorCounter.textContent = (idx + 1) + ' / ' + slots.length;

    /* Next button */
    var nextBtn = q('#iz-bld-editor-next', modalEl);
    if (nextBtn) nextBtn.disabled = (idx >= slots.length - 1);

    /* Load photo */
    photoImg.src = slot.dataUrl;
    photoImg.onload = function () {
      applyCoverSize(photoImg, photoFrame);
      applyPan(slot.offX, slot.offY);
    };
    if (photoImg.complete && photoImg.naturalWidth) {
      applyCoverSize(photoImg, photoFrame);
      applyPan(slot.offX, slot.offY);
    }

    /* Caption + font */
    captionInput.value = slot.caption;
    setFontPicker(slot.font || FONTS[0].v, false /* don't write back to slot */);
    updateCaptionPreview();

    /* Netflix-tarzi afis alanlari */
    if (productType === 'netflix-poster-tablo') {
      var pIsim = q('#iz-bld-poster-isim', modalEl), pBaslik = q('#iz-bld-poster-baslik', modalEl);
      var pHikaye = q('#iz-bld-poster-hikaye', modalEl), pTur = q('#iz-bld-poster-tur', modalEl);
      if (pIsim)   pIsim.value   = slot.posterIsim   || '';
      if (pBaslik) pBaslik.value = slot.posterBaslik || '';
      if (pHikaye) pHikaye.value = slot.posterHikaye || '';
      if (pTur)    pTur.value    = slot.posterTur    || '';
      ['iz-bld-poster-isim', 'iz-bld-poster-baslik', 'iz-bld-poster-hikaye', 'iz-bld-poster-tur'].forEach(function (id) {
        var el = q('#' + id, modalEl), countEl = q('#' + id + '-count', modalEl);
        if (el && countEl) countEl.textContent = el.value.length + '/' + el.getAttribute('maxlength');
      });
      var posterErr = q('#iz-bld-poster-err', modalEl);
      if (posterErr) posterErr.style.display = 'none';
    }

    /* Gercek sablonu canli gosteren canvas — sadece afis degil, caption'li
       (ani-kutusu/palo-kart) ve caption'siz (foto-kart) tum backend
       urunlerinde de her slot yuklendiginde guncel gorunsun. */
    if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1) {
      renderPosterEditorCanvas();
    }
  }

  function applyCoverSize(img, frame) {
    var fw = frame.offsetWidth  || 220;
    var fh = frame.offsetHeight || 240;
    var iw = img.naturalWidth;
    var ih = img.naturalHeight;
    if (!iw || !ih) return;

    var scale = Math.max(fw / iw, fh / ih);
    img.style.width  = Math.round(iw * scale) + 'px';
    img.style.height = Math.round(ih * scale) + 'px';
  }

  function applyPan(offX, offY) {
    photoImg.style.transform = 'translate(calc(-50% + ' + (offX || 0) + 'px), calc(-50% + ' + (offY || 0) + 'px))';
  }

  function getPanBounds() {
    var fw  = photoFrame.offsetWidth  || 220;
    var fh  = photoFrame.offsetHeight || 240;
    var iw  = parseFloat(photoImg.style.width)  || fw;
    var ih  = parseFloat(photoImg.style.height) || fh;
    return {
      maxX: Math.max(0, (iw - fw) / 2),
      maxY: Math.max(0, (ih - fh) / 2)
    };
  }

  function setupPhotoPan() {
    function onDown(e) {
      if (!photoImg.src || photoImg.src === window.location.href) return;
      var xy = getXY(e);
      drag.on = true;
      drag.sx = xy[0];
      drag.sy = xy[1];
      var slot = slots[editIdx];
      drag.bx = slot ? slot.offX : 0;
      drag.by = slot ? slot.offY : 0;
      e.preventDefault();
    }
    function onMove(e) {
      if (!drag.on) return;
      var xy = getXY(e);
      var dx = xy[0] - drag.sx + drag.bx;
      var dy = xy[1] - drag.sy + drag.by;
      var b  = getPanBounds();
      var ox = clamp(dx, -b.maxX, b.maxX);
      var oy = clamp(dy, -b.maxY, b.maxY);
      applyPan(ox, oy);
      if (slots[editIdx]) { slots[editIdx].offX = ox; slots[editIdx].offY = oy; }
      e.preventDefault();
    }
    function onUp() { drag.on = false; }

    photoImg.addEventListener('mousedown',  onDown);
    photoImg.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove',  onMove);
    document.addEventListener('touchmove',  onMove, { passive: false });
    document.addEventListener('mouseup',    onUp);
    document.addEventListener('touchend',   onUp);
  }

  /* ─────────────────────────────────────────────── */
  /*  Afis/tablo urunleri: canli sablon canvas motoru  */
  /* ─────────────────────────────────────────────── */

  /* Backend'de gercek sablonu olan urunler icin slot piksel olculerini bir kez
     cekip onbelleklerin — hem erken (arka plan) yukleme hem de son gonderim
     bunu kullanir, boylece slots.json ikinci kez cekilmez. */
  var backendSlotDims = null;
  var backendSlotsFull = null; /* tum slots[] dizisi — farkli boyutlu slotlu sablonlar icin (orn. google_arama_poster) */
  var backendSlotDimsPromise = null;
  function loadBackendSlotDims() {
    if (backendSlotDims) return Promise.resolve(backendSlotDims);
    if (backendSlotDimsPromise) return backendSlotDimsPromise;
    backendSlotDimsPromise = fetch(photoApiBase + '/api/templates/' + photoTemplateId + '/slots.json')
      .then(function (r) {
        if (!r.ok) throw new Error('slots.json HTTP ' + r.status);
        return r.json();
      })
      .then(function (slotsData) {
        backendSlotsFull = slotsData.slots;
        var s = slotsData.slots[0];
        backendSlotDims = { width: s.width, height: s.height };
        return backendSlotDims;
      });
    return backendSlotDimsPromise;
  }

  /* Cogu sablonda tum slotlar ayni boyuttadir (loadBackendSlotDims'in
     slot[0]'i yeterlidir) — ama Google Arama Poster gibi 5 FARKLI boyutlu
     sabit slotu olan sablonlarda, hangi fotografin hangi slot'a gittigine
     gore (i, yukleme/slot sirasina gore) DOGRU boyutu donmek gerekir.
     backendSlotsFull henuz cekilmediyse (nadir bir yaris durumu) genel
     backendSlotDims'e duser. */
  function getSlotDimsAt(i, slotState) {
    var dims;
    if (backendSlotsFull && backendSlotsFull.length) {
      var s = backendSlotsFull[i % backendSlotsFull.length];
      dims = { width: s.width, height: s.height };
    } else {
      dims = backendSlotDims || { width: 0, height: 0 };
    }
    /* Yon-uyumlu sablonlarda (5x7/9x13/13x18), o slot'un fotografi yataysa
       hedef boyutlari yer degistiriyoruz — computeCropForSlot'a giden CW/CH
       BURADAN gelir, yani kirpma orani nihayetinde basilan (yatay) karta
       gore hesaplanir. Canli onizlemenin (resolveTmplForSlot) kullandigi
       sekille birebir ayni kaynaktan (fotografin kendi yonunden) turetildigi
       icin ikisi hicbir zaman birbirinden sapmaz.
       slotState CAGIRAN tarafindan dogrudan verilir (i, "active"/filtrelenmis
       bir dizideki sira olabilir — slots[] ile hizali olmayabilir; guvenli
       olan cagiranin zaten elinde tuttugu gercek slot nesnesini almak). */
    if (isOrientationAdaptiveTemplate() && isLandscapeSlotState(slotState)) {
      return { width: dims.height, height: dims.width };
    }
    return dims;
  }

  function loadPosterTemplateAssets(cb) {
    cb = currentDraftCallback(cb);
    var cached = posterTemplateCache[photoTemplateId];
    if (cached) { cb(cached); return; }
    fetch(photoApiBase + '/api/templates/' + photoTemplateId + '/slots.json')
      .then(function (r) {
        if (!r.ok) throw new Error('slots.json HTTP ' + r.status);
        return r.json();
      })
      .then(function (slotsData) {
        var bg = new Image(), fg = new Image();
        var loadedCount = 0;
        function checkDone() {
          loadedCount++;
          if (loadedCount < 2) return;
          var entry = {
            bg: bg, fg: fg,
            slot: slotsData.slots[0],
            slots: slotsData.slots,
            groupSize: slotsData.slots.length,
            textAreas: slotsData.text_areas || {},
            captionArea: slotsData.caption_area || null,
            calendarSpec: slotsData.calendar || null,
            srcW: bg.naturalWidth, srcH: bg.naturalHeight,
          };
          posterTemplateCache[photoTemplateId] = entry;
          posterFrameW = 220;
          posterFrameH = Math.round(220 / (entry.slot.width / entry.slot.height));
          cb(entry);
        }
        bg.onload = checkDone; fg.onload = checkDone;
        bg.src = photoApiBase + '/api/templates/' + photoTemplateId + '/arkaplan.png';
        fg.src = photoApiBase + '/api/templates/' + photoTemplateId + '/onkat.png';
      })
      .catch(function (err) {
        console.error('[İz Builder] Şablon önizleme varlıkları yüklenemedi:', err);
      });
  }

  /* ── Yön uyumu (klasik foto kartlar: 5x7/9x13/13x18) ──
     Musteri yatay bir foto yuklerse, canli onizleme de backend'deki
     "<id>_yatay" kardes sablonunu (bg/fg/slot boyutlari yer degistirmis)
     kullanir — boylece musterinin gordugu ile gercekte basilan birebir
     ayni olur. Portre sablonla ayni sekilde tek seferlik fetch+cache. */
  var posterTemplateYatayCache = {};
  var posterTemplateYatayPromise = null;
  function isOrientationAdaptiveTemplate() {
    return ORIENTATION_ADAPTIVE_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1;
  }
  function isLandscapeSlotState(slotState) {
    return !!(slotState && slotState.naturalW && slotState.naturalH && slotState.naturalW > slotState.naturalH);
  }
  function loadPosterTemplateAssetsYatay(cb) {
    var cached = posterTemplateYatayCache[photoTemplateId];
    if (cached) { cb(cached); return; }
    if (posterTemplateYatayPromise) { posterTemplateYatayPromise.then(cb); return; }
    var yatayId = photoTemplateId + '_yatay';
    posterTemplateYatayPromise = fetch(photoApiBase + '/api/templates/' + yatayId + '/slots.json')
      .then(function (r) {
        if (!r.ok) throw new Error('yatay slots.json HTTP ' + r.status);
        return r.json();
      })
      .then(function (slotsData) {
        return new Promise(function (resolve) {
          var bg = new Image(), fg = new Image();
          var loadedCount = 0;
          function checkDone() {
            loadedCount++;
            if (loadedCount < 2) return;
            var entry = {
              bg: bg, fg: fg,
              slot: slotsData.slots[0],
              slots: slotsData.slots,
              groupSize: slotsData.slots.length,
              textAreas: {}, captionArea: null, calendarSpec: null,
              srcW: bg.naturalWidth, srcH: bg.naturalHeight,
            };
            posterTemplateYatayCache[photoTemplateId] = entry;
            resolve(entry);
          }
          bg.onload = checkDone; fg.onload = checkDone;
          bg.src = photoApiBase + '/api/templates/' + yatayId + '/arkaplan.png';
          fg.src = photoApiBase + '/api/templates/' + yatayId + '/onkat.png';
        });
      })
      .catch(function (err) {
        console.error('[İz Builder] Yatay şablon önizleme varlıkları yüklenemedi:', err);
        return null;
      });
    posterTemplateYatayPromise.then(cb);
  }
  /* Yon-uyumlu bir sablon icin ilgili fotograf yatay ise, cb'ye yatay
     sablonu (bg/fg/slot yer degistirmis kardes) verir; aksi halde
     dokunmadan portre tmpl'i geri verir. Tum canli onizleme/kucuk resim/
     zoom render'lari bu tek noktadan gecer, boylece musterinin gordugu
     ile submit anindaki kirpma hesabi (getSlotDimsAt) her zaman ayni
     sekli kullanir. */
  function resolveTmplForSlot(tmpl, slotState, cb) {
    cb = currentDraftCallback(cb);
    if (isOrientationAdaptiveTemplate() && isLandscapeSlotState(slotState)) {
      loadPosterTemplateAssetsYatay(function (tmplYatay) { cb(tmplYatay || tmpl); });
    } else {
      cb(tmpl);
    }
  }

  /* ── Palo kart sticker'lari ──
     Musteri yazi alanina istedigi kadar dekoratif sticker ekleyip surukleyip
     boyutlandirabilir. Kaynak: backend'deki stickers/manifest.json (bkz.
     /api/stickers), kategori sekmeli bir secici ile (WhatsApp/emoji
     secicisi gibi) sunulur. Sadece caption_area'si olan urunlerde (palo
     kart) gosterilir — foto_kart_* urunlerinde hic caption/font alani
     olmadigi icin bu bolum de otomatik olarak gizli kalir (ayni
     #iz-bld-caption-font-fields wrapper'i icinde oldugu icin).
     Sticker resimleri (thumbnail + canvas) img/Image olarak yuklenip
     CANVAS'A SADECE CIZILIR, hic toDataURL/toBlob'a cevrilmez (backend
     pipeline urunlerinde export zaten sunucuda yapiliyor) — bu yuzden
     cross-origin img icin CORS/"tainted canvas" sorunu olusmaz. */
  var stickersManifest = null;
  var stickersManifestPromise = null;
  function loadStickerManifest(cb) {
    if (stickersManifest) { cb(stickersManifest); return; }
    if (stickersManifestPromise) { stickersManifestPromise.then(cb); return; }
    stickersManifestPromise = fetch(photoApiBase + '/api/stickers')
      .then(function (r) {
        if (!r.ok) throw new Error('stickers manifest HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        stickersManifest = data && data.categories ? data : { categories: [] };
        return stickersManifest;
      })
      .catch(function (err) {
        console.error('[İz Builder] Sticker listesi yüklenemedi:', err);
        stickersManifest = { categories: [] };
        return stickersManifest;
      });
    stickersManifestPromise.then(cb);
  }

  function updateStickerCountBadge() {
    if (!stickerCountEl) return;
    var slot = slots[editIdx];
    var n = (slot && slot.stickers) ? slot.stickers.length : 0;
    if (n > 0) {
      stickerCountEl.textContent = n;
      stickerCountEl.hidden = false;
    } else {
      stickerCountEl.hidden = true;
    }
  }

  function renderStickerTabs(manifest) {
    if (!stickerTabsEl) return;
    stickerTabsEl.innerHTML = '';
    if (!manifest.categories.length) return;
    if (!stickerActiveCategory || !manifest.categories.some(function (c) { return c.slug === stickerActiveCategory; })) {
      stickerActiveCategory = manifest.categories[0].slug;
    }
    manifest.categories.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iz-bld__sticker-tab' + (cat.slug === stickerActiveCategory ? ' iz-bld__sticker-tab--active' : '');
      btn.textContent = cat.label;
      btn.addEventListener('click', function () {
        stickerActiveCategory = cat.slug;
        renderStickerTabs(manifest);
        renderStickerGrid(manifest);
      });
      stickerTabsEl.appendChild(btn);
    });
  }

  function renderStickerGrid(manifest) {
    if (!stickerGridEl) return;
    stickerGridEl.innerHTML = '';
    var cat = manifest.categories.filter(function (c) { return c.slug === stickerActiveCategory; })[0];
    if (!cat) return;
    /* Sadece AKTIF sekmenin resimleri DOM'a eklenir — diger kategoriler
       sekmeye tiklanana kadar hic yuklenmez (performans: 100+ sticker olsa
       bile ilk acilista sadece ~10-25 kucuk thumbnail indirilir). */
    cat.items.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iz-bld__sticker-thumb';
      btn.setAttribute('aria-label', 'Sticker ekle');
      /* stickerImageCache'de ONCEDEN olusturup burada da AYNI Image node'unu
         kullaniyoruz — hem grid'de thumbnail olarak gorunur hem de tiklaninca
         eklenirken en-boy orani zaten yuklu/hazir olur (computeAutoFitScale
         icin agdan tekrar beklemeye gerek kalmaz). */
      var img = stickerImageCache[item.file];
      if (!img) {
        img = new Image();
        img.crossOrigin = 'anonymous';
        img.loading = 'lazy';
        img.src = photoApiBase + '/api/stickers/' + item.file;
        stickerImageCache[item.file] = img;
      }
      img.alt = '';
      btn.appendChild(img);
      applyStickerThumbAspect(btn, img);
      btn.addEventListener('click', function () { addStickerToActiveSlot(item.file); });
      stickerGridEl.appendChild(btn);
    });
  }

  /* Sabit kare kutu, dikey (ayi gibi) veya yatay (balik/cicek gibi)
     sticker'lari object-fit:contain ile kucultup etrafinda bosluk
     birakiyordu — bazi kategoriler diğerlerinden gozle gorulur kucuk
     duruyordu. Bunun yerine her thumbnail'in kutusunu kendi gercek en-boy
     oranina gore ayarliyoruz (asiri ince/uzun olmasin diye hafifce
     sinirlandirilmis) — boylece her sticker kendi dogal boyutuyla rahat
     gorunur. */
  function applyStickerThumbAspect(btn, img) {
    var apply = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      btn.style.aspectRatio = String(clamp(img.naturalWidth / img.naturalHeight, 0.55, 1.8));
    };
    if (img.complete && img.naturalWidth) { apply(); return; }
    img.addEventListener('load', function onLoad() {
      img.removeEventListener('load', onLoad);
      apply();
    });
  }

  /* Masaustunde panel alanin icinde acilan sade bir kutu; mobilde (bkz.
     iz-builder.css @600px) telefon klavyesi/WhatsApp sticker secici gibi
     ekranin altindan kayarak gelen sabit bir "bottom sheet"e donusuyor —
     bunun icin gorunurluk `hidden` niteligi yerine CSS class ile kontrol
     ediliyor (transform gecisi `display:none`den calismaz). */
  function openStickerPanel() {
    if (!stickerPanelEl) return;
    stickerPanelEl.classList.add('iz-bld__sticker-panel--open');
    if (stickerBackdropEl) stickerBackdropEl.classList.add('iz-bld__sticker-backdrop--open');
    if (modalEl) modalEl.classList.add('iz-bld--sticker-sheet-open');
    if (stickerToggleBtn) stickerToggleBtn.setAttribute('aria-expanded', 'true');
    loadStickerManifest(function (manifest) {
      renderStickerTabs(manifest);
      renderStickerGrid(manifest);
      /* Sadece masaustunde (inline panel) gorunur alana kaydir — mobilde
         sheet zaten sabit/ekranin ustunde acildigi icin gerek yok. */
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
      if (!isMobile && window.requestAnimationFrame) {
        requestAnimationFrame(function () {
          if (stickerToggleBtn) stickerToggleBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  }

  function closeStickerPanel() {
    if (!stickerPanelEl) return;
    stickerPanelEl.classList.remove('iz-bld__sticker-panel--open');
    if (stickerBackdropEl) stickerBackdropEl.classList.remove('iz-bld__sticker-backdrop--open');
    if (modalEl) modalEl.classList.remove('iz-bld--sticker-sheet-open');
    if (stickerToggleBtn) stickerToggleBtn.setAttribute('aria-expanded', 'false');
  }

  function toggleStickerPanel() {
    if (!stickerPanelEl) return;
    if (stickerPanelEl.classList.contains('iz-bld__sticker-panel--open')) closeStickerPanel(); else openStickerPanel();
  }

  /* Yeni eklenen sticker'lar birbirinin tam ustune binmesin diye hafif bir
     kademeli (staircase) baslangic konumu verir — musteri zaten sonradan
     istedigi yere surukleyebilir, bu sadece rahat bir varsayilan. */
  /* Yazi alaninin (lastCaptionAreaPx, en son interaktif cizimden) icine
     "contain" mantigiyla oturan varsayilan scale'i hesaplar — sticker'in en-
     boy orani bozulmadan, ne genisligi ne yuksekligi alani tasmaz. Resim
     henuz yuklenmediyse (naturalWidth bilinmiyor) makul bir tahmine duser;
     yuklenince addStickerToActiveSlot bunu duzeltip yeniden cizer. */
  function computeAutoFitScale(img) {
    var areaW = lastCaptionAreaPx.w, areaH = lastCaptionAreaPx.h;
    if (!img || !img.naturalWidth || !img.naturalHeight || !areaW) return STICKER_DEFAULT_SCALE_FALLBACK;
    var aspect = img.naturalWidth / img.naturalHeight;
    var wFromHeight = areaH * aspect;
    var w = Math.min(areaW, wFromHeight);
    return clamp(w / areaW, 0.05, 1);
  }

  function addStickerToActiveSlot(file) {
    var slot = slots[editIdx];
    if (!slot) return;
    var n = slot.stickers.length;
    var stagger = (n % 5) * 0.05;
    var img = stickerImageCache[file];
    var scale = computeAutoFitScale(img);

    var entry = {
      file: file,
      x: clamp(0.24 + stagger, 0.05, 0.95),
      y: clamp(0.5 + stagger * 0.5, 0.05, 0.95),
      scale: scale,
      /* "Biraz" buyutup kucultmeye izin ver — otomatik oturan boyuta gore
         sinirli bir aralik (bkz. STICKER_ZOOM_RANGE), ucsuz bucaksiz degil. */
      scaleMin: clamp(scale * STICKER_ZOOM_RANGE[0], 0.04, 1),
      scaleMax: clamp(scale * STICKER_ZOOM_RANGE[1], scale, 1),
    };
    slot.stickers.push(entry);
    stickerSelectedIdx = slot.stickers.length - 1;
    updateStickerCountBadge();
    renderPosterEditorCanvas();

    if (!img) {
      img = new Image();
      img.crossOrigin = 'anonymous';
      stickerImageCache[file] = img;
      img.src = photoApiBase + '/api/stickers/' + file;
    }
    if (!img.complete || !img.naturalWidth) {
      img.addEventListener('load', function onStickerImgLoad() {
        img.removeEventListener('load', onStickerImgLoad);
        /* Tahmini fallback'ten gercek en-boy oranina gore duzelt. */
        var fixedScale = computeAutoFitScale(img);
        entry.scale = fixedScale;
        entry.scaleMin = clamp(fixedScale * STICKER_ZOOM_RANGE[0], 0.04, 1);
        entry.scaleMax = clamp(fixedScale * STICKER_ZOOM_RANGE[1], fixedScale, 1);
        renderPosterEditorCanvas();
      });
    }
  }

  /* Secili sticker varsa fotonun hemen altindaki surguyu (PDF gorunuculerdeki
     yakinlastirma cubugu gibi) onun scaleMin..scaleMax araligina gore
     konumlandirip gosterir; yoksa surguyu gizler. Canvas uzerindeki kucuk bir
     tutamaci tutturmaya calismak yerine musteri artik net/genis bir surguyle
     boyutlandiriyor — mobilde de parmakla rahat kullanilir. */
  function updateStickerZoomUI(slotState) {
    if (!stickerZoomEl) return;
    var st = slotState && slotState.stickers && slotState.stickers[stickerSelectedIdx];
    if (!st) { stickerZoomEl.hidden = true; return; }
    stickerZoomEl.hidden = false;
    if (stickerZoomRangeEl && document.activeElement !== stickerZoomRangeEl) {
      var lo = st.scaleMin || 0.05, hi = st.scaleMax || 1;
      var pct = hi > lo ? (st.scale - lo) / (hi - lo) : 0.5;
      stickerZoomRangeEl.value = String(Math.round(clamp(pct, 0, 1) * 1000));
    }
  }

  function onStickerZoomInput() {
    var slot = slots[editIdx];
    var st = slot && slot.stickers && slot.stickers[stickerSelectedIdx];
    if (!st || !stickerZoomRangeEl) return;
    var lo = st.scaleMin || 0.05, hi = st.scaleMax || 1;
    var pct = Number(stickerZoomRangeEl.value) / 1000;
    st.scale = lo + pct * (hi - lo);
    renderPosterEditorCanvas();
  }

  function deleteSelectedSticker() {
    var slot = slots[editIdx];
    if (!slot || !slot.stickers || stickerSelectedIdx < 0) return;
    slot.stickers.splice(stickerSelectedIdx, 1);
    stickerSelectedIdx = -1;
    updateStickerCountBadge();
    renderPosterEditorCanvas();
  }

  function _posterWrapText(ctx, text, maxW) {
    /* Musterinin textarea'da Enter'a basarak yazdigi paragraf baslarini
       korur — sadece boslukla degil, satir satir da bolup her satiri ayri
       ayri genislige gore sarmalar (yoksa "\n" bir bosluk gibi yutulup
       musterinin bilerek yaptigi satir baslari kayboluyordu). */
    var rawLines = [];
    text.split('\n').forEach(function (paragraph) {
      var words = paragraph.split(/\s+/).filter(Boolean);
      if (!words.length) { rawLines.push(''); return; }
      var current = words[0];
      for (var i = 1; i < words.length; i++) {
        var trial = current + ' ' + words[i];
        if (ctx.measureText(trial).width <= maxW) { current = trial; }
        else { rawLines.push(current); current = words[i]; }
      }
      rawLines.push(current);
    });

    /* Guvenlik agi: bosluksuz TEK bir "kelime" (orn. uzun bir URL/hashtag)
       yukaridaki kelime-bazli sarma ile KIRILAMAZ — tek basina kutudan
       tasan bir satir olarak kalir. Bu satirlari harf harf bolerek kutuyu
       kesin olarak asmamasini sagliyoruz (composite.py'deki _wrap_lines ile
       ayni mantik — boylece canli onizleme ile basilan cikti hep ayni
       satirlara boluyor). */
    var lines = [];
    rawLines.forEach(function (line) {
      if (!line || ctx.measureText(line).width <= maxW) { lines.push(line); return; }
      var chunk = '';
      for (var i = 0; i < line.length; i++) {
        var trial = chunk + line[i];
        if (!chunk || ctx.measureText(trial).width <= maxW) { chunk = trial; }
        else { lines.push(chunk); chunk = line[i]; }
      }
      if (chunk) lines.push(chunk);
    });
    return lines;
  }

  /* Her "text_areas" kullanan urun tipinin kendi alan-id onekini burada
     tanimliyoruz. ONEMLI: bir onceki urunde "||" ile sirayla deneyip ilk
     BULUNAN elementi kullanmak YANLIS bir yaklasimdi — #iz-bld-poster-isim
     gibi elementler HER ZAMAN DOM'da var (netflix-poster-tablo icin, gizli
     de olsa), "isim" gibi ortak bir ad kullaninca hep o BOS elementi buluyor,
     dogru urunun kendi alanina hic dusmuyordu (mavi "isim" yazisinin
     onizlemede hic gorunmeme sebebi buydu). Bu yuzden urun tipine gore hangi
     onekin kullanilacagi ACIKCA (map ile) seciliyor. */
  var POSTER_FIELD_PREFIX_BY_PRODUCT_TYPE = {
    'google-arama-poster-tablo':  '#iz-bld-google-',
    'ani-gazetesi-poster-tablo':  '#iz-bld-gazete-',
    'kalbimdeki-anilar-sarkili-takvim-tablosu': '#iz-bld-takvim-',
    'askin-kalbi-i̇simli-ve-sarkili-poster-tablo': '#iz-bld-kalp-',
  };
  function _posterFieldValue(name) {
    var prefix = POSTER_FIELD_PREFIX_BY_PRODUCT_TYPE[productType] || '#iz-bld-poster-';
    var el = q(prefix + name, modalEl);
    return el ? el.value.trim() : '';
  }

  function _posterFontFamily(area) {
    if (area.font === 'title')      return "'Pacifico', cursive";
    if (area.font === 'inter')      return "'Inter', sans-serif";
    if (area.font === 'playfair')   return "'Playfair Display', serif";
    if (area.font === 'montserrat') return "'Montserrat', sans-serif";
    if (area.font === 'cormorant')  return "'Cormorant Garamond', serif";
    return "'Roboto', sans-serif";
  }

  /* composite.py'deki _resolve_text_area_weight ile ayni esleme: "weight"
     (orn. "ExtraBold") adiyla verilen alanlar oncelikli, yoksa eski "bold"
     boolean bayragina (Bold=700) geriye donuk uyumluluk icin bakilir. Sadece
     "bold: true/false" ile CSS font kisayoluna "bold " kelimesi eklemek
     (eski davranis) ExtraBold/SemiBold gibi isimlendirilmis agirliklari HIC
     yansitmiyordu — bu yuzden onizlemede Ani Takvimi'nin ay/yil metni normal
     kalinlikta gorunuyordu, oysa basilan cikti (composite.py) gercekten
     ExtraBold'du. */
  var POSTER_WEIGHT_CSS_MAP = {
    Thin: 100, ExtraLight: 200, Light: 300, Regular: 400,
    Medium: 500, SemiBold: 600, Bold: 700, ExtraBold: 800, Black: 900,
  };
  function _posterWeightCss(area) {
    var w = area.weight || (area.bold ? 'Bold' : null);
    return w ? (POSTER_WEIGHT_CSS_MAP[w] || 400) : 400;
  }

  /* Canvas font kisayolunda agirlik SIZE'DAN ONCE gelmeli ("800 64px Arial")
     — bu yuzden family string'inin icine degil, dogrudan ctx.font
     atamasinin basina eklenir. */
  function _posterFontCss(area, sizePx) {
    return _posterWeightCss(area) + ' ' + sizePx + 'px ' + _posterFontFamily(area);
  }

  function _posterAreaColor(area) {
    return area.color || '#ffffff';
  }

  function _posterAreaText(name, area) {
    var source = area.source_field || name;
    var value = _posterFieldValue(source);
    if (!value) return '';
    return (area.prefix || '') + value;
  }

  function drawPosterTextAreas(ctx, tmpl, scale) {
    var areas = tmpl.textAreas || {};
    ctx.textBaseline = 'alphabetic';

    /* 1. gecis: tek satirlik alanlar icin sigacak nihai boyutu hesapla;
       size_group'daki alanlar ayni (en kucuk) boyutu paylasir — composite.py
       ile ayni mantik, boylece duzenleme ekraninda gordugu ile basilan
       tasarim gorsel olarak ayni olsun. */
    var fittedSizes = {};
    Object.keys(areas).forEach(function (name) {
      var area = areas[name];
      if (area.multiline) return;
      var text = _posterAreaText(name, area);
      if (!text) return;
      var sz = area.font_size * scale;
      ctx.font = _posterFontCss(area, sz);
      var minSz = Math.max(10 * scale, sz * 0.3);
      while (sz > minSz && ctx.measureText(text).width > area.w * scale) {
        sz -= 2;
        ctx.font = _posterFontCss(area, sz);
      }
      fittedSizes[name] = sz;
    });
    var groupSizes = {};
    Object.keys(areas).forEach(function (name) {
      var grp = areas[name].size_group;
      if (grp && fittedSizes[name] !== undefined) {
        groupSizes[grp] = groupSizes[grp] === undefined ? fittedSizes[name] : Math.min(groupSizes[grp], fittedSizes[name]);
      }
    });

    /* 2. gecis: gercek cizim */
    Object.keys(areas).forEach(function (name) {
      var area = areas[name];
      var text = _posterAreaText(name, area);
      if (!text) return;

      var align  = area.align || 'left';
      var x = area.x * scale, y = area.y * scale, w = area.w * scale, h = area.h * scale;
      ctx.fillStyle = _posterAreaColor(area);

      if (area.multiline) {
        var size = area.font_size * scale;
        ctx.font = _posterFontCss(area, size);
        var lineH = size * 1.25;
        var maxLines = Math.max(1, Math.floor(h / lineH));
        var lines = _posterWrapText(ctx, text, w).slice(0, maxLines);
        var ty = y + size * 0.85;
        ctx.textAlign = align === 'left' ? 'left' : 'center';
        lines.forEach(function (line) {
          ctx.fillText(line, align === 'left' ? x : x + w / 2, ty);
          ty += lineH;
        });
      } else {
        var grp = area.size_group;
        var sz = (grp && groupSizes[grp] !== undefined) ? groupSizes[grp] : fittedSizes[name];
        ctx.font = _posterFontCss(area, sz);
        ctx.textAlign = align === 'left' ? 'left' : 'center';
        ctx.fillText(text, align === 'left' ? x : x + w / 2, y + h / 2 + sz * 0.35);
      }
    });
  }

  /* CW/CH: canvas'in ic (draw) cozunurlugu. readOnly=true iken foto yoksa
     bos slot alani sablonun kendi arkaplaniyla (siyah) birakilir. */
  /* ani-kutusu/palo-kart/foto-kart gibi urunlerde (text_areas degil, tek bir
     caption_area kullanan urunlerde) not metnini gercek yerinde, gercek
     fontla (musteri secimi varsa Roboto/Pacifico, yoksa sunucunun
     varsayilan el yazisi fontu Caveat ile ayni gorunmesi icin Caveat)
     ortalanmis ve sigacak sekilde kucularak cizer — composite.py'deki
     draw_caption() ile ayni mantik. */
  function drawCaptionOnCanvas(ctx, tmpl, scale, slotState) {
    var area = tmpl.captionArea;
    if (!area || !slotState) return;
    var maxChars = area.max_chars || 40;
    var text = (slotState.caption || '').trim().slice(0, maxChars);
    if (!text) return;

    var fontEntry = FONTS.filter(function (f) { return f.v === slotState.font; })[0];
    var family = (fontEntry && fontEntry.k === 'pacifico') ? "'Pacifico', cursive"
               : (fontEntry && fontEntry.k === 'roboto')   ? "'Roboto', sans-serif"
               : "'Caveat', cursive";

    var x = area.x * scale, y = area.y * scale, w = area.width * scale, h = area.height * scale;
    var sz = Math.max(10 * scale, (h * 0.55));
    ctx.fillStyle = '#1E2A44';
    ctx.textBaseline = 'alphabetic';
    ctx.textAlign = 'center';
    ctx.font = sz + 'px ' + family;
    var minSz = 14 * scale;
    while (sz > minSz && ctx.measureText(text).width > w) {
      sz -= 2;
      ctx.font = sz + 'px ' + family;
    }
    ctx.fillText(text, x + w / 2, y + h / 2 + sz * 0.35);
  }

  var STICKER_DELETE_R = 11;   /* silme rozetinin yaricapi (canvas px) */
  /* composite.py'deki STICKER_BOTTOM_SAFE_PX ile BIREBIR ayni deger (300dpi'de
     ~3mm) — kagidin en altina cok yakin sticker kesim/baski toleransi icin
     yukari itilir. Iki tarafta da ayni sabit olmazsa musteri onizlemede
     gordugunden farkli bir baski alir. */
  var STICKER_BOTTOM_SAFE_PX = 35;
  /* Yeni eklenen bir sticker varsayilan olarak yazi alanina "oturacak"
     sekilde otomatik boyutlandirilir (bkz. computeAutoFitScale); bu sabitler
     o varsayilana gore ne kadar kucultup buyutebilecegini sinirlar — "biraz"
     ayarlanabilsin, absürt kucuk/buyuk olmasin diye. */
  var STICKER_ZOOM_RANGE = [0.55, 1.65];
  var STICKER_DEFAULT_SCALE_FALLBACK = 0.34; /* resim henuz yuklenmeden once kullanilan tahmini deger */

  /* stickerHitRects: en son cizimde her sticker'in canvas-uzayindaki
     {left,top,right,bottom, delX,delY} dikdortgenini tutar — setupStickerInteraction'daki
     pointer olaylari BUNU okuyarak hangi sticker'a / silme rozetine
     tiklandigini bulur (yeniden hesaplamak yerine
     son cizimle birebir ayni koordinatlari kullanmak surukleme sirasinda
     "kayma" olmasini engeller). */
  var stickerHitRects = [];
  /* Son interaktif cizimde caption_area'nin canvas-BITMAP uzayindaki
     {x,y,w,h} dikdortgeni — surukleme/boyutlandirma delta'larini normalize
     etmek (0..1) icin kullanilir. */
  var lastCaptionAreaPx = { x: 0, y: 0, w: 1, h: 1 };

  function drawStickersOnCanvas(ctx, tmpl, scale, slotState, interactive) {
    /* stickerHitRects SADECE interaktif (editor) cizimde guncellenir — bu
       fonksiyon final-preview/thumbnail/zoom gorunumlerinde de (interactive
       olmadan, sadece GORSEL olarak) cagrildigi icin, o cizimler editorun
       surukleme/tutamac koordinatlarini ezmez. */
    if (interactive) stickerHitRects = [];
    var area = tmpl.captionArea;
    if (!area) return;

    var areaX = area.x * scale, areaY = area.y * scale;
    var areaW = area.width * scale, areaH = area.height * scale;
    /* Liste bos olsa bile guncellenir — ilk sticker eklenmeden ONCE bile
       surukleme normalizasyonu icin dogru referans hazir olsun diye. */
    if (interactive) lastCaptionAreaPx = { x: areaX, y: areaY, w: areaW, h: areaH };

    var list = slotState && slotState.stickers;
    if (!list || !list.length) return;

    list.forEach(function (st, idx) {
      var img = stickerImageCache[st.file];
      if (!img) {
        img = new Image();
        img.crossOrigin = 'anonymous';
        stickerImageCache[st.file] = img;
        img.onload = function () { if (interactive) renderPosterEditorCanvas(); };
        img.src = photoApiBase + '/api/stickers/' + st.file;
        return; /* bu frame'de henuz cizilemez, yuklenince tekrar render edilir */
      }
      if (!img.complete || !img.naturalWidth) return;

      var w = areaW * st.scale;
      var h = w * (img.naturalHeight / img.naturalWidth);
      var cx = areaX + st.x * areaW;
      var cy = areaY + st.y * areaH;
      var left = cx - w / 2, top = cy - h / 2;

      /* Kagidin en altina cok yakin dusmesin (backend'deki draw_stickers ile
         BIREBIR ayni mantik/sabit — WYSIWYG). tmpl.srcH*scale, backend'deki
         canvas.height'in bu render olceğindeki karsiligi. */
      var maxBottom = tmpl.srcH * scale - STICKER_BOTTOM_SAFE_PX * scale;
      if (top + h > maxBottom) top = maxBottom - h;

      ctx.drawImage(img, left, top, w, h);

      var isSelected = interactive && (idx === stickerSelectedIdx);
      if (isSelected) {
        ctx.save();
        ctx.strokeStyle = '#C2872E';
        ctx.lineWidth = 1.5;
        ctx.setLineDash([4, 3]);
        ctx.strokeRect(left, top, w, h);
        ctx.restore();
      }

      if (!interactive) return;

      /* Boyutlandirma artik canvas uzerindeki kucuk bir tutamacla degil,
         fotonun altindaki surguyle yapiliyor (bkz. updateStickerZoomUI) —
         burada sadece TASIMA (hit-test govde) ve SILME (sag-ust rozet)
         icin dikdortgen tutuluyor. */
      var delX = left + w, delY = top;
      stickerHitRects.push({
        idx: idx, left: left, top: top, right: left + w, bottom: top + h,
        delX: delX, delY: delY,
      });

      /* Silme rozeti sadece secili sticker'da cizilir — sekmeyen digerleri
         sade kalir (kalabalik gorunmesin diye). */
      if (isSelected) {
        ctx.save();
        ctx.fillStyle = '#fff';
        ctx.strokeStyle = '#E24B4B';
        ctx.lineWidth = 1.5;
        ctx.beginPath(); ctx.arc(delX, delY, STICKER_DELETE_R, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(delX - 4, delY - 4); ctx.lineTo(delX + 4, delY + 4);
        ctx.moveTo(delX + 4, delY - 4); ctx.lineTo(delX - 4, delY + 4);
        ctx.strokeStyle = '#E24B4B'; ctx.lineWidth = 1.5; ctx.stroke();
        ctx.restore();
      }
    });
  }

  /* Turkce ay adi -> ay numarasi (composite.py'deki TURKISH_MONTHS ile ayni). */
  var TURKISH_MONTHS_JS = {
    'ocak': 1, 'şubat': 2, 'subat': 2, 'mart': 3, 'nisan': 4, 'mayıs': 5, 'mayis': 5,
    'haziran': 6, 'temmuz': 7, 'ağustos': 8, 'agustos': 8, 'eylül': 9, 'eylul': 9,
    'ekim': 10, 'kasım': 11, 'kasim': 11, 'aralık': 12, 'aralik': 12,
  };

  /* JS'in varsayilan .toLowerCase()'i Turkce'ye ozgu degil: "İ" (noktali
     buyuk I) harfini duz "i"ye degil, "i" + BIRLESIK NOKTA (U+0307) isaretine
     ceviriyor — orn. "NİSAN".toLowerCase() "nisan" degil "ni̇san" (6 kod
     noktasi) veriyor, bu da TURKISH_MONTHS_JS'teki "nisan" anahtariyla HIC
     eslesmiyor. Once İ/I harflerini Turkce kuralina gore (İ->i, I->ı) elle
     donusturup SONRA toLowerCase() cagirarak (composite.py'deki _tr_lower
     ile ayni mantik) bunu duzeltiyoruz.
     */
  function _trLowerJs(s) {
    return s.replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase();
  }

  /* Klasik parametrik kalp egrisi — composite.py'deki draw_heart ile ayni
     formul, canvas'ta ICI BOS (sadece cizgi) bir kalp cizer. */
  function drawHeartOnCanvas(ctx, cx, cy, w, h, color, strokeWidth) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = strokeWidth;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.beginPath();
    var steps = 120;
    for (var i = 0; i <= steps; i++) {
      var t = 2 * Math.PI * i / steps;
      var x = 16 * Math.pow(Math.sin(t), 3);
      var y = 13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t);
      var px = cx + (x / 16) * (w / 2);
      var py = cy - (y / 17) * (h / 2);
      if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
    }
    ctx.stroke();
    ctx.restore();
  }

  /* Ani Takvimi Poster (Kalbimdeki Anılar) icin: musterinin sectigi ay/yil'e
     gore gercek takvimi (JS Date ile ayin kac gun ciktigini ve 1'inin haftanin
     hangi gunune denk geldigini hesaplayip) ve secili gunu cerceveleyen kalbi
     canli onizlemede de gosterir — composite.py'deki draw_calendar ile ayni
     mantik, boylece duzenleme ekraninda gordugu ile basilan poster ayni olur. */
  function drawCalendarOnCanvas(ctx, tmpl, scale) {
    var spec = tmpl.calendarSpec;
    if (!spec) return;

    var ayAdi = _trLowerJs((takvimFields.ay || '').trim());
    var yilStr = (takvimFields.yil || '').trim();
    var gunStr = (takvimFields.gun || '').trim();
    var month = TURKISH_MONTHS_JS[ayAdi];
    if (!month || !/^\d+$/.test(yilStr)) return;
    var year = parseInt(yilStr, 10);

    /* JS'in getDay()'i Pazar=0 ile baslar; sablonumuzun sutun sirasi (P S Ç
       P C C P) Pazartesi'den basladigi icin Pazartesi=0 olacak sekilde
       donusturuyoruz (Python'un calendar.monthrange'i ile ayni kural). */
    var jsFirstDay = new Date(year, month - 1, 1).getDay();
    var firstWeekday = (jsFirstDay + 6) % 7;
    var daysInMonth = new Date(year, month, 0).getDate();

    var columnsX = spec.columns_x;
    var rowYStart = spec.week_row_y_start;
    var rowPitch = spec.row_pitch;
    var fontSize = (spec.font_size || 95) * scale;
    var family = "'Montserrat', sans-serif";
    var color = spec.color || '#636363';

    ctx.font = 'bold ' + fontSize + 'px ' + family;
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    var selectedDay = /^\d+$/.test(gunStr) ? parseInt(gunStr, 10) : null;
    var heartCx = null, heartCy = null;

    for (var day = 1; day <= daysInMonth; day++) {
      var offset = firstWeekday + (day - 1);
      var row = Math.floor(offset / 7);
      var col = offset % 7;
      var cx = columnsX[col] * scale;
      var cy = (rowYStart + row * rowPitch) * scale;
      ctx.fillText(String(day), cx, cy);
      if (selectedDay === day) { heartCx = cx; heartCy = cy; }
    }

    if (heartCx !== null) {
      drawHeartOnCanvas(
        ctx, heartCx, heartCy,
        (spec.heart_w || 220) * scale, (spec.heart_h || 200) * scale,
        spec.heart_color || '#E63946', (spec.heart_stroke || 10) * scale
      );
    }
  }

  /* Askin Kalbi Poster: iki ismi (kalpFields.isim1/isim2) aralarina
     area.joiner ("&") koyup hafif bir daire yayi uzerinde cizer — "&" HER
     ZAMAN yayin tam merkezinde sabit kalir (composite.py'deki draw_arc_names
     ile ayni matematik, bkz. orada). */
  function drawArcNamesOnCanvas(ctx, tmpl, scale) {
    var areas = tmpl.textAreas || {};
    var area = null;
    Object.keys(areas).forEach(function (k) { if (areas[k].arc) area = areas[k]; });
    if (!area) return;

    var name1 = (kalpFields.isim1 || '').trim();
    var name2 = (kalpFields.isim2 || '').trim();
    if (!name1 && !name2) return;

    var joiner = area.joiner || ' & ';
    var size = (area.font_size || 96) * scale;
    ctx.font = _posterFontCss(area, size);
    ctx.fillStyle = _posterAreaColor(area);
    ctx.textBaseline = 'alphabetic';
    ctx.textAlign = 'left';

    var radius = (area.arc_radius || 2750) * scale;
    var cx = (area.x + area.w / 2) * scale;
    var baseY = (area.y + area.h / 2) * scale;

    function widthsOf(s) {
      var arr = [];
      for (var i = 0; i < s.length; i++) arr.push(ctx.measureText(s[i]).width);
      return arr;
    }
    function sum(arr) { return arr.reduce(function (a, b) { return a + b; }, 0); }

    var name1W = widthsOf(name1), joinerW = widthsOf(joiner), name2W = widthsOf(name2);
    var halfJoiner = sum(joinerW) / 2;

    function drawRun(chars, widths, startOffset) {
      var pos = startOffset;
      for (var i = 0; i < chars.length; i++) {
        var w = widths[i];
        var arcCenter = pos + w / 2;
        var theta = arcCenter / radius;
        var x = cx + radius * Math.sin(theta);
        var y = baseY + radius * (1 - Math.cos(theta));
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(theta);
        ctx.fillText(chars[i], -w / 2, 0);
        ctx.restore();
        pos += w;
      }
    }

    drawRun(name1.split(''), name1W, -halfJoiner - sum(name1W));
    drawRun(joiner.split(''), joinerW, -halfJoiner);
    drawRun(name2.split(''), name2W, halfJoiner);
  }

  /* ani_takvimi_poster gibi COK KUCUK, COK SAYIDA (27 tane, 300x300) ayni
     boyutlu slotu olan sablonlarda, editor canvas'i her zaman TUM posteri
     (3508x4961) 220-250px'e sigdirdigi icin tek bir foto alani ekranda
     sadece ~15-20px kaliyordu — kadraj/konum ayarlamak pratik olarak
     imkansizdi. Bu sablonlarda editor, TUM poster yerine SADECE o an
     duzenlenen foto alaninin (biraz kenar payiyla) YAKINLASTIRILMIS halini
     gosterir (bkz. drawPosterCanvasFrame'deki zoomToSlot). */
  /* askin_kalbi_poster BURADA KASITLI OLARAK YOK: musteri geri bildirimiyle
     (tiklayinca yakinlastirma sistemini sevmedi) bu urun icin buyuk-sablon +
     tam-ekran-secim-penceresi deneyimine (bkz. usesBigCanvasPicker) gecildi —
     zoom orada artik kullanilmiyor. */
  var ZOOM_SLOT_EDITOR_TEMPLATE_IDS = [
    'ani_takvimi_poster', 'ani_takvimi_poster_a4', 'ani_takvimi_poster_a5',
  ];
  function shouldZoomSlotEditor() {
    return ZOOM_SLOT_EDITOR_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1;
  }

  function getSlotForIdx(tmpl, slotIdx) {
    /* Coklu sabit foto alanli sablonlarda (orn. 5x20 kitap ayraci — 4 alan)
       her foto, sirasina gore (slotIdx % grup boyutu) dogru fiziksel konuma
       yerlesir; tek slotlu sablonlarda (afis/palo-kart/tekli foto-kart)
       zaten tek eleman oldugu icin her zaman ayni konuma duser. */
    return (tmpl.slots && tmpl.slots.length)
      ? tmpl.slots[(slotIdx || 0) % tmpl.slots.length]
      : tmpl.slot;
  }

  /* Yakinlastirilmis (zoomToSlot) editorde, o an duzenlenen foto alaninin
     etrafina biraz kenar payi (kalp/cerceve gibi komsu gorsel ogeler de
     gorunsun diye) birakip SADECE o bolgeyi kirpar. drawPosterCanvasFrame
     ve renderPosterEditorCanvas'in AYNI kirpma dikdortgenini kullanmasi
     gerekiyor (biri cizim, digeri surukleme-hassasiyeti icin) — bu yuzden
     tek bir yerden hesaplaniyor. */
  function computeZoomCropRect(tmpl, s) {
    var pad = Math.max(s.width, s.height) * 0.35;
    var cropX = Math.max(0, s.x - pad);
    var cropY = Math.max(0, s.y - pad);
    var cropW = Math.min(tmpl.srcW - cropX, s.width + pad * 2);
    var cropH = Math.min(tmpl.srcH - cropY, s.height + pad * 2);
    return { cropX: cropX, cropY: cropY, cropW: cropW, cropH: cropH };
  }

  function drawPosterCanvasFrame(canvas, tmpl, slotState, CW, CH, slotIdx, zoomToSlot, stickersInteractive) {
    var s = getSlotForIdx(tmpl, slotIdx);

    var scale, cropX = 0, cropY = 0, cropW = tmpl.srcW, cropH = tmpl.srcH;
    if (zoomToSlot) {
      var rect = computeZoomCropRect(tmpl, s);
      cropX = rect.cropX; cropY = rect.cropY; cropW = rect.cropW; cropH = rect.cropH;
      scale = CW / cropW;
      CH = Math.round(CW * cropH / cropW);
    } else {
      scale = CW / tmpl.srcW;
    }
    canvas.width = CW; canvas.height = CH;
    var ctx = canvas.getContext('2d');

    function drawBgOrFg(img) {
      if (zoomToSlot) ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, CW, CH);
      else ctx.drawImage(img, 0, 0, CW, CH);
    }

    function drawRest() {
      drawBgOrFg(tmpl.fg);
      if (!zoomToSlot) {
        drawPosterTextAreas(ctx, tmpl, scale);
        drawCaptionOnCanvas(ctx, tmpl, scale, slotState);
        drawStickersOnCanvas(ctx, tmpl, scale, slotState, !!stickersInteractive);
        drawCalendarOnCanvas(ctx, tmpl, scale);
        drawArcNamesOnCanvas(ctx, tmpl, scale);
      }
    }

    ctx.clearRect(0, 0, CW, CH);
    drawBgOrFg(tmpl.bg);

    if (slotState && slotState.dataUrl) {
      var sx = (s.x - cropX) * scale, sy = (s.y - cropY) * scale, sw = s.width * scale, sh = s.height * scale;

      var drawPhoto = function (img) {
        ctx.save();
        ctx.beginPath(); ctx.rect(sx, sy, sw, sh); ctx.clip();

        var naturalW = slotState.naturalW || img.naturalWidth || 1;
        var naturalH = slotState.naturalH || img.naturalHeight || 1;
        var fitScale = Math.max(sw / naturalW, sh / naturalH);
        var dw = naturalW * fitScale, dh = naturalH * fitScale;
        var ox = (slotState.offX || 0) * (sw / (slotState.frameW || posterFrameW));
        var oy = (slotState.offY || 0) * (sh / (slotState.frameH || posterFrameH));
        var dx = sx + sw / 2 - dw / 2 + ox;
        var dy = sy + sh / 2 - dh / 2 + oy;
        ctx.drawImage(img, dx, dy, dw, dh);
        ctx.restore();
        drawRest();
      };

      /* Fotograf her cizimde YENIDEN bir Image() olusturup onload beklemek,
         surukleme sirasinda (her mousemove bir render tetikler) her karede
         kisa bir "fotosuz" bosluk yaratip goz yoran bir beyaz yanip-sonme
         etkisi olusturuyordu. Ayni dataUrl icin yuklenmis Image nesnesini
         slot durumunda onbelleklenip sonraki cizimlerde onload beklemeden
         hemen cizerek bunu ortadan kaldiriyoruz. */
      if (slotState._cachedImg && slotState._cachedImgSrc === slotState.dataUrl) {
        drawPhoto(slotState._cachedImg);
      } else {
        var img = new Image();
        img.onload = function () {
          slotState._cachedImg = img;
          slotState._cachedImgSrc = slotState.dataUrl;
          drawPhoto(img);
        };
        img.src = slotState.dataUrl;
      }
    } else {
      drawRest();
    }
  }

  /* Coklu sabit foto alanli sablonlarda (orn. 5x20 — 4 alan) TUM grup
     alanlarini TEK canvas'ta ayni anda cizer: doluysa fotografi, bosta ise
     tikanabilir oldugunu belli eden kesikli bir "+" yer tutucusu gosterir. */
  function drawGroupedCanvasFrame(canvas, tmpl, groupSlotStates, CW, CH, activeIdx, usePreview, zoomActive) {
    var slotDefs = tmpl.slots || [tmpl.slot];
    var zoomSlot = (zoomActive && typeof activeIdx === 'number' && activeIdx >= 0) ? slotDefs[activeIdx] : null;

    var scale, cropX = 0, cropY = 0, cropW = tmpl.srcW, cropH = tmpl.srcH;
    if (zoomSlot) {
      var rect = computeZoomCropRect(tmpl, zoomSlot);
      cropX = rect.cropX; cropY = rect.cropY; cropW = rect.cropW; cropH = rect.cropH;
      scale = CW / cropW;
      CH = Math.round(CW * cropH / cropW);
    } else {
      scale = CW / tmpl.srcW;
    }
    canvas.width = CW; canvas.height = CH;
    var ctx = canvas.getContext('2d');

    /* posterFrameW/H = AKTIF slotun (surukleme sirasinda konumlandirilan
       fotografin ait oldugu alanin) GERCEK ekran-CSS-piksel boyutu —
       getPosterPanBounds/ox-oy hesaplarinin dogru calismasi icin sarttir.
       Onceden sabit "220px CSS genislik" varsayiliyordu; bu hem farkli
       boyutlu alanlari olan sablonlarda (Askin Kalbi'nin 380-1200px arasi
       degisen alanlari gibi) HER ZAMAN yanlisti, hem de canvas'in kendisi
       artik duyarli (responsive, orn. "min(94vw,640px)") bir genislikte
       gosterilebildigi icin (buyuk-sablon deneyimi) sabit bir sayiyla hic
       tutmuyordu — musteri fotografi asagi/yana fazla surukleyince
       kutunun disinda beyaz alan gorunmesinin sebebi tam olarak buydu.
       Artik canvas'in GERCEKTEN ekranda kapladigi CSS genisligini
       (getBoundingClientRect) olcup, o an aktif olan slotun (ya da hicbiri
       secili degilse ilk slotun) boyutuna orantiliyoruz. */
    var displayedCssW = canvas.getBoundingClientRect().width || CW;
    var refSlot = (typeof activeIdx === 'number' && activeIdx >= 0 && slotDefs[activeIdx]) ? slotDefs[activeIdx] : tmpl.slot;
    if (zoomSlot) {
      var cssPxPerPosterPx = displayedCssW / cropW;
      posterFrameW = zoomSlot.width * cssPxPerPosterPx;
      posterFrameH = zoomSlot.height * cssPxPerPosterPx;
    } else {
      var cssPxPerPosterPxFull = displayedCssW / tmpl.srcW;
      posterFrameW = refSlot.width * cssPxPerPosterPxFull;
      posterFrameH = refSlot.height * cssPxPerPosterPxFull;
    }

    function drawBgOrFg(img) {
      if (zoomSlot) ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, CW, CH);
      else ctx.drawImage(img, 0, 0, CW, CH);
    }

    ctx.clearRect(0, 0, CW, CH);
    drawBgOrFg(tmpl.bg);

    function drawPlaceholder(s) {
      var sx = (s.x - cropX) * scale, sy = (s.y - cropY) * scale, sw = s.width * scale, sh = s.height * scale;
      ctx.save();
      ctx.fillStyle = 'rgba(30,42,68,0.06)';
      ctx.fillRect(sx, sy, sw, sh);
      ctx.strokeStyle = 'rgba(30,42,68,0.35)';
      ctx.setLineDash([7, 6]);
      ctx.lineWidth = 2;
      ctx.strokeRect(sx + 3, sy + 3, sw - 6, sh - 6);
      ctx.fillStyle = 'rgba(30,42,68,0.45)';
      ctx.font = '700 ' + Math.max(20, sh * 0.22) + 'px sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('+', sx + sw / 2, sy + sh / 2);
      ctx.restore();
    }

    function drawActiveHighlight() {
      if (typeof activeIdx !== 'number' || activeIdx < 0 || !slotDefs[activeIdx]) return;
      var s = slotDefs[activeIdx];
      var sx = (s.x - cropX) * scale, sy = (s.y - cropY) * scale, sw = s.width * scale, sh = s.height * scale;
      ctx.save();
      /* Secili alanin belirginligini artirmak icin: koyu bir dis kontur +
         parlak turuncu bir ic kontur + hafif bir parlama (glow) — tek renkli
         ince cizgi arka plana gore bazen kaybolabiliyordu. */
      ctx.shadowColor = 'rgba(194,135,46,0.9)';
      ctx.shadowBlur = 14;
      ctx.strokeStyle = '#1E2A44';
      ctx.lineWidth = 8;
      ctx.strokeRect(sx + 3, sy + 3, sw - 6, sh - 6);
      ctx.shadowBlur = 0;
      ctx.strokeStyle = '#FFA733';
      ctx.lineWidth = 4;
      ctx.strokeRect(sx + 3, sy + 3, sw - 6, sh - 6);
      ctx.restore();
    }

    function drawFinish() {
      drawBgOrFg(tmpl.fg);
      /* Google Arama Poster gibi urunlerde arama/isim metinleri, Ani Takvimi
         posterinde ise ay/yil + dinamik takvim/kalp de grup onizlemesinde
         (grid karesi, grup ekrani, son onizleme) gorunsun —
         drawPosterCanvasFrame'in tek-slotlu esdegeriyle ayni cizim. Zoomlu
         grup gorunumunde (sadece tek slot gorunurken) bu ustyaziler tum
         poster varsayimiyla konumlandigi icin (orn. takvim y~3300 iken
         yakinlastirilan foto y~500 olabilir) atlanir — tek-slot editorundeki
         zoomToSlot mantigiyla ayni. */
      if (!zoomSlot) {
        drawPosterTextAreas(ctx, tmpl, scale);
        drawCaptionOnCanvas(ctx, tmpl, scale, groupSlotStates[0]);
        drawCalendarOnCanvas(ctx, tmpl, scale);
        drawArcNamesOnCanvas(ctx, tmpl, scale);
      }
      drawActiveHighlight();
    }

    var toLoad = [];
    slotDefs.forEach(function (s, idx) {
      var slotState = groupSlotStates[idx];
      if (slotState && slotState.dataUrl) toLoad.push({ s: s, slotState: slotState });
      else drawPlaceholder(s);
    });

    if (!toLoad.length) { drawFinish(); return; }

    var remaining = toLoad.length;
    toLoad.forEach(function (entry) {
      var s = entry.s, slotState = entry.slotState;
      var sx = (s.x - cropX) * scale, sy = (s.y - cropY) * scale, sw = s.width * scale, sh = s.height * scale;

      function drawPhoto(img) {
        ctx.save();
        ctx.beginPath(); ctx.rect(sx, sy, sw, sh); ctx.clip();
        var naturalW = slotState.naturalW || img.naturalWidth || 1;
        var naturalH = slotState.naturalH || img.naturalHeight || 1;
        var fitScale = Math.max(sw / naturalW, sh / naturalH);
        var dw = naturalW * fitScale, dh = naturalH * fitScale;
        var ox = (slotState.offX || 0) * (sw / (slotState.frameW || posterFrameW));
        var oy = (slotState.offY || 0) * (sh / (slotState.frameH || posterFrameH));
        var dx = sx + sw / 2 - dw / 2 + ox;
        var dy = sy + sh / 2 - dh / 2 + oy;
        ctx.drawImage(img, dx, dy, dw, dh);
        ctx.restore();
        remaining--;
        if (remaining === 0) drawFinish();
      }

      /* Onizleme (kucuk, hizli) ve tam cozunurluk (buyutulmus/zoom) icin ayri
         cache alanlari — biri diger baglami "kirletmesin" diye ayri tutuluyor. */
      var srcUrl = (usePreview && slotState.previewDataUrl) ? slotState.previewDataUrl : slotState.dataUrl;
      var cachedImgKey = usePreview ? '_cachedImgPreview' : '_cachedImg';
      var cachedSrcKey = usePreview ? '_cachedImgPreviewSrc' : '_cachedImgSrc';

      if (slotState[cachedImgKey] && slotState[cachedSrcKey] === srcUrl) {
        drawPhoto(slotState[cachedImgKey]);
      } else {
        var img = new Image();
        img.onload = function () {
          slotState[cachedImgKey] = img;
          slotState[cachedSrcKey] = srcUrl;
          drawPhoto(img);
        };
        img.src = srcUrl;
      }
    });
  }

  var ZOOM_EDITOR_CSS_WIDTH = 380;

  function renderPosterEditorCanvas() {
    if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) === -1) return;
    var canvas = q('#iz-bld-poster-editor-canvas', modalEl);
    if (!canvas || editIdx < 0 || !slots[editIdx]) return;
    var slotState = slots[editIdx];
    var zoom = shouldZoomSlotEditor();
    /* ani_takvimi_poster gibi 27 kucuk esit-boy alanli sablonlarda, kadraji
       rahat ayarlayabilmek icin editor canvas'ini hem YAKINLASTIRIP (crop)
       hem de ekranda GERCEKTEN daha buyuk gostererek acik ara buyutuyoruz;
       diger (tek/az slotlu) sablonlar mevcut 220px goruntuleme boyutunu korur. */
    if (zoom) canvas.style.width = ZOOM_EDITOR_CSS_WIDTH + 'px';
    loadPosterTemplateAssets(function (tmplPortrait) {
    resolveTmplForSlot(tmplPortrait, slotState, function (tmpl) {
      if (tmpl.captionArea && captionInput) captionInput.maxLength = tmpl.captionArea.max_chars || 40;
      if (zoom) {
        /* Suruklerken fare hareketi CSS-piksel cinsinden birikiyor
           (bkz. onMove); bu deger daha sonra hem onizlemede (drawPosterCanvasFrame
           icindeki ox/oy) hem de surukleme sinirlarinda (getPosterPanBounds)
           posterFrameW/H'e bolunerek yorumlaniyor. Yakinlastirilmis modda foto
           alani ekranda cok daha buyuk gorundugu icin bu iki degeri de
           GERCEK ekran-piksel boyutuna guncellemezsek surukleme asiri
           hassas/tutarsiz olur. Suruklerken bu deger otomatik olarak slotun
           kendisine de kaydedilir (bkz. setupPosterPhotoPan/onDown), boylece
           nihai baski kirpma hesabi (computeCropForSlot) da AYNI dogru
           referansi kullanir. */
        var s = getSlotForIdx(tmpl, editIdx);
        var rect = computeZoomCropRect(tmpl, s);
        var cssPxPerPosterPx = ZOOM_EDITOR_CSS_WIDTH / rect.cropW;
        posterFrameW = s.width * cssPxPerPosterPx;
        posterFrameH = s.height * cssPxPerPosterPx;
      } else if (tmpl.srcW > tmpl.srcH) {
        /* Yatay sablon (yon-uyumlu urunde yatay foto secilince): sabit
           genislik yerine sabit YUKSEKLIK kullanip genisligi otomatik
           birakiyoruz — yoksa dikey kartla ayni 220px genislige sikisip
           cok daha kisa/kucuk gorunuyordu. posterFrameW/H de ayni oranla
           (roller yer degistirmis halde) hesaplanir, boylece surukleme
           hassasiyeti dikey kartla birebir ayni kalir. */
        posterFrameH = 220;
        posterFrameW = Math.round(220 * (tmpl.slot.width / tmpl.slot.height));
        canvas.style.width = 'auto';
        canvas.style.height = '220px';
      } else {
        posterFrameW = 220;
        posterFrameH = Math.round(220 / (tmpl.slot.width / tmpl.slot.height));
        canvas.style.width = '220px';
        canvas.style.height = '';
      }
      drawPosterCanvasFrame(canvas, tmpl, slotState, 700, Math.round(700 * tmpl.srcH / tmpl.srcW), editIdx, zoom, true);
      updateStickerZoomUI(slotState);
    });
    });
  }

  /* posterFrameW/H (global) her sablon/an icin ayni degeri tasimaz — Askin
     Kalbi gibi FARKLI boyutlu alanlari olan gruplu sablonlarda, ve buyuk-
     sablon deneyiminde (duyarli/vw-tabanli CSS genislik) her render'da
     DEGISEBILIR. Bu yuzden bir slot GERCEKTEN suruklenirken (offX/offY
     degistiginde) o ANKI dogru referansi (slotState.frameW/frameH) SLOTUN
     KENDISINE kaydediyoruz — boylece sonradan (baska bir slot secilip
     global deger degismis olsa bile, ya da son onizleme/kucuk resim gibi
     FARKLI bir canvas boyutunda tekrar cizilirken) HER ZAMAN o slotun
     GERCEKTEN suruklendigi andaki dogru olcekle yorumlanir — aksi halde
     musteri fotografi asagi/yana suruklediginde, farkli bir baglamda
     (kucuk resim, son onizleme, baski kirpma hesabi) yanlis olceklenip
     kutunun disinda beyaz alan gorunmesine ya da yanlis kirpilmasina yol acar. */
  function getPosterPanBounds(slotState) {
    var fw = slotState.frameW || posterFrameW;
    var fh = slotState.frameH || posterFrameH;
    var naturalW = slotState.naturalW || fw;
    var naturalH = slotState.naturalH || fh;
    var scale = Math.max(fw / naturalW, fh / naturalH);
    var iw = naturalW * scale, ih = naturalH * scale;
    return {
      maxX: Math.max(0, (iw - fw) / 2),
      maxY: Math.max(0, (ih - fh) / 2),
    };
  }

  /* Canvas-BITMAP uzayinda tiklanan noktayi dondurur (CSS ekran boyutu ile
     bitmap cozunurlugu farkli olabilir — orn. mobilde canvas kucuk gosterilir
     ama bitmap hep 700px genisliginde uretilir). stickerHitRects hep bitmap
     uzayinda oldugu icin hit-test'in de ayni uzayda yapilmasi gerekir. */
  function canvasPointFromEvent(e) {
    var canvas = q('#iz-bld-poster-editor-canvas', modalEl);
    if (!canvas) return null;
    var rect = canvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    var xy = getXY(e);
    var scaleX = canvas.width / rect.width;
    var scaleY = canvas.height / rect.height;
    return { x: (xy[0] - rect.left) * scaleX, y: (xy[1] - rect.top) * scaleY };
  }

  function hitTestStickerDelete(pt) {
    if (!pt) return -1;
    for (var i = 0; i < stickerHitRects.length; i++) {
      var r = stickerHitRects[i];
      if (r.idx !== stickerSelectedIdx) continue;
      if (Math.hypot(pt.x - r.delX, pt.y - r.delY) <= STICKER_DELETE_R * 1.7) return r.idx;
    }
    return -1;
  }

  function hitTestStickerBody(pt) {
    if (!pt) return -1;
    /* En son eklenen/en ustte cizilen sticker ONCE kontrol edilsin diye
       TERSTEN tarar. */
    for (var i = stickerHitRects.length - 1; i >= 0; i--) {
      var r = stickerHitRects[i];
      if (pt.x >= r.left && pt.x <= r.right && pt.y >= r.top && pt.y <= r.bottom) return r.idx;
    }
    return -1;
  }

  function isPointOnAnySticker(pt) {
    return hitTestStickerDelete(pt) !== -1 || hitTestStickerBody(pt) !== -1;
  }

  var stickerDrag = { mode: null, idx: -1, sx: 0, sy: 0, startX: 0, startY: 0 };

  function setupStickerInteraction() {
    function isCanvasTarget(e) {
      return e.target && e.target.id === 'iz-bld-poster-editor-canvas';
    }
    function onDown(e) {
      if (!isCanvasTarget(e)) return;
      var slot = slots[editIdx];
      if (!slot || !slot.stickers || !slot.stickers.length) return;
      var pt = canvasPointFromEvent(e);
      if (!pt) return;

      var delIdx = hitTestStickerDelete(pt);
      if (delIdx !== -1) {
        e.preventDefault();
        slot.stickers.splice(delIdx, 1);
        stickerSelectedIdx = -1;
        updateStickerCountBadge();
        renderPosterEditorCanvas();
        return;
      }

      var bodyIdx = hitTestStickerBody(pt);
      if (bodyIdx !== -1) {
        e.preventDefault();
        stickerSelectedIdx = bodyIdx;
        stickerDrag.mode = 'move';
        stickerDrag.idx = bodyIdx;
        stickerDrag.sx = pt.x; stickerDrag.sy = pt.y;
        stickerDrag.startX = slot.stickers[bodyIdx].x;
        stickerDrag.startY = slot.stickers[bodyIdx].y;
        renderPosterEditorCanvas();
        return;
      }

      /* Bos alana tiklandi: secim kaldirilir (fotograf pan'i normal calismaya
         devam eder — burada preventDefault/return yapmiyoruz). */
      if (stickerSelectedIdx !== -1) {
        stickerSelectedIdx = -1;
        renderPosterEditorCanvas();
      }
    }

    function onMove(e) {
      if (stickerDrag.mode !== 'move') return;
      var slot = slots[editIdx];
      var st = slot && slot.stickers[stickerDrag.idx];
      if (!st) { stickerDrag.mode = null; return; }
      var pt = canvasPointFromEvent(e);
      if (!pt) return;

      var dxNorm = (pt.x - stickerDrag.sx) / lastCaptionAreaPx.w;
      var dyNorm = (pt.y - stickerDrag.sy) / lastCaptionAreaPx.h;
      st.x = clamp(stickerDrag.startX + dxNorm, 0, 1);
      st.y = clamp(stickerDrag.startY + dyNorm, 0, 1);
      renderPosterEditorCanvas();
      e.preventDefault();
    }

    function onUp() { stickerDrag.mode = null; }

    document.addEventListener('mousedown',  onDown);
    document.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove',  onMove);
    document.addEventListener('touchmove',  onMove, { passive: false });
    document.addEventListener('mouseup',    onUp);
    document.addEventListener('touchend',   onUp);
  }

  function setupPosterPhotoPan() {
    function isCanvasTarget(e) {
      return e.target && e.target.id === 'iz-bld-poster-editor-canvas';
    }
    function onDown(e) {
      if (!isCanvasTarget(e)) return;
      var slotState = slots[editIdx];
      if (!slotState || !slotState.dataUrl) return;
      /* Tiklanan nokta bir sticker'in/tutamacinin uzerindeyse fotografi
         degil sticker'i surukleriz — setupStickerInteraction devralir. */
      if (isPointOnAnySticker(canvasPointFromEvent(e))) return;
      var xy = getXY(e);
      posterDrag.on = true;
      posterDrag.sx = xy[0]; posterDrag.sy = xy[1];
      posterDrag.bx = slotState.offX || 0; posterDrag.by = slotState.offY || 0;
      /* Bu surukleme oturumunun GERCEK referansini (o an dogru hesaplanmis
         posterFrameW/H) slotun kendisine kaydet — bkz. yukaridaki not. */
      slotState.frameW = posterFrameW; slotState.frameH = posterFrameH;
      e.preventDefault();
    }
    function onMove(e) {
      if (!posterDrag.on) return;
      var slotState = slots[editIdx];
      if (!slotState) return;
      var xy = getXY(e);
      var dx = xy[0] - posterDrag.sx + posterDrag.bx;
      var dy = xy[1] - posterDrag.sy + posterDrag.by;
      var b = getPosterPanBounds(slotState);
      slotState.offX = clamp(dx, -b.maxX, b.maxX);
      slotState.offY = clamp(dy, -b.maxY, b.maxY);
      renderPosterEditorCanvas();
      e.preventDefault();
    }
    function onUp() { posterDrag.on = false; }

    document.addEventListener('mousedown',  onDown);
    document.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove',  onMove);
    document.addEventListener('touchmove',  onMove, { passive: false });
    document.addEventListener('mouseup',    onUp);
    document.addEventListener('touchend',   onUp);
  }

  function updateCaptionPreview() {
    // The saved photo state is the source for final/zoom previews and print properties.
    var limit = captionInput.maxLength;
    if (limit > 0) captionInput.value = captionInput.value.slice(0, limit);
    if (editIdx >= 0 && slots[editIdx]) slots[editIdx].caption = captionInput.value;
    var cap = captionInput.value.trim();
    captionPreview.textContent = cap || 'Not ekle…';
    captionPreview.style.color = cap ? 'var(--iz-ink,#1E2A44)' : '#aaa';
    captionPreview.style.fontFamily = fontSelect.value;
  }

  /* ─────────────────────────────────────────────── */
  /*  Custom font picker                               */
  /* ─────────────────────────────────────────────── */
  function buildFontPicker() {
    if (!fontListEl) return;
    FONTS.forEach(function (f) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'iz-bld__font-opt';
      btn.setAttribute('data-value', f.v);
      btn.setAttribute('role', 'option');
      btn.style.fontFamily = f.v;
      btn.textContent = f.l;
      btn.addEventListener('click', function () {
        setFontPicker(f.v, true);
        closeFontPicker();
      });
      fontListEl.appendChild(btn);
    });

    var trigBtn = q('#iz-bld-font-btn', modalEl);
    if (trigBtn) {
      trigBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (fontListEl.hidden) openFontPicker(); else closeFontPicker();
      });
    }
    setFontPicker(FONTS[0].v, false);
  }

  function openFontPicker() {
    if (!fontListEl) return;
    fontListEl.hidden = false;
    var b = q('#iz-bld-font-btn', modalEl);
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  function closeFontPicker() {
    if (!fontListEl) return;
    fontListEl.hidden = true;
    var b = q('#iz-bld-font-btn', modalEl);
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  /* writeBack=true → also save to current slot; false → display only (loading slot) */
  function setFontPicker(fontValue, writeBack) {
    var f = null;
    for (var i = 0; i < FONTS.length; i++) { if (FONTS[i].v === fontValue) { f = FONTS[i]; break; } }
    if (!f) f = FONTS[0];

    if (fontSelect)     fontSelect.value = f.v;
    if (fontBtnLabelEl) { fontBtnLabelEl.textContent = f.l; fontBtnLabelEl.style.fontFamily = f.v; }

    /* Active state inside list */
    if (fontListEl) {
      var opts = fontListEl.querySelectorAll('.iz-bld__font-opt');
      for (var j = 0; j < opts.length; j++) {
        opts[j].classList.toggle('iz-bld__font-opt--active', opts[j].getAttribute('data-value') === f.v);
      }
    }

    var fp = q('#iz-bld-font-preview', modalEl);
    if (fp) fp.style.fontFamily = f.v;

    captionPreview.style.fontFamily = f.v;

    if (writeBack && editIdx >= 0 && slots[editIdx]) {
      slots[editIdx].font = f.v;
      if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1) renderPosterEditorCanvas();
    }
  }

  function saveCurrentSlot() {
    if (editIdx < 0 || !slots[editIdx]) return;
    updateCaptionPreview();
    slots[editIdx].caption = captionInput.value;
    slots[editIdx].font    = fontSelect.value;

    if (productType === 'netflix-poster-tablo') {
      var pIsim = q('#iz-bld-poster-isim', modalEl), pBaslik = q('#iz-bld-poster-baslik', modalEl);
      var pHikaye = q('#iz-bld-poster-hikaye', modalEl), pTur = q('#iz-bld-poster-tur', modalEl);
      slots[editIdx].posterIsim   = pIsim   ? pIsim.value.trim()   : '';
      slots[editIdx].posterBaslik = pBaslik ? pBaslik.value.trim() : '';
      slots[editIdx].posterHikaye = pHikaye ? pHikaye.value.trim() : '';
      slots[editIdx].posterTur    = pTur    ? pTur.value.trim()    : '';
    }
  }

  function validatePosterFields() {
    if (productType !== 'netflix-poster-tablo') return true;
    var errEl = q('#iz-bld-poster-err', modalEl);
    var isim = q('#iz-bld-poster-isim', modalEl), baslik = q('#iz-bld-poster-baslik', modalEl);
    var hikaye = q('#iz-bld-poster-hikaye', modalEl), tur = q('#iz-bld-poster-tur', modalEl);
    var ok = isim && isim.value.trim() && baslik && baslik.value.trim() &&
             hikaye && hikaye.value.trim() && tur && tur.value.trim();
    if (errEl) errEl.style.display = ok ? 'none' : '';
    return !!ok;
  }

  function confirmEdit() {
    if (!validatePosterFields()) return;
    saveCurrentSlot();

    var confirmedIdx = editIdx;
    if (slots[confirmedIdx]) {
      slots[confirmedIdx].done = true;
      /* Düzenlenmiş küçük önizleme oluştur — grid'de güncel hali gösterilsin */
      generateSlotThumb(slots[confirmedIdx], function (thumbUrl) {
        if (thumbUrl && slots[confirmedIdx]) {
          slots[confirmedIdx].thumbDataUrl = thumbUrl;
          /* Şu an grid fazındaysak anında güncelle */
          if (phaseEls.grid && phaseEls.grid.style.display !== 'none') {
            buildGrid();
          }
        }
      });
    }

    if (editIdx < slots.length - 1) {
      /* Sonraki slota geç */
      editIdx++;
      loadEditorSlot(editIdx);
    } else {
      /* Tümü tamamlandı — grid'e dön */
      buildGrid();
      showPhase('grid');
    }
  }

  function editorGoNext() {
    saveCurrentSlot();
    if (editIdx < slots.length - 1) {
      editIdx++;
      loadEditorSlot(editIdx);
    }
  }

  /* ─────────────────────────────────────────────── */
  /*  Phase 4: Final preview                          */
  /* ─────────────────────────────────────────────── */
  function updatePreviewText() {
    updatePreviewName();
    var pvwSong   = q('#iz-pvw-song',   modalEl);
    var pvwArtist = q('#iz-pvw-artist', modalEl);
    if (pvwSong)   pvwSong.textContent   = spotifyTitle  || 'Şarkı Adı';
    if (pvwArtist) pvwArtist.textContent = spotifyArtist || 'Sanatçı';
    if (spotifyTrackId) {
      var bImg = q('#iz-pvw-barcode', modalEl);
      if (bImg) { bImg.src = 'https://scannables.scdn.co/uri/plain/jpeg/000000/white/640/spotify:track:' + spotifyTrackId; bImg.style.display = ''; }
    }
    var pvwWrap = q('#iz-bld-poster-preview-wrap', modalEl);
    if (pvwWrap && pvwWrap.style.display !== 'none') renderMuzikPreview();
  }

  /* ── Müzik posteri önizlemesi ── */
  function renderMuzikPreview() {
    var wrap = q('#iz-bld-poster-preview-wrap', modalEl);
    if (!wrap) return;
    wrap.style.display = 'block';

    var overlay = q('#iz-bld-preview-overlay', modalEl);
    if (overlay) overlay.style.display = 'none';

    var active = slots.filter(function (s) { return s.dataUrl; });
    var canvas = q('#iz-bld-preview-canvas', modalEl);
    if (!canvas || !active.length) return;
    var slot = active[0];

    var CW = 630, CH = 891;
    canvas.width = CW; canvas.height = CH;
    var ctx = canvas.getContext('2d');

    var pxmm = CW / 297;
    function px(mm) { return mm * pxmm; }

    var PL = px(46.9), PT = px(53.8), PW = px(203.2), PH = px(203.2);
    var BG = '#183e83';
    var FONT = 'Montserrat, Arial, sans-serif';
    var chromeUrl = (window.IZ_MUZIK_CHROME) || '';

    function drawBlurredBg(srcImg) {
      try { ctx.filter = 'blur(22px) brightness(0.45)'; } catch(e) {}
      var sc2 = Math.max(CW / srcImg.naturalWidth, CH / srcImg.naturalHeight) * 1.25;
      var iw = srcImg.naturalWidth * sc2, ih = srcImg.naturalHeight * sc2;
      ctx.drawImage(srcImg, (CW-iw)/2, (CH-ih)/2, iw, ih);
      try { ctx.filter = 'none'; } catch(e) {}
    }

    function drawGradient(c1, c2, horiz) {
      var grd = horiz ? ctx.createLinearGradient(0,0,CW,CH) : ctx.createLinearGradient(0,0,0,CH);
      grd.addColorStop(0, c1); grd.addColorStop(1, c2);
      ctx.fillStyle = grd; ctx.fillRect(0, 0, CW, CH);
    }

    /* Üst bar ve alt kontroller için koyu degrade — chrome öğeleri okunabilir olsun */
    function drawDarkOverlays() {
      var hg = ctx.createLinearGradient(0, 0, 0, px(58));
      hg.addColorStop(0, 'rgba(0,0,0,0.60)');
      hg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = hg; ctx.fillRect(0, 0, CW, px(58));

      var cg = ctx.createLinearGradient(0, px(302), 0, CH);
      cg.addColorStop(0, 'rgba(0,0,0,0)');
      cg.addColorStop(0.15, 'rgba(0,0,0,0.55)');
      cg.addColorStop(1,    'rgba(0,0,0,0.70)');
      ctx.fillStyle = cg; ctx.fillRect(0, px(302), CW, CH - px(302));
    }

    function drawChromeOverlay(cb) {
      if (!chromeUrl) { cb(); return; }
      var cImg = new Image(); cImg.crossOrigin = 'anonymous';
      cImg.onload  = function () { ctx.drawImage(cImg, 0, 0, CW, CH); cb(); };
      cImg.onerror = cb;
      cImg.src = chromeUrl;
    }

    function drawContent() {
      drawDarkOverlays();
      drawChromeOverlay(function () {
        /* Müşteri fotoğrafı — yuvarlak köşeli kare */
        var uImg = new Image();
        uImg.onload = function () {
          var r = PW * 0.032;
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(PL+r,PT); ctx.lineTo(PL+PW-r,PT); ctx.arcTo(PL+PW,PT,PL+PW,PT+r,r);
          ctx.lineTo(PL+PW,PT+PH-r); ctx.arcTo(PL+PW,PT+PH,PL+PW-r,PT+PH,r);
          ctx.lineTo(PL+r,PT+PH); ctx.arcTo(PL,PT+PH,PL,PT+PH-r,r);
          ctx.lineTo(PL,PT+r); ctx.arcTo(PL,PT,PL+r,PT,r); ctx.closePath();
          ctx.clip();
          var sc2 = Math.max(PW / uImg.naturalWidth, PH / uImg.naturalHeight);
          var iw = uImg.naturalWidth*sc2, ih = uImg.naturalHeight*sc2;
          ctx.drawImage(uImg, PL+(PW-iw)/2, PT+(PH-ih)/2, iw, ih);
          ctx.restore();

          /* Müşteri ismi — üst çubuk */
          var noName = q('#iz-bld-no-name', modalEl);
          if (posterName && (!noName || !noName.checked)) {
            ctx.font = 'bold ' + Math.round(px(3.5)) + 'px ' + FONT;
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(posterName, CW/2, px(35.5));
            ctx.textBaseline = 'alphabetic';
          }

          /* Şarkı adı — tek satır, otomatik küçülen font */
          var songTop = PT + PH + px(5);
          var MAX_SPX = Math.round(px(12.5)); /* ≈ 37pt @A3 */
          var MIN_SPX = 12;
          var spx = MAX_SPX;
          if (spotifyTitle) {
            ctx.font = 'bold ' + spx + 'px ' + FONT;
            while (ctx.measureText(spotifyTitle).width > PW * 0.95 && spx > MIN_SPX) {
              spx--;
              ctx.font = 'bold ' + spx + 'px ' + FONT;
            }
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'top';
            ctx.fillText(spotifyTitle, PL, songTop);
          }

          /* Sanatçı — şarkı adının hemen altında */
          var artistTop = songTop + spx + px(2);
          var apx = Math.round(px(7)); /* ≈ 21pt @A3 */
          if (spotifyArtist) {
            ctx.font = apx + 'px ' + FONT;
            ctx.fillStyle = '#b0b0b0';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'top';
            ctx.fillText(spotifyArtist, PL, artistTop, PW * 0.9);
          }

          ctx.textBaseline = 'alphabetic';

          /* Spotify barkodu — siyah arka plan screen blend ile kaldırılır */
          if (spotifyTrackId) {
            var bUrl = 'https://scannables.scdn.co/uri/plain/jpeg/000000/white/640/spotify:track:' + spotifyTrackId;
            var bImg = new Image(); bImg.crossOrigin = 'anonymous';
            bImg.onload = function () {
              var bW = px(78);
              var bH = bW * (bImg.naturalHeight / bImg.naturalWidth);
              ctx.save();
              ctx.globalCompositeOperation = 'screen';
              ctx.drawImage(bImg, (CW-bW)/2, PT+PH-bH-px(8), bW, bH);
              ctx.restore();
            };
            bImg.src = bUrl;
          }
        };
        uImg.src = slot.dataUrl;
      });
    }

    /* Arka plan katmanı */
    if (bgChoice === 'album' && spotifyAlbumArt) {
      var aImg = new Image(); aImg.crossOrigin = 'anonymous';
      aImg.onload  = function () { drawBlurredBg(aImg); drawContent(); };
      aImg.onerror = function () { ctx.fillStyle = BG; ctx.fillRect(0,0,CW,CH); drawContent(); };
      aImg.src = spotifyAlbumArt;
    } else if (bgChoice === 'g1') {
      drawGradient('#1a1a2e', '#16213e', true); drawContent();
    } else if (bgChoice === 'g2') {
      drawGradient('#0f0c29', '#302b63', false); drawContent();
    } else if (bgChoice === 'g3') {
      drawGradient('#12002b', '#1a0050', true); drawContent();
    } else {
      var pImg = new Image();
      pImg.onload  = function () { drawBlurredBg(pImg); drawContent(); };
      pImg.onerror = function () { ctx.fillStyle = BG; ctx.fillRect(0,0,CW,CH); drawContent(); };
      pImg.src = slot.dataUrl;
    }
  }

  function renderPosterFinalPreview() {
    var active = slots.filter(function (s) { return s.dataUrl; });
    if (!active.length) return;
    var slotState = active[0];

    loadPosterTemplateAssets(function (tmplPortrait) {
    resolveTmplForSlot(tmplPortrait, slotState, function (tmpl) {
      var wrap = document.createElement('div');
      wrap.style.cssText = 'text-align:center';

      var canvas = document.createElement('canvas');
      /* Yatay sablonda sabit genislik yerine sabit yukseklik kullanilir —
         yoksa dikey karda ayni genislige sikisip cok daha kucuk gorunur
         (bkz. renderPosterEditorCanvas'taki ayni mantik). */
      canvas.style.cssText = (tmpl.srcW > tmpl.srcH
        ? 'height:260px;max-height:100%;width:auto;max-width:100%;'
        : 'width:260px;max-width:100%;height:auto;'
      ) + 'border-radius:8px;box-shadow:0 8px 28px rgba(0,0,0,0.3);cursor:zoom-in';
      wrap.appendChild(canvas);

      var hint = document.createElement('div');
      hint.style.cssText = 'font-size:11.5px;color:#7B8398;margin-top:8px';
      hint.textContent = 'Büyütmek için tasarıma dokun';
      wrap.appendChild(hint);

      drawPosterCanvasFrame(canvas, tmpl, slotState, 900, Math.round(900 * tmpl.srcH / tmpl.srcW));
      canvas.addEventListener('click', function () {
        openPosterZoom(tmpl, slotState);
      });

      finalGridEl.appendChild(wrap);
    });
    });
  }

  function renderBackendFinalPreview() {
    if (!slots.some(function (s) { return s.dataUrl; })) return;

    loadPosterTemplateAssets(function (tmplPortrait) {
      /* Orijinal slots[] sirasindaki index'i (i) koruyoruz — coklu sabit foto
         alanli sablonlarda (orn. 5x20, 4 alan) her fotonun DOGRU fiziksel
         konuma (i % grup boyutu) yerlesmesi bu sıraya bagli. Her kart kendi
         fotografinin yonune gore portre/yatay sablon kullanabildigi icin
         (bir siparişte hem dikey hem yatay foto olabilir), tmpl coz(u)mu
         HER slot icin AYRI AYRI yapilir. */
      slots.forEach(function (slotState, i) {
        if (!slotState.dataUrl) return;
        resolveTmplForSlot(tmplPortrait, slotState, function (tmpl) {
          var item = document.createElement('div');
          item.className = 'iz-bld__final-item';

          var canvas = document.createElement('canvas');
          /* Yatay sablonda sabit genislik yerine sabit yukseklik kullanilir —
             yoksa dikey kartla ayni genislige sikisip cok daha kucuk gorunur. */
          canvas.style.cssText = (tmpl.srcW > tmpl.srcH
            ? 'height:120px;max-height:100%;width:auto;max-width:100%;'
            : 'width:120px;max-width:100%;height:auto;'
          ) + 'border-radius:8px;box-shadow:0 8px 20px rgba(0,0,0,0.25);cursor:zoom-in;display:block;margin:0 auto';
          item.appendChild(canvas);

          drawPosterCanvasFrame(canvas, tmpl, slotState, 500, Math.round(500 * tmpl.srcH / tmpl.srcW), i);
          canvas.addEventListener('click', function () {
            openPosterZoom(tmpl, slotState, i);
          });

          var num = document.createElement('div');
          num.style.cssText = 'font-size:11px;color:#7B8398;font-weight:600;text-align:center;margin-top:6px';
          num.textContent = '#' + (i + 1);
          item.appendChild(num);

          finalGridEl.appendChild(item);
        });
      });
    });
  }

  function openPosterZoom(tmpl, slotState, slotIdx) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(30,42,68,0.85);display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'max-width:100%;max-height:100%;border-radius:6px;box-shadow:0 20px 60px rgba(0,0,0,0.5)';
    overlay.appendChild(canvas);

    drawPosterCanvasFrame(canvas, tmpl, slotState, 1400, Math.round(1400 * tmpl.srcH / tmpl.srcW), slotIdx);

    overlay.addEventListener('click', function () {
      overlay.remove();
    });
    document.body.appendChild(overlay);
  }

  /* Ani Takvimi Poster gibi TEK cikti + COKLU AYNI-boyutlu sabit slotu olan
     sablonlarda, tum yuklenen fotograflari (upload sirasiyla, her biri KENDI
     slotuna) TEK bir posterde birlikte gosterir — drawGroupedCanvasFrame
     "grup" kavramindan bagimsiz olarak zaten "tum slotlari ayni canvas'a ciz"
     islevini gordugu icin dogrudan reuse ediyoruz. */
  function renderSingleMultiSlotFinalPreview() {
    if (!slots.some(function (s) { return s && s.dataUrl; })) return;
    loadPosterTemplateAssets(function (tmpl) {
      var item = document.createElement('div');
      item.className = 'iz-bld__final-item';

      var canvas = document.createElement('canvas');
      canvas.style.cssText = 'width:240px;max-width:100%;height:auto;border-radius:8px;box-shadow:0 8px 28px rgba(0,0,0,0.3);cursor:zoom-in;display:block;margin:0 auto';
      item.appendChild(canvas);

      drawGroupedCanvasFrame(canvas, tmpl, slots, 700, Math.round(700 * tmpl.srcH / tmpl.srcW));
      canvas.addEventListener('click', function () {
        openGroupedZoom(tmpl, slots);
      });

      var hint = document.createElement('div');
      hint.style.cssText = 'font-size:11.5px;color:#7B8398;margin-top:8px;text-align:center';
      hint.textContent = 'Büyütmek için tasarıma dokun';
      item.appendChild(hint);

      finalGridEl.appendChild(item);
    });
  }

  function renderGroupedFinalPreview() {
    var gs = currentGroupSize();
    var groupCount = Math.ceil(MAX_SLOTS / gs);
    loadPosterTemplateAssets(function (tmpl) {
      for (var g = 0; g < groupCount; g++) {
        (function (g) {
          var groupSlots = slots.slice(g * gs, g * gs + gs);
          if (!groupSlots.some(function (s) { return s && s.dataUrl; })) return;

          var item = document.createElement('div');
          item.className = 'iz-bld__final-item';

          var canvas = document.createElement('canvas');
          canvas.style.cssText = 'width:160px;max-width:100%;height:auto;border-radius:8px;box-shadow:0 8px 20px rgba(0,0,0,0.25);cursor:zoom-in;display:block;margin:0 auto';
          item.appendChild(canvas);

          drawGroupedCanvasFrame(canvas, tmpl, groupSlots, 500, Math.round(500 * tmpl.srcH / tmpl.srcW), -1, true);
          canvas.addEventListener('click', function () {
            /* Zoom'da musteri detayi kontrol ediyor — orada tam cozunurluk
               kullanilir (bkz. openGroupedZoom, usePreview verilmiyor). */
            openGroupedZoom(tmpl, groupSlots);
          });

          var num = document.createElement('div');
          num.style.cssText = 'font-size:11px;color:#7B8398;font-weight:600;text-align:center;margin-top:6px';
          num.textContent = 'Kağıt #' + (g + 1);
          item.appendChild(num);

          finalGridEl.appendChild(item);
        })(g);
      }
    });
  }

  function openGroupedZoom(tmpl, groupSlots) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(30,42,68,0.85);display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'max-width:100%;max-height:100%;border-radius:6px;box-shadow:0 20px 60px rgba(0,0,0,0.5)';
    overlay.appendChild(canvas);

    drawGroupedCanvasFrame(canvas, tmpl, groupSlots, 1400, Math.round(1400 * tmpl.srcH / tmpl.srcW));

    overlay.addEventListener('click', function () {
      overlay.remove();
    });
    document.body.appendChild(overlay);
  }

  function renderFinal() {
    /* Dusuk cozunurluklu (yazdirma alanina gore kucuk) foto varsa, tum urun
       tiplerinde (mevcut/gelecek) siparis vermeden once tek bir uyari
       banner'i gosterilir — engelleyici degil, sadece bilgilendirici. */
    var lowResWarning = q('#iz-bld-lowres-warning', modalEl);
    if (lowResWarning) {
      var anyLowRes = slots.some(function (s) { return s && s.lowRes; });
      lowResWarning.style.display = anyLowRes ? '' : 'none';
    }

    var pvwWrap  = q('#iz-bld-poster-preview-wrap', modalEl);
    var fotoPvw  = q('#iz-bld-foto-preview-wrap',   modalEl);
    if (pvwWrap)  pvwWrap.style.display  = 'none';
    if (fotoPvw)  fotoPvw.style.display  = 'none';

    if (productType === 'muzik-tablosu') {
      finalGridEl.innerHTML = '';
      renderMuzikPreview();
      return;
    }

    if (productType === 'foto-builder') {
      finalGridEl.innerHTML = '';
      if (fotoPvw) fotoPvw.style.display = '';
      renderFotoBuilderPreview();
      return;
    }

    if (productType === 'netflix-poster-tablo') {
      finalGridEl.innerHTML = '';
      renderPosterFinalPreview();
      return;
    }

    if (isGroupedFlow()) {
      /* 5x20 kitap ayraci gibi coklu sabit foto alanli urunlerde son
         onizleme, her fotografi ayri degil, her KAGIDI (grup) tam
         basilacagi haliyle (icindeki tum fotolarla birlikte) gosterir. */
      finalGridEl.innerHTML = '';
      renderGroupedFinalPreview();
      return;
    }

    if (isSingleMultiSlotFlow()) {
      /* Ani Takvimi Poster gibi: TEK poster, 27 AYNI boyutlu sabit foto
         alani (otomatik siradan yerlesir) — 27 ayri "sadece 1 foto dolu"
         kart yerine, TUM fotograflarin birlikte yerlesmis oldugu TEK bir
         onizleme goster. */
      finalGridEl.innerHTML = '';
      renderSingleMultiSlotFinalPreview();
      return;
    }

    if (BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1) {
      /* ani-kutusu/palo-kart/foto-kart: son onizlemede de jenerik mockup
         degil, tam olarak basilacak gercek karti (foto+varsa not birlikte
         yerlesmis halde) goster. */
      finalGridEl.innerHTML = '';
      renderBackendFinalPreview();
      return;
    }

    finalGridEl.innerHTML = '';
    slots.forEach(function (slot, i) {
      var scaleRatio = 120 / 220; /* final frame width / editor frame width */

      /* Clone a mini polaroid */
      var item = document.createElement('div');
      item.className = 'iz-bld__final-item';

      var pol = document.createElement('div');
      pol.className = 'iz-bld__final-polaroid';

      var pf = document.createElement('div');
      pf.className = 'iz-bld__final-photo';

      var img = document.createElement('img');
      img.src = slot.dataUrl;
      img.alt = '';
      img.style.position  = 'absolute';
      img.style.left = '50%';
      img.style.top  = '50%';

      img.onload = function () {
        var fw = 120, fh = 130;
        var scale = Math.max(fw / img.naturalWidth, fh / img.naturalHeight);
        img.style.width  = Math.round(img.naturalWidth  * scale) + 'px';
        img.style.height = Math.round(img.naturalHeight * scale) + 'px';
        /* Scale pan offset proportionally */
        var scaledOX = slot.offX * (fw / 220);
        var scaledOY = slot.offY * (fh / 240);
        img.style.transform = 'translate(calc(-50% + ' + scaledOX + 'px), calc(-50% + ' + scaledOY + 'px))';
      };

      pf.appendChild(img);
      pol.appendChild(pf);

      var note = document.createElement('div');
      note.className = 'iz-bld__final-note';
      note.style.fontFamily = slot.font;
      note.textContent = slot.caption || '—';
      pol.appendChild(note);

      item.appendChild(pol);

      var num = document.createElement('div');
      num.style.cssText = 'font-size:11px;color:#7B8398;font-weight:600';
      num.textContent = '#' + (i + 1);
      item.appendChild(num);

      finalGridEl.appendChild(item);
    });
  }

  /* ─────────────────────────────────────────────── */
  /*  300 DPI Print PDF generation                    */
  /* ─────────────────────────────────────────────── */

  function loadJsPDF() {
    return new Promise(function (resolve, reject) {
      if (window.jspdf) { resolve(); return; }
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.crossOrigin = 'anonymous';
      s.onload  = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  /* Renders one slot to a high-res canvas at the given px dimensions */
  function renderPrintPhoto(slot, CW, CH) {
    return new Promise(function (resolve) {
      var canvas = document.createElement('canvas');
      canvas.width = CW; canvas.height = CH;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, CW, CH);

      var img = new Image();
      img.onload = function () {
        var scale = Math.max(CW / img.naturalWidth, CH / img.naturalHeight);
        var dw = Math.round(img.naturalWidth  * scale);
        var dh = Math.round(img.naturalHeight * scale);
        /* Scale pan offsets proportionally from editor frame (220×240) */
        var ox = (slot.offX || 0) * (CW / 220);
        var oy = (slot.offY || 0) * (CH / 240);
        ctx.drawImage(img, Math.round(CW / 2 - dw / 2 + ox), Math.round(CH / 2 - dh / 2 + oy), dw, dh);
        resolve(canvas);
      };
      img.onerror = function () { resolve(canvas); };
      img.src = slot.dataUrl;
    });
  }

  /* Returns PDF layout dimensions. Maximises cards/page with minimal cutting margin. */
  function getPDFLayout() {
    var papers = {
      a4:     [210, 297],
      a3:     [297, 420],
      a3p:    [329, 483],
      custom: [customPaperW, customPaperH]
    };
    var p   = papers[paperSize] || papers.a4;
    var GAP = 4;  /* 4mm gap = 2mm cutting margin each side — minimal but practical */

    /* Card dimensions from theme editor settings */
    var PW = cardW, PH = cardH;

    /* Photo area inside the card */
    var PL, PT, PW2, PH2;
    if (printStyle === 'borderless') {
      PL = 0; PT = 0; PW2 = PW; PH2 = PH;
    } else {
      /* Proportional polaroid border: ~7% sides/top, ~16% bottom caption */
      var brd  = Math.max(4, Math.round(PW * 0.07));
      var cap  = Math.max(10, Math.round(PH * 0.17));
      PL = brd; PT = brd; PW2 = PW - 2 * brd; PH2 = PH - brd - cap;
    }

    var cols = Math.max(1, Math.floor((p[0] + GAP) / (PW + GAP)));
    var rows = Math.max(1, Math.floor((p[1] + GAP) / (PH + GAP)));

    /* Center the grid on the page */
    var gridW  = cols * PW + (cols - 1) * GAP;
    var gridH  = rows * PH + (rows - 1) * GAP;
    var startX = (p[0] - gridW) / 2;
    var startY = (p[1] - gridH) / 2;

    return { pw: p[0], ph: p[1], cols: cols, rows: rows,
             PW: PW, PH: PH, PL: PL, PT: PT, PW2: PW2, PH2: PH2,
             GAP: GAP, perPage: cols * rows, startX: startX, startY: startY };
  }

  /*
   * Draws a cutting guide around a card:
   *  1. Thin full-perimeter line = the cut boundary to follow
   *  2. Corner crop marks extending outside (only when sufficient space exists)
   * pageW/pageH used to check if marks fit within the paper.
   */
  function drawCuttingGuide(doc, x, y, w, h, pageW, pageH) {
    doc.setDrawColor(140, 140, 140);
    doc.setLineWidth(0.12);
    var G = 0.8, L = 3;

    /* Corner L-marks — only if they fit on the paper */
    var corners = [
      /* TL */ { hx1: x-G-L, hx2: x-G, hy: y,   vx: x,   vy1: y-G-L, vy2: y-G,     fits: (x>G+L+0.3 && y>G+L+0.3) },
      /* TR */ { hx1: x+w+G, hx2: x+w+G+L, hy: y, vx: x+w, vy1: y-G-L, vy2: y-G,    fits: (x+w+G+L<pageW-0.3 && y>G+L+0.3) },
      /* BL */ { hx1: x-G-L, hx2: x-G, hy: y+h, vx: x,   vy1: y+h+G, vy2: y+h+G+L, fits: (x>G+L+0.3 && y+h+G+L<pageH-0.3) },
      /* BR */ { hx1: x+w+G, hx2: x+w+G+L, hy: y+h, vx: x+w, vy1: y+h+G, vy2: y+h+G+L, fits: (x+w+G+L<pageW-0.3 && y+h+G+L<pageH-0.3) }
    ];
    corners.forEach(function (c) {
      if (!c.fits) return;
      doc.line(c.hx1, c.hy,  c.hx2, c.hy);
      doc.line(c.vx,  c.vy1, c.vx,  c.vy2);
    });

    /* Center edge tick marks — short dashes PARALLEL to each edge at its midpoint */
    var mx = x + w / 2, my = y + h / 2;
    var ticks = [
      /* top    — horizontal dash above card   */ { x1: mx-L/2, y1: y-G,   x2: mx+L/2, y2: y-G,   fits: (y>G+0.3) },
      /* bottom — horizontal dash below card   */ { x1: mx-L/2, y1: y+h+G, x2: mx+L/2, y2: y+h+G, fits: (y+h+G<pageH-0.3) },
      /* left   — vertical dash left of card   */ { x1: x-G,   y1: my-L/2, x2: x-G,   y2: my+L/2, fits: (x>G+0.3) },
      /* right  — vertical dash right of card  */ { x1: x+w+G, y1: my-L/2, x2: x+w+G, y2: my+L/2, fits: (x+w+G<pageW-0.3) }
    ];
    ticks.forEach(function (t) {
      if (!t.fits) return;
      doc.line(t.x1, t.y1, t.x2, t.y2);
    });
  }

  /* Tek sayfa tam kanat fotoğraf PDF (düz baskı / özel poster) */
  function generateFullPagePDF() {
    return loadJsPDF().then(function () {
      var papers = { a4: [210, 297], a3: [297, 420], a3p: [329, 483], custom: [customPaperW, customPaperH] };
      var p = papers[paperSize] || papers.a4;
      var pw = p[0], ph = p[1];
      var jsPDF = window.jspdf.jsPDF;
      var doc = new jsPDF({ unit: 'mm', format: [pw, ph], orientation: 'portrait' });
      var active = slots.filter(function (s) { return s.dataUrl; });
      if (active.length === 0) {
        doc.setProperties({ title: 'Pozca — Baskı Dosyası' });
        return doc.output('blob');
      }
      var slot = active[0];
      var DPI = 300, MM2PX = DPI / 25.4;
      return renderPrintPhoto(slot, Math.round(pw * MM2PX), Math.round(ph * MM2PX))
        .then(function (canvas) {
          try { doc.addImage(canvas.toDataURL('image/jpeg', 0.88), 'JPEG', 0, 0, pw, ph); } catch (e) {}
          doc.setProperties({ title: 'Pozca — Baskı Dosyası' });
          return doc.output('blob');
        });
    });
  }

  /* Müzik posteri PDF */
  function generateMuzikPosteriPDF() {
    return loadJsPDF().then(function () {
      var slot = slots.filter(function (s) { return s.dataUrl; })[0];
      var jsPDF = window.jspdf.jsPDF;

      var papers = { a5:[148,210], a4:[210,297], a3:[297,420], a3p:[329,483], custom:[customPaperW,customPaperH] };
      var p = papers[paperSize] || papers.a4;
      var pw = p[0], ph = p[1];

      var doc = new jsPDF({ unit:'mm', format:[pw,ph], orientation:'portrait' });
      doc.setProperties({ title:'Pozca — Müzik Posteri Baskı Dosyası' });
      if (!slot) return doc.output('blob');

      var A3w = 297, A3h = 420;
      var sc  = Math.min(pw/A3w, ph/A3h);
      var ox  = (pw - A3w*sc) / 2;
      var oy  = (ph - A3h*sc) / 2;

      function sx(x) { return ox + x*sc; }
      function sy(y) { return oy + y*sc; }
      function sm(v) { return v*sc; }

      var PL=46.9, PT=53.8, PW=203.2, PH=203.2;
      var PB = PT + PH;
      var BG = [24,62,131];
      var chromeUrl = (window.IZ_MUZIK_CHROME) || '';

      return new Promise(function (resolve) {

        /* Yardımcı: bulanık canvas oluştur */
        function makeBlurCanvas(srcUrl, w, h, cb) {
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var cctx = c.getContext('2d');
          var img = new Image();
          if (srcUrl && srcUrl.indexOf('data:') !== 0) img.crossOrigin = 'anonymous';
          img.onload = function () {
            try { cctx.filter = 'blur(25px) brightness(0.45)'; } catch(e) {}
            var s2 = Math.max(w/img.naturalWidth, h/img.naturalHeight) * 1.25;
            cctx.drawImage(img, (w-img.naturalWidth*s2)/2, (h-img.naturalHeight*s2)/2,
                           img.naturalWidth*s2, img.naturalHeight*s2);
            try { cctx.filter = 'none'; } catch(e) {}
            cb(c);
          };
          img.onerror = function () { cb(null); };
          img.src = srcUrl;
        }

        /* Chrome PNG → küçük canvas üzerinden ekle (jsPDF bellek baskısını azaltır) */
        function addChromePNG(cb) {
          if (!chromeUrl) { cb(); return; }
          var cImg = new Image(); cImg.crossOrigin = 'anonymous';
          cImg.onload = function () {
            try {
              /* 500px genişliğinde küçük canvas — ~1MB bellek */
              var cc = document.createElement('canvas');
              var scale = 500 / cImg.naturalWidth;
              cc.width = 500; cc.height = Math.round(cImg.naturalHeight * scale);
              cc.getContext('2d').drawImage(cImg, 0, 0, cc.width, cc.height);
              doc.addImage(cc.toDataURL('image/png'), 'PNG', sx(0), sy(0), sm(A3w), sm(A3h));
            } catch(e) {}
            cb();
          };
          cImg.onerror = cb;
          cImg.src = chromeUrl;
        }

        /* Üst/alt karanlık geçiş — chrome elemanları okunabilsin */
        function addDarkOverlays() {
          /* Üst gradient — başlık çubuğu */
          try {
            var oc = document.createElement('canvas'); oc.width = 10; oc.height = 100;
            var octx = oc.getContext('2d');
            var og = octx.createLinearGradient(0, 0, 0, 100);
            og.addColorStop(0, 'rgba(0,0,0,0.60)'); og.addColorStop(1, 'rgba(0,0,0,0)');
            octx.fillStyle = og; octx.fillRect(0, 0, 10, 100);
            doc.addImage(oc.toDataURL('image/png'), 'PNG', sx(0), sy(0), sm(A3w), sy(58)-sy(0));
          } catch(e) {}
          /* Alt gradient — kontrol paneli */
          try {
            var bc2 = document.createElement('canvas'); bc2.width = 10; bc2.height = 100;
            var bctx2 = bc2.getContext('2d');
            var bg2 = bctx2.createLinearGradient(0, 0, 0, 100);
            bg2.addColorStop(0, 'rgba(0,0,0,0)'); bg2.addColorStop(0.15, 'rgba(0,0,0,0.55)');
            bg2.addColorStop(1, 'rgba(0,0,0,0.70)');
            bctx2.fillStyle = bg2; bctx2.fillRect(0, 0, 10, 100);
            doc.addImage(bc2.toDataURL('image/png'), 'PNG', sx(0), sy(302), sm(A3w), sy(A3h)-sy(302));
          } catch(e) {}
        }

        /* Müşteri fotoğrafı 300 DPI yuvarlak köşeli */
        function addPhoto(cb) {
          var MM2PX = 300/25.4;
          var phpx = Math.round(PW*MM2PX);
          var phC = document.createElement('canvas'); phC.width = phpx; phC.height = phpx;
          var pctx = phC.getContext('2d');
          var uImg = new Image();
          uImg.onload = function () {
            var r = Math.round(phpx*0.032);
            pctx.save();
            pctx.beginPath();
            pctx.moveTo(r,0); pctx.lineTo(phpx-r,0); pctx.arcTo(phpx,0,phpx,r,r);
            pctx.lineTo(phpx,phpx-r); pctx.arcTo(phpx,phpx,phpx-r,phpx,r);
            pctx.lineTo(r,phpx); pctx.arcTo(0,phpx,0,phpx-r,r);
            pctx.lineTo(0,r); pctx.arcTo(0,0,r,0,r); pctx.closePath();
            pctx.clip();
            var is = Math.max(phpx/uImg.naturalWidth, phpx/uImg.naturalHeight);
            pctx.drawImage(uImg,(phpx-uImg.naturalWidth*is)/2,(phpx-uImg.naturalHeight*is)/2,
                           uImg.naturalWidth*is, uImg.naturalHeight*is);
            pctx.restore();
            try { doc.addImage(phC.toDataURL('image/jpeg',0.92),'JPEG',sx(PL),sy(PT),sm(PW),sm(PH)); } catch(e) {}
            cb();
          };
          uImg.onerror = cb;
          uImg.src = slot.dataUrl;
        }

        /* Metin — tek satır şarkı, dinamik sanatçı konumu */
        function addText() {
          var noName = q('#iz-bld-no-name',modalEl);
          if (posterName && (!noName || !noName.checked)) {
            doc.setFont('helvetica','bold'); doc.setFontSize(10*sc);
            doc.setTextColor(255,255,255);
            doc.text(posterName, sx(A3w/2), sy(35.5), {align:'center',maxWidth:sm(170)});
          }

          /* Şarkı — tek satır sığana kadar font küçültülür */
          var songTopMM = PT + PH + 5;
          if (spotifyTitle) {
            var songPt = 37 * sc;
            doc.setFont('helvetica','bold');
            doc.setFontSize(songPt);
            while (doc.getTextWidth(spotifyTitle) > sm(PW * 0.95) && songPt > 10 * sc) {
              songPt -= 0.5;
              doc.setFontSize(songPt);
            }
            doc.setTextColor(255,255,255);
            doc.text(spotifyTitle, sx(PL), sy(songTopMM) + songPt * 0.352);
          }

          /* Sanatçı — şarkı altında dinamik */
          var artistPt = 22 * sc;
          var songHeightMM = (spotifyTitle ? (37 * sc) * 0.352 / sc : 0) + 2;
          if (spotifyArtist) {
            doc.setFont('helvetica','normal'); doc.setFontSize(artistPt);
            doc.setTextColor(176,176,176);
            var artistY = sy(songTopMM) + sm(songHeightMM) + artistPt * 0.352;
            doc.text(spotifyArtist, sx(PL), artistY, {maxWidth:sm(PW*0.9)});
          }
        }

        /* Barkod — siyah pikseller şeffaflaştırılır → PNG */
        function addBarcode(cb) {
          if (!spotifyTrackId) { cb(); return; }
          var bUrl = 'https://scannables.scdn.co/uri/plain/jpeg/000000/white/640/spotify:track:'+spotifyTrackId;
          var bImg = new Image(); bImg.crossOrigin = 'anonymous';
          bImg.onload = function () {
            try {
              var bc = document.createElement('canvas');
              bc.width = bImg.naturalWidth; bc.height = bImg.naturalHeight;
              var bctx = bc.getContext('2d');
              bctx.drawImage(bImg, 0, 0);
              var id = bctx.getImageData(0, 0, bc.width, bc.height);
              var d = id.data;
              for (var i = 0; i < d.length; i += 4) {
                if (d[i] < 50 && d[i+1] < 50 && d[i+2] < 50) d[i+3] = 0;
              }
              bctx.putImageData(id, 0, 0);
              var bW = sm(80), bH = bW*(bImg.naturalHeight/bImg.naturalWidth);
              doc.addImage(bc.toDataURL('image/png'), 'PNG', sx(A3w/2)-bW/2, sy(PB)-bH-sm(8), bW, bH);
            } catch(e) {}
            cb();
          };
          bImg.onerror = cb;
          bImg.src = bUrl;
        }

        /* Sayfa 2 — orijinal fotoğraf (doğal boyut, 300 DPI, JPEG yeniden sıkıştırılmaz) */
        function addOriginalPhotoPage(cb) {
          var img = new Image();
          img.onload = function () {
            var MM2PX = 300 / 25.4;
            var pW = img.naturalWidth  / MM2PX;
            var pH = img.naturalHeight / MM2PX;
            /* Makul bir üst sınır — A0 (841mm) aşmasın */
            var maxMM = 841;
            if (pW > maxMM || pH > maxMM) {
              var ds = Math.min(maxMM / pW, maxMM / pH);
              pW *= ds; pH *= ds;
            }
            doc.addPage([pW, pH]);
            var fmt = slot.dataUrl.indexOf('data:image/png') === 0 ? 'PNG' : 'JPEG';
            try { doc.addImage(slot.dataUrl, fmt, 0, 0, pW, pH); } catch(e) {}
            cb();
          };
          img.onerror = cb;
          img.src = slot.dataUrl;
        }

        function buildLayers() {
          addChromePNG(function () {
            addDarkOverlays();
            addPhoto(function () {
              addText();
              addBarcode(function () {
                addOriginalPhotoPage(function () {
                  resolve(doc.output('blob'));
                });
              });
            });
          });
        }

        /* Arka plan */
        var bgSrc = bgChoice === 'album' && spotifyAlbumArt ? spotifyAlbumArt
                  : (bgChoice === 'photo' || !bgChoice) ? slot.dataUrl
                  : null;

        if (bgSrc) {
          var bgW = Math.round(A3w * (150/25.4)), bgH = Math.round(A3h * (150/25.4));
          makeBlurCanvas(bgSrc, bgW, bgH, function (bgC) {
            if (bgC) {
              try { doc.addImage(bgC.toDataURL('image/jpeg',0.75),'JPEG',sx(0),sy(0),sm(A3w),sm(A3h)); } catch(e) {}
            } else {
              doc.setFillColor(BG[0],BG[1],BG[2]); doc.rect(sx(0),sy(0),sm(A3w),sm(A3h),'F');
            }
            buildLayers();
          });
        } else {
          var gC = document.createElement('canvas'); gC.width = 10; gC.height = 10;
          var gctx = gC.getContext('2d'); var grd;
          if (bgChoice === 'g1') {
            grd = gctx.createLinearGradient(0,0,10,10);
            grd.addColorStop(0,'#1a1a2e'); grd.addColorStop(1,'#16213e');
          } else if (bgChoice === 'g2') {
            grd = gctx.createLinearGradient(0,0,0,10);
            grd.addColorStop(0,'#0f0c29'); grd.addColorStop(1,'#302b63');
          } else if (bgChoice === 'g3') {
            grd = gctx.createLinearGradient(0,0,10,10);
            grd.addColorStop(0,'#12002b'); grd.addColorStop(1,'#1a0050');
          }
          if (grd) {
            gctx.fillStyle = grd; gctx.fillRect(0,0,10,10);
            try { doc.addImage(gC.toDataURL('image/jpeg'),'JPEG',sx(0),sy(0),sm(A3w),sm(A3h)); } catch(e) {}
          } else {
            doc.setFillColor(BG[0],BG[1],BG[2]); doc.rect(sx(0),sy(0),sm(A3w),sm(A3h),'F');
          }
          buildLayers();
        }
      });
    });
  }

  /* ─────────────────────────────────────────────── */
  /*  Foto-builder: template preview + PDF            */
  /* ─────────────────────────────────────────────── */

  /* Draws template preview onto canvas element for final-phase display */
  function renderFotoBuilderPreview() {
    var canvasEl = q('#iz-bld-foto-canvas', modalEl);
    if (!canvasEl || !templateConfig) return;
    var cfg = templateConfig;
    var paperW = cfg.paperW || 297;
    var paperH = cfg.paperH || 420;
    var slotList = cfg.slots || [];

    /* Canvas display: 300px wide, proportional height */
    var PX_W = 300;
    var PX_H = Math.round(paperH / paperW * PX_W);
    canvasEl.width  = PX_W;
    canvasEl.height = PX_H;
    var ctx = canvasEl.getContext('2d');
    ctx.clearRect(0, 0, PX_W, PX_H);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, PX_W, PX_H);

    var scale = PX_W / paperW;

    /* Draw each slot's customer photo */
    var activeSlots = slots.filter(function (s) { return s.dataUrl; });
    var drawn = 0;

    function drawSlot(si) {
      if (si >= slotList.length) { overlayTemplate(); return; }
      var sc = slotList[si];
      var customerSlot = activeSlots[si];
      if (!customerSlot || !customerSlot.dataUrl) { drawSlot(si + 1); return; }

      var sx = sc.x * scale, sy_mm = sc.y * scale;
      var sw = sc.w * scale, sh_mm = sc.h * scale;
      var r  = (sc.r || 0) * scale;

      var img = new Image();
      img.onload = function () {
        ctx.save();
        /* Rounded rect clip */
        ctx.beginPath();
        if (ctx.roundRect) {
          ctx.roundRect(sx, sy_mm, sw, sh_mm, r);
        } else {
          ctx.rect(sx, sy_mm, sw, sh_mm);
        }
        ctx.clip();

        /* Cover-fit photo with pan offset (offsets stored relative to editor frame 220×240) */
        var photoScale = Math.max(sw / img.naturalWidth, sh_mm / img.naturalHeight);
        var dw = img.naturalWidth  * photoScale;
        var dh = img.naturalHeight * photoScale;
        var ox = (customerSlot.offX || 0) * (sw / 220);
        var oy = (customerSlot.offY || 0) * (sh_mm / 240);
        ctx.drawImage(img, sx + (sw - dw) / 2 + ox, sy_mm + (sh_mm - dh) / 2 + oy, dw, dh);
        ctx.restore();
        drawSlot(si + 1);
      };
      img.onerror = function () { drawSlot(si + 1); };
      img.src = customerSlot.dataUrl;
    }

    function overlayTemplate() {
      if (!cfg.template) return;
      var tmpl = new Image();
      tmpl.crossOrigin = 'anonymous';
      tmpl.onload = function () {
        ctx.drawImage(tmpl, 0, 0, PX_W, PX_H);
      };
      tmpl.src = cfg.template;
    }

    drawSlot(0);
  }

  /* PDF for foto-builder: one page per original photo (no canvas re-encoding) */
  function generateFotoBuilderPDF() {
    return loadJsPDF().then(function () {
      var jsPDF  = window.jspdf.jsPDF;
      var active = slots.filter(function (s) { return s.dataUrl; });
      if (!active.length) return new Blob([], { type: 'application/pdf' });

      return new Promise(function (resolve) {
        var doc = null;
        var idx = 0;

        function addNext() {
          if (idx >= active.length) { resolve(doc ? doc.output('blob') : new Blob([], { type: 'application/pdf' })); return; }
          var slot = active[idx];
          var img  = new Image();
          img.onload = function () {
            var MM2PX = 300 / 25.4;
            var pW = img.naturalWidth  / MM2PX;
            var pH = img.naturalHeight / MM2PX;
            var maxMM = 841;
            if (pW > maxMM || pH > maxMM) {
              var ds = Math.min(maxMM / pW, maxMM / pH); pW *= ds; pH *= ds;
            }
            if (!doc) {
              doc = new jsPDF({ unit: 'mm', format: [pW, pH], orientation: pH > pW ? 'portrait' : 'landscape' });
              doc.setProperties({ title: 'Pozca — Fotoğraf ' + (idx + 1) });
            } else {
              doc.addPage([pW, pH]);
            }
            var fmt = slot.dataUrl.indexOf('data:image/png') === 0 ? 'PNG' : 'JPEG';
            try { doc.addImage(slot.dataUrl, fmt, 0, 0, pW, pH); } catch(e) {}
            idx++;
            addNext();
          };
          img.onerror = function () { idx++; addNext(); };
          img.src = slot.dataUrl;
        }

        addNext();
      });
    });
  }

  /*
   * Generates a print-ready PDF using current printStyle + paperSize.
   * Returns a Promise<Blob>.
   */
  function generatePDF() {
    if (productType === 'muzik-tablosu') return generateMuzikPosteriPDF();
    if (productType === 'foto-builder')  return generateFotoBuilderPDF();
    if (productType !== 'ani-kutusu')    return generateFullPagePDF();
    return loadJsPDF().then(function () {
      var L      = getPDFLayout();
      var jsPDF  = window.jspdf.jsPDF;
      var doc    = new jsPDF({ unit: 'mm', format: [L.pw, L.ph], orientation: 'portrait' });
      var active = slots.filter(function (s) { return s.dataUrl; });

      /* Render all photos at 300 DPI canvas resolution */
      var DPI = 300;
      var MM2PX = DPI / 25.4;
      var renders = active.map(function (s) {
        return renderPrintPhoto(s, Math.round(L.PW2 * MM2PX), Math.round(L.PH2 * MM2PX));
      });

      return Promise.all(renders).then(function (canvases) {
        canvases.forEach(function (canvas, i) {
          var posIdx = i % L.perPage;
          var col    = posIdx % L.cols;
          var row    = Math.floor(posIdx / L.cols);

          if (posIdx === 0 && i > 0) doc.addPage();

          var x = L.startX + col * (L.PW + L.GAP);
          var y = L.startY + row * (L.PH + L.GAP);

          /* White card background (polaroid only) */
          if (printStyle === 'polaroid') {
            doc.setFillColor(255, 255, 255);
            doc.rect(x, y, L.PW, L.PH, 'F');
          }

          /* Photo */
          try {
            doc.addImage(canvas.toDataURL('image/jpeg', 0.88), 'JPEG',
                         x + L.PL, y + L.PT, L.PW2, L.PH2);
          } catch (e) {}

          /* Caption (polaroid only) */
          var slot = active[i];
          if (printStyle === 'polaroid' && slot.caption) {
            doc.setFontSize(8);
            doc.setFont('helvetica', 'italic');
            doc.setTextColor(55, 55, 55);
            doc.text(slot.caption, x + L.PW / 2, y + L.PT + L.PH2 + 9,
                     { align: 'center', maxWidth: L.PW - 12 });
          }

          /* Cutting guide: full perimeter + smart corner marks */
          drawCuttingGuide(doc, x, y, L.PW, L.PH, L.pw, L.ph);
        });

        doc.setProperties({
          title: 'Pozca — Baskı Dosyası',
          subject: active.length + ' adet · ' + paperSize.toUpperCase() + ' · ' + printStyle,
          creator: 'Pozca'
        });

        return doc.output('blob');
      });
    });
  }

  /* ─────────────────────────────────────────────── */
  /*  PDF loading overlay                             */
  /* ─────────────────────────────────────────────── */
  function showPdfOverlay() {
    var el = document.getElementById('iz-pdf-overlay');
    if (!el) {
      el = document.createElement('div');
      el.id = 'iz-pdf-overlay';
      el.className = 'iz-pdf-overlay';
      el.innerHTML =
        '<div class="iz-pdf-overlay__spinner"></div>' +
        '<div class="iz-pdf-overlay__body">' +
          '<p class="iz-pdf-overlay__title">Hazırlanıyor…</p>' +
          '<p class="iz-pdf-overlay__sub">Lütfen bekleyin — fotoğraflarınızın boyutu yüksek olduğu için birkaç dakika sürebilir</p>' +
        '</div>';
      document.body.appendChild(el);
    } else {
      el.style.display = 'flex';
      /* Onceki bir akistan kalma farkli bir metin varsa varsayilana dondur */
      var subEl = el.querySelector('.iz-pdf-overlay__sub');
      if (subEl) subEl.textContent = 'Lütfen bekleyin — fotoğraflarınızın boyutu yüksek olduğu için birkaç dakika sürebilir';
    }
  }

  function hidePdfOverlay() {
    var el = document.getElementById('iz-pdf-overlay');
    if (el) el.style.display = 'none';
  }

  /* ─────────────────────────────────────────────── */
  /*  Kalite kaybetmeyen backend entegrasyonu (ani-kutusu)  */
  /*  PDF/canvas ile ikinci kez sikistirma yerine orijinal  */
  /*  dosyayi oldugu gibi Flask API'ye yukler.              */
  /* ─────────────────────────────────────────────── */

  function dataUrlToBlob(dataUrl) {
    var parts = dataUrl.split(',');
    var mime  = parts[0].match(/:(.*?);/)[1];
    var bin   = atob(parts[1]);
    var arr   = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
  }

  var _EXT_BY_MIME = { 'image/jpeg': '.jpg', 'image/png': '.png', 'image/webp': '.webp' };

  /* Fotografi ARTIK Render sunucumuza gondermiyoruz — once kucuk bir JSON
     istegiyle R2'ye dogrudan yuklemek icin "presigned URL" aliyoruz, sonra
     tarayici dosyayi DOGRUDAN R2'ye yukluyor. Render sunucumuz hicbir foto
     baytini gormuyor/aktarmiyor; sadece bu ufak URL istegini yanitliyor.
     Boylece buyuk siparislerde (30-64+ foto) yukleme asamasindaki sunucu
     zorlanmasi/hiz siniri sorunlari tamamen ortadan kalkiyor — kompozisyon
     (asil agir is) hala Render'da, degismedi.
     S3/R2 yapilandirilmamis bir ortamda (yerel gelistirme) sunucu
     "upload_url": null doner; bu durumda eski (sunucu uzerinden) yola duseriz. */
  function uploadPhotoToBackend(blob, targetW, targetH, naturalW, naturalH) {
    var lowRes = (naturalW && naturalH && targetW && targetH)
      ? (naturalW < targetW || naturalH < targetH)
      : undefined;
    var ext = _EXT_BY_MIME[blob.type] || '.jpg';

    return fetch(photoApiBase + '/api/photos/presign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ext: ext }),
    }).then(function (res) {
      if (res.status === 429) throw new Error('RATE_LIMIT');
      if (!res.ok) throw new Error('Presign HTTP ' + res.status);
      return res.json();
    }).then(function (presign) {
      if (!presign.upload_url) {
        // Yerel gelistirme / S3 yapilandirilmamis: eski yola dus.
        var fd = new FormData();
        fd.append('photo', blob, 'foto.jpg');
        fd.append('target_w', Math.round(targetW));
        fd.append('target_h', Math.round(targetH));
        return fetch(photoApiBase + '/api/photos', { method: 'POST', body: fd })
          .then(function (res) {
            if (res.status === 429) throw new Error('RATE_LIMIT');
            if (!res.ok) throw new Error('Foto yukleme HTTP ' + res.status);
            return res.json();
          });
      }
      return fetch(presign.upload_url, {
        method: 'PUT',
        headers: { 'Content-Type': presign.content_type },
        body: blob,
      }).then(function (putRes) {
        if (!putRes.ok) throw new Error('R2 yukleme HTTP ' + putRes.status);
        return { photo_id: presign.photo_id, low_resolution: lowRes };
      });
    });
  }

  /* Bir kerelik basarisizlikta (agdaki gecici bir kesinti, sunucunun anlik
     yogunlugu vb.) tek seferlik tekrar dener — buyuk siparislerde (20-30+
     foto) tek bir fotonun gecici hatasi butun siparisi cokertmesin. */
  function uploadPhotoWithRetry(blob, targetW, targetH, naturalW, naturalH) {
    return uploadPhotoToBackend(blob, targetW, targetH, naturalW, naturalH).catch(function (err) {
      /* Hiz siniri asildiysa (RATE_LIMIT) daha uzun bekleyip tekrar dene */
      var delay = (err && err.message === 'RATE_LIMIT') ? 4000 : 800;
      return new Promise(function (resolve) { setTimeout(resolve, delay); })
        .then(function () { return uploadPhotoToBackend(blob, targetW, targetH, naturalW, naturalH); });
    });
  }

  /* items'i ayni anda en fazla "limit" kadar isleyerek workFn'i calistirir —
     sunucuyu (sinirlarini test ettigimiz Render ornegini) asiri yuklememek
     icin. Buyuk siparislerde (orn. 64 foto) hepsini ayni anda paralel
     yuklemek sunucuyu cokertip "Fotograflar yuklenirken bir sorun olustu"
     hatasina yol aciyordu — bu, kok sebebi cozer. */
  function runWithConcurrencyLimit(items, limit, workFn) {
    return new Promise(function (resolve, reject) {
      if (!items.length) { resolve([]); return; }
      var results = new Array(items.length);
      var nextIndex = 0, activeCount = 0, doneCount = 0, rejected = false;

      function startNext() {
        if (rejected || nextIndex >= items.length) return;
        var i = nextIndex++;
        activeCount++;
        workFn(items[i], i).then(function (res) {
          results[i] = res;
          activeCount--; doneCount++;
          if (doneCount === items.length) { resolve(results); return; }
          startNext();
        }).catch(function (err) {
          if (!rejected) { rejected = true; reject(err); }
        });
      }

      for (var k = 0; k < Math.min(limit, items.length); k++) startNext();
    });
  }

  /*
   * Editordeki 220x240 onizleme cercevesinde tutulan pan (offX/offY) degerini,
   * backend'in ani_kutusu sablonundaki gercek foto alani (CW x CH, px) icin
   * bir kirpma dikdortgenine ({x,y,w,h}, orijinal foto piksel uzayinda) cevirir.
   * renderPrintPhoto() ile ayni "cover fit + pan" matematigini kullanir, sadece
   * canvas'a cizmek yerine esdeger kirpma dikdortgenini geri dondurur.
   */
  function computeCropForSlot(slot, CW, CH, frameW, frameH) {
    /* slot.frameW/frameH, musteri bu alani GERCEKTEN surukledigi anda
       (bkz. setupGroupCanvasInteraction/setupPosterPhotoPan onDown)
       kaydedilen dogru referanstir — varsa HER ZAMAN ona oncelik verilir.
       Askin Kalbi gibi FARKLI boyutlu alanlari olan gruplu sablonlarda (ve
       buyuk-sablon deneyiminin duyarli CSS genisliginde) tek bir sabit
       220/240 varsayimi YANLIS kirpmaya (kutunun disinda beyaz alan gibi
       gorunen kaymalara) yol aciyordu. */
    frameW = slot.frameW || frameW || 220;
    frameH = slot.frameH || frameH || 240;
    var naturalW = slot.naturalW || 1;
    var naturalH = slot.naturalH || 1;
    var scale = Math.max(CW / naturalW, CH / naturalH);
    var dw = naturalW * scale;
    var dh = naturalH * scale;
    var ox = (slot.offX || 0) * (CW / frameW);
    var oy = (slot.offY || 0) * (CH / frameH);
    var px = CW / 2 - dw / 2 + ox;
    var py = CH / 2 - dh / 2 + oy;

    var cropX = -px / scale;
    var cropY = -py / scale;
    var cropW = CW / scale;
    var cropH = CH / scale;

    /* Sinirlar disina tasmayi engelle (kucuk yuvarlama hatalarina karsi guvenlik) */
    cropX = Math.max(0, Math.min(cropX, naturalW - 1));
    cropY = Math.max(0, Math.min(cropY, naturalH - 1));
    cropW = Math.min(cropW, naturalW - cropX);
    cropH = Math.min(cropH, naturalH - cropY);

    return {
      x: Math.round(cropX), y: Math.round(cropY),
      w: Math.round(cropW), h: Math.round(cropH),
    };
  }

  /* Tum slotlari backend'e yukler, sepet properties'ini hazirlar. */
  function buildBackendPropsAndUpload() {
    var active = slots.filter(function (s) { return s.dataUrl; });

    return runWithConcurrencyLimit(active, UPLOAD_CONCURRENCY, function (s, i) {
      /* Cogu sablonda tum slotlar ayni boyuttadir; Google Arama Poster gibi
         5 FARKLI boyutlu sabit slotu olan sablonlarda i (yukleme/slot
         sirasi) ile dogru slot boyutu getSlotDimsAt'tan okunur. */
      var dims = getSlotDimsAt(i, s);
      /* Arka planda zaten baslamis/bitmis bir yukleme varsa onu bekle (fast
         path — genelde bu noktada zaten tamamlanmis olur); basarisiz olduysa
         (once yakalanamayan bir ag sorunu vb.) sifirdan bir sans daha ver. */
      var uploadP = s._uploadPromise
        ? s._uploadPromise.catch(function () {
            return uploadPhotoWithRetry(dataUrlToBlob(s.dataUrl), dims.width, dims.height, s.naturalW, s.naturalH);
          })
        : uploadPhotoWithRetry(dataUrlToBlob(s.dataUrl), dims.width, dims.height, s.naturalW, s.naturalH);
      return uploadP.then(function (res) {
        return { slot: s, photo_id: res.photo_id, low_res: res.low_resolution, dims: dims };
      });
    }).then(function (results) {
      /* Basta alt cizgi (_) olan property adlari Shopify tarafindan musteriye
         gosterilen sepet/checkout ekranlarindan otomatik gizlenir (merchant
         admin panelinden hala gorebilir) — bunlar bizim backend'imizin
         makine-okur teknik verileri, musterinin gormesine gerek yok. */
      var props = { _template_id: photoTemplateId };
      results.forEach(function (r, i) {
        var n = i + 1;
        var crop = productType === 'netflix-poster-tablo'
          ? computeCropForSlot(r.slot, r.dims.width, r.dims.height, posterFrameW, posterFrameH)
          : computeCropForSlot(r.slot, r.dims.width, r.dims.height);
        props['_photo_' + n + '_photo_id'] = r.photo_id;
        props['_photo_' + n + '_crop']     = JSON.stringify(crop);
        /* Yon-uyumlu sablonlarda (5x7/9x13/13x18) backend'e bu fotografin
           yatay basilmasi gerektigini acikca soyluyoruz — crop orani zaten
           getSlotDimsAt'in donduğu (swap edilmis) CW/CH'e gore hesaplandi,
           backend'in kendi basina tahmin etmesine gerek yok/olmamali. */
        if (isOrientationAdaptiveTemplate() && isLandscapeSlotState(r.slot)) {
          props['_photo_' + n + '_orientation'] = 'landscape';
        }
        if (r.slot.caption) props['_photo_' + n + '_caption'] = r.slot.caption;
        /* Font secimi gercekten basilan bir fontsa (RESTRICTED_FONTS, orn.
           palo kart urunleri) backend'e anahtarini gonder; degilse (varsayilan
           kozmetik font listesi) hicbir sey gonderilmez — eski davranis korunur. */
        var fontEntry = FONTS.filter(function (f) { return f.v === r.slot.font; })[0];
        if (fontEntry && fontEntry.k) props['_photo_' + n + '_font'] = fontEntry.k;

        if (r.slot.stickers && r.slot.stickers.length) {
          props['_photo_' + n + '_stickers'] = JSON.stringify(r.slot.stickers);
        }

        if (productType === 'netflix-poster-tablo') {
          if (r.slot.posterIsim)   props['_photo_' + n + '_isim']    = r.slot.posterIsim;
          if (r.slot.posterBaslik) props['_photo_' + n + '_baslik']  = r.slot.posterBaslik;
          if (r.slot.posterHikaye) props['_photo_' + n + '_hikaye']  = r.slot.posterHikaye;
          if (r.slot.posterTur)    props['_photo_' + n + '_tur']     = r.slot.posterTur;
        }
        if (productType === 'google-arama-poster-tablo' && n === 1) {
          if (googleArama) props['_photo_1_arama'] = googleArama;
          if (googleIsim)  props['_photo_1_isim']  = googleIsim;
        }
        if (productType === 'ani-gazetesi-poster-tablo' && n === 1) {
          Object.keys(gazeteFields).forEach(function (field) {
            if (gazeteFields[field]) props['_photo_1_' + field] = gazeteFields[field];
          });
        }
        if (productType === 'kalbimdeki-anilar-sarkili-takvim-tablosu' && n === 1) {
          Object.keys(takvimFields).forEach(function (field) {
            if (takvimFields[field]) props['_photo_1_' + field] = takvimFields[field];
          });
        }
        if (productType === 'askin-kalbi-i̇simli-ve-sarkili-poster-tablo' && n === 1) {
          Object.keys(kalpFields).forEach(function (field) {
            if (kalpFields[field]) props['_photo_1_' + field] = kalpFields[field];
          });
        }
      });
      return props;
    });
  }

  /* ─────────────────────────────────────────────── */
  /*  Cart submission                                 */
  /* ─────────────────────────────────────────────── */
  // Only local draft/UI cleanup: no cart changes, remote deletes or file revocation.
  function resetCompletedDesign() {
    draftGeneration++; resetOnPageRestore = true;
    slots = []; uploadPool = [];
    editIdx = -1; activeGroupIdx = -1; activeSlotInGroup = -1;
    drag.on = false; posterDrag.on = false; stickerDrag.mode = null; stickerDrag.idx = -1;
    stickerSelectedIdx = -1; stickerActiveCategory = null; stickerHitRects = [];
    lastCaptionAreaPx = { x: 0, y: 0, w: 1, h: 1 };
    _bgUploadQueue = []; // Keep the active-upload counter/references intact.
    _fileReadBatches = []; _pendingFileCount = 0; _pendingReplacement = false;
    _replaceTarget = null; _uploadMessages = [];
    spotifyTrackId = ''; spotifyTitle = ''; spotifyArtist = ''; spotifyAlbumArt = '';
    posterName = ''; googleArama = ''; googleIsim = ''; bgChoice = 'photo';
    [gazeteFields, takvimFields, kalpFields].forEach(function (fields) {
      Object.keys(fields).forEach(function (key) { fields[key] = ''; });
    });
    formEl.querySelectorAll('[data-iz-builder], [data-iz-pdf]').forEach(function (node) { node.remove(); });
    modalEl.querySelectorAll('input, textarea, select').forEach(function (input) {
      if (input.type === 'checkbox' || input.type === 'radio') input.checked = input.defaultChecked;
      else if (input.tagName === 'SELECT') {
        Array.prototype.forEach.call(input.options, function (option) { option.selected = option.defaultSelected; });
      } else input.value = input.type === 'file' ? '' : input.defaultValue;
    });
    var copyright = q('#iz-bld-copyright-ok', modalEl);
    if (copyright) copyright.checked = false;
    var cartButton = q('#iz-bld-cart', modalEl);
    if (cartButton) cartButton.disabled = true;
    var error = q('#iz-bld-submit-error', modalEl);
    if (error) error.hidden = true;
    closeStickerPanel(); closeFontPicker();
    setFontPicker(FONTS[0].v, false); updateCaptionPreview(); updateStickerCountBadge();
    if (stickerZoomEl) stickerZoomEl.hidden = true;
    if (photoImg) { photoImg.onload = null; photoImg.removeAttribute('src'); photoImg.style.transform = ''; }
    [gridEl, finalGridEl].forEach(function (node) { if (node) node.replaceChildren(); });
    modalEl.querySelectorAll('canvas').forEach(function (canvas) { canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height); });
    ['iz-bld-sp-art-img', 'iz-pvw-barcode'].forEach(function (id) {
      var image = q('#' + id, modalEl); if (image) image.removeAttribute('src');
    });
    modalEl.querySelectorAll('[data-bg]').forEach(function (button) {
      button.style.border = button.getAttribute('data-bg') === 'photo' ? '2px solid #1ED760' : '2px solid transparent';
    });
    renderUploadThumbs(); updateUploadStatus(); validateUploadPhase(); updateGridProgress();
    showPhase('upload');
  }

  var cartSubmissionPending = false;
  function submitCart() {
    if (cartSubmissionPending) return;
    if (!formEl || !submitBtn) { alert('Form bulunamadı.'); return; }

    /* Buton zaten isaretlenmeden pasif kalir — bu sadece savunma amacli
       (orn. bir sekilde disabled atlatilirsa) ikinci bir kontrol. */
    var copyrightChk = q('#iz-bld-copyright-ok', modalEl);
    if (copyrightChk && !copyrightChk.checked) {
      alert('Devam etmeden önce lütfen telif hakkı onay kutusunu işaretleyin.');
      return;
    }

    cartSubmissionPending = true;
    var cartButton = q('#iz-bld-cart', modalEl);
    if (cartButton) cartButton.disabled = true;
    var submissionSettled = false;
    var pdfTimer = null;
    var cartTimer = null;
    var cartRequestStarted = false;
    var submissionId = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    var submissionForm = formEl;
    var previousPdf = formEl.querySelector('[data-iz-pdf]');
    if (previousPdf) previousPdf.parentNode.removeChild(previousPdf);
    var submissionError = q('#iz-bld-submit-error', modalEl);
    if (submissionError) submissionError.hidden = true;
    showPdfOverlay();

    function stopWatchingCart() {
      clearTimeout(cartTimer);
      submissionForm.removeEventListener('iz-builder:cart-result', onCartResult);
    }
    function onCartResult(event) {
      if (submissionSettled || !event.detail || event.detail.submissionId !== submissionId) return;
      if (!event.detail.success) {
        failSubmission(event.detail.message || 'Sepete ekleme doğrulanamadı. Tasarımınız korundu; tekrar denemeden önce sepetinizi kontrol edin.');
        return;
      }
      submissionSettled = true;
      clearTimeout(pdfTimer); stopWatchingCart();
      cartSubmissionPending = false;
      hidePdfOverlay();
      resetCompletedDesign();
    }
    function failSubmission(message) {
      if (submissionSettled) return;
      submissionSettled = true;
      clearTimeout(pdfTimer);
      stopWatchingCart();
      cartSubmissionPending = false;
      hidePdfOverlay();
      if (cartRequestStarted) openModal();
      if (cartButton) cartButton.disabled = !!(copyrightChk && !copyrightChk.checked);
      var stalePdf = formEl.querySelector('[data-iz-pdf]');
      if (stalePdf) stalePdf.parentNode.removeChild(stalePdf);
      if (!submissionError) {
        submissionError = document.createElement('p');
        submissionError.id = 'iz-bld-submit-error';
        submissionError.className = 'pozca-ux-submit-error';
        submissionError.setAttribute('role', 'alert');
        submissionError.setAttribute('tabindex', '-1');
        if (cartButton) cartButton.parentNode.insertBefore(submissionError, cartButton);
        else modalEl.appendChild(submissionError);
      }
      submissionError.textContent = message;
      submissionError.hidden = false;
      submissionError.focus();
    }
    var fileErrorMessage = 'Tasarım dosyanız hazırlanırken bağlantı zaman aşımına uğradı. Lütfen internet bağlantınızı kontrol edip tekrar \'Sipariş Ver\' butonuna basın.';

    function doSubmit(backendProps) {
      if (submissionSettled) return;
      formEl.querySelectorAll('[data-iz-builder]').forEach(function (el) { el.parentNode.removeChild(el); });

      function injectHidden(name, value) {
        var inp = document.createElement('input');
        inp.type  = 'hidden';
        inp.name  = 'properties[' + name + ']';
        inp.value = value;
        inp.setAttribute('data-iz-builder', '1');
        formEl.appendChild(inp);
      }

      /* Yeni backend entegrasyonu (ani-kutusu): template_id + photo_N_* alanlari.
         Bunlar polaroid_project'in webhook'unun okudugu makine-okur properties'tir. */
      if (backendProps) {
        Object.keys(backendProps).forEach(function (key) {
          injectHidden(key, backendProps[key]);
        });
      }

      injectHidden('_pozca_design_id', submissionId);
      injectHidden('_Tasarım Sayısı', slots.length + ' adet');
      injectHidden('_PDF Tarihi', new Date().toLocaleString('tr-TR'));

      slots.forEach(function (slot, i) {
        var no = i + 1;
        if (slot.caption) injectHidden('_Tasarım ' + no + ' Notu', slot.caption);
        if (productType !== 'foto-builder') {
          injectHidden('_Tasarım ' + no + ' Fontu', slot.font.split(',')[0].replace(/['"]/g, ''));
        }
        /* Foto-builder: crop bilgisini ekle (owner Figma'da kullanacak) */
        if (productType === 'foto-builder') {
          var cropInfo = 'offX:' + Math.round(slot.offX || 0) + ' offY:' + Math.round(slot.offY || 0);
          injectHidden('_Fotoğraf ' + no + ' Kadraj', cropInfo);
        }
      });

      /* Spotify bilgisini sipariş property'sine ekle — musteriye sepette gozukmesin,
         merchant admin panelinden gorebilir (alt cizgi Shopify tarafindan otomatik gizlenir) */
      if (spotifyTrackId) injectHidden('_Spotify Track ID', spotifyTrackId);
      var _spInp = q('#iz-bld-spotify-url', modalEl);
      if (_spInp && _spInp.value.trim()) injectHidden('_Spotify Linki', _spInp.value.trim());
      if (spotifyTitle)  injectHidden('_Şarkı Adı', spotifyTitle);
      if (spotifyArtist) injectHidden('_Sanatçı',   spotifyArtist);
      if (posterName)    injectHidden('_Poster İsim', posterName);

      var _ot = document.querySelector('.iz-pdf-overlay__title');
      var _os = document.querySelector('.iz-pdf-overlay__sub');
      if (_ot) _ot.textContent = 'Sepete ekleniyor…';
      if (_os) {
        /* backendProps varsa (ani-kutusu, netflix-poster-tablo vb.) baski dosyasi
           siparis sonrasi sunucuda hazirlanir — musteriye bunun biraz zaman
           alabilecegini belirtelim, "islem yapilmiyor" hissi vermesin */
        _os.textContent = backendProps
          ? 'Lütfen bekleyin — fotoğraflarınızın boyutu yüksek olduğu için birkaç dakika sürebilir'
          : 'Lütfen bekleyin';
      }

      closeModal();
      submitBtn.removeAttribute('disabled');

      // Wait for this exact request's parsed Shopify result, not a resolved fetch promise.
      cartRequestStarted = true;
      submissionForm.addEventListener('iz-builder:cart-result', onCartResult);
      cartTimer = setTimeout(function () {
        failSubmission('Sepete ekleme zaman aşımına uğradı. Tasarımınız korundu; tekrar denemeden önce sepetinizi kontrol edin.');
      }, 30000);
      try { submitBtn.click(); }
      catch (err) { failSubmission('Sepete eklenemedi. Tasarımınız korundu; lütfen yeniden deneyin.'); }

    }

    /* Yeni (kalite kaybetmeyen) yol: backend'de gercek bir sablonu olan urunler
       icin PDF/canvas hic uretilmez — orijinal fotograflar dogrudan Flask
       API'ye yuklenir, sunucu 300 DPI'da kayipsiz composite eder. Hangi
       urunun bu yolu kullanacagi Shopify urun handle'ina degil, o urune
       Liquid'de atanan photoTemplateId'ye gore belirlenir (BACKEND_TEMPLATE_IDS) —
       boylece yeni bir boy/urun eklerken JS'de handle eklemeye gerek kalmaz,
       sadece iz-builder.liquid'e data-photo-template-id eklemek yeterli olur.
       Diger urun tipleri (muzik-tablosu, duz-baski, ozel-poster, foto-builder)
       eski PDF akisini aynen kullanmaya devam eder. */
    var useBackendPipeline = BACKEND_TEMPLATE_IDS.indexOf(photoTemplateId) !== -1 && !!photoApiBase;
    if (useBackendPipeline) {
      loadBackendSlotDims()
        .then(function () {
          return buildBackendPropsAndUpload();
        })
        .then(function (props) {
          doSubmit(props);
        })
        .catch(function (err) {
          console.error('[İz Builder] Backend yükleme hatası:', err);
          if (err && err.message === 'RATE_LIMIT') {
            failSubmission('Çok sayıda fotoğrafı hızlı yüklediniz. Lütfen 1 dakika bekleyip tekrar deneyin.');
            return;
          }
          failSubmission(fileErrorMessage);
        });
      return;
    }

    /* Dosya hazırlanmadan sepete gönderme; geç gelen yanıt da gönderemez. */
    pdfTimer = setTimeout(function () {
      failSubmission(fileErrorMessage);
    }, 25000);

    Promise.resolve().then(function () { return generatePDF(); })
      .then(function (pdfBlob) {
        if (submissionSettled) return;
        if (!pdfBlob || !pdfBlob.size || pdfBlob.type !== 'application/pdf') {
          throw new Error('Baskı PDF dosyası oluşturulamadı.');
        }
        var pdfInp = formEl.querySelector('[data-iz-pdf]');
        if (!pdfInp) {
          pdfInp = document.createElement('input');
          pdfInp.type  = 'file';
          pdfInp.name  = 'properties[_Baskı PDF]';
          pdfInp.setAttribute('data-iz-pdf', '1');
          pdfInp.style.display = 'none';
          formEl.appendChild(pdfInp);
        }
        var dt = new DataTransfer();
        dt.items.add(new File([pdfBlob], productType + '-tasarim.pdf', { type: 'application/pdf' }));
        pdfInp.files = dt.files;
        if (!pdfInp.files || pdfInp.files.length !== 1 || !pdfInp.files[0].size) {
          throw new Error('Baskı PDF dosyası forma eklenemedi.');
        }

        clearTimeout(pdfTimer);
        doSubmit();
      })
      .catch(function (err) {
        console.error('[İz Builder] PDF hatası:', err);
        failSubmission(fileErrorMessage);
      });
  }

  /* ─────────────────────────────────────────────── */
  /*  Init                                            */
  /* ─────────────────────────────────────────────── */
  function init() {
    triggerBtn = document.getElementById('iz-builder-open');
    if (!triggerBtn) return;

    MAX_SLOTS    = parseInt(triggerBtn.getAttribute('data-max-slots')       || '20')  || 20;
    printStyle   = triggerBtn.getAttribute('data-print-style')  || 'polaroid';
    paperSize    = triggerBtn.getAttribute('data-paper-size')   || 'a4';
    cardW        = parseInt(triggerBtn.getAttribute('data-card-w')          || '90')  || 90;
    cardH        = parseInt(triggerBtn.getAttribute('data-card-h')          || '110') || 110;
    customPaperW = parseInt(triggerBtn.getAttribute('data-custom-paper-w')  || '130') || 130;
    customPaperH = parseInt(triggerBtn.getAttribute('data-custom-paper-h')  || '180') || 180;
    strictCount  = triggerBtn.getAttribute('data-strict-count') !== 'false';
    productType  = triggerBtn.getAttribute('data-product-type') || 'ani-kutusu';
    hasSpotify   = triggerBtn.getAttribute('data-has-spotify')  === 'true';
    photoApiBase    = (triggerBtn.getAttribute('data-photo-api-base') || '').replace(/\/$/, '');
    photoTemplateId = triggerBtn.getAttribute('data-photo-template-id') || 'ani_kutusu';

    /* Palo kart urunleri: sadece belirli (gercekten basilan) fontlar arasindan
       secim yaptirmak icin data-caption-fonts="roboto,pacifico" kullanilir. */
    var _captionFontsRaw = (triggerBtn.getAttribute('data-caption-fonts') || '').trim();
    if (_captionFontsRaw) {
      var restricted = _captionFontsRaw.split(',').map(function (s) { return s.trim(); })
        .filter(function (k) { return RESTRICTED_FONTS[k]; })
        .map(function (k) { return RESTRICTED_FONTS[k]; });
      if (restricted.length) FONTS = restricted;
    }

    /* Foto-builder: şablon konfigürasyon */
    var _fotoCfgRaw = triggerBtn.getAttribute('data-foto-config');
    if (_fotoCfgRaw) {
      try {
        templateConfig = JSON.parse(_fotoCfgRaw);
        productType = 'foto-builder';
        /* Şablon slot sayısını MAX_SLOTS'a yansıt */
        if (templateConfig.slots && templateConfig.slots.length) {
          MAX_SLOTS = templateConfig.slots.length;
        }
      } catch (e) { templateConfig = null; }
    }
    q('#iz-bld-max-label') && (q('#iz-bld-max-label').textContent = MAX_SLOTS);

    /* Product form refs */
    formEl    = document.querySelector('[data-type="add-to-cart-form"]');
    submitBtn = formEl && formEl.querySelector('[type="submit"][name="add"]');

    window.addEventListener('pageshow', function () {
      if (resetOnPageRestore) resetCompletedDesign();
    });

    triggerBtn.addEventListener('click', function () {
      /* Musteri "Tasarla"ya bastigi an, varyant onceden degismis olabilir —
         bu ana kadar canli takip (pubsub/DOM-observer) bir sekilde kacirmis
         olsa bile, burada artik hicbir yaris durumu yok: secim uzun suredir
         sabitlenmis, DOM'daki GERCEK secili varyant id'sini simdi okuyup
         MAX_SLOTS'u kesin dogru degere senkronlar. Degisiklik varsa (gruplu
         urunlerde) atama oturumu sifirlanir/sorulur ve upload fazina
         donulur — "varyant degistirip Tasarla'ya basinca ilk sayfa yukleme
         sayfasi olsun" istegi de boylece karsilanmis olur.
         ONEMLI: modal, bu is TAMAMEN bitene kadar (musteri onay penceresini
         Evet/Hayir ile yanitlayana kadar) ACILMIYOR — boylece modal acildiginda
         faz zaten kesinlesmis olur, "Evet" ile "Hayir" arasinda farkli/tutarsiz
         bir davranis olmaz. */
      _applyFromLiveInputValue(openModal);
    });

    var variantIdInput = formEl && formEl.querySelector('[name="id"]');

    /* Varyant başlığından kağıt boyutunu algıla (muzik-tablosu için) */
    function detectPaperSizeFromTitle(title) {
      if (!title) return;
      var t = title.toUpperCase();
      if (t.indexOf('A5') !== -1) paperSize = 'a5';
      else if (t.indexOf('A3') !== -1) paperSize = 'a3';
      else if (t.indexOf('A4') !== -1) paperSize = 'a4';
    }

    /* İlk yüklenmede mevcut varyantı oku */
    if (productType === 'muzik-tablosu') {
      var _varSel = document.querySelector('select[name="id"]');
      if (_varSel) {
        var _selOpt = _varSel.options[_varSel.selectedIndex];
        if (_selOpt) detectPaperSizeFromTitle(_selOpt.text);
      } else {
        var _varInp = document.querySelector('input[name="id"]');
        if (_varInp) {
          var _opt = document.querySelector('option[value="' + _varInp.value + '"]');
          if (_opt) detectPaperSizeFromTitle(_opt.textContent);
        }
      }
    }

    /* Update slot count when variant changes.
       Dawn temasi varyant degisimini "variant:change" adinda duz bir DOM
       event'i olarak degil, kendi pubsub.js/constants.js sistemiyle
       PUB_SUB_EVENTS.variantChange ("variant-change") olarak yayinlar —
       hicbir yerde gercekten "variant:change" dispatch edilmedigi icin bu
       dinleyici hic tetiklenmiyordu ve MAX_SLOTS sayfa yuklendigindeki
       varyantta sonsuza kadar kilitli kaliyordu. */
    /* "Boy"/"Boyut" secenegi miktar degil, fiziksel baski boyu (15x21=A5,
       21x30=A4, digerleri A3). Varyant degisince dogru sablona (ve
       dolayisiyla dogru foto alani/metin konumlarina, GERCEK A5/A4/A3
       piksel boyutuna) gecmemiz lazim — yoksa hangi boy secilirse secilsin
       hep ayni (varsayilan A3) dosya uretilirdi. Her urunun kendi A3/A4/A5
       sablon ucluesu POSTER_SIZE_TEMPLATE_MAP'te tanimli; "a3" anahtari her
       zaman o urunun ORIJINAL (suffix'siz) sablon id'sine karsilik gelir —
       A4/A5 siz A3 sablonundan (arkaplan/onkat gorseli LANCZOS ile, tum
       piksel koordinatlari orantili) turetilip templates/ klasorune ayrica
       eklendi. */
    var POSTER_SIZE_TEMPLATE_MAP = {
      'netflix-poster-tablo': { a5: 'netflix_posteri_a5', a4: 'netflix_posteri_a4', a3: 'netflix_posteri_a3' },
      'google-arama-poster-tablo': { a5: 'google_arama_poster_a5', a4: 'google_arama_poster_a4', a3: 'google_arama_poster' },
      'ani-gazetesi-poster-tablo': { a5: 'ani_gazetesi_poster_a5', a4: 'ani_gazetesi_poster_a4', a3: 'ani_gazetesi_poster' },
      'kalbimdeki-anilar-sarkili-takvim-tablosu': { a5: 'ani_takvimi_poster_a5', a4: 'ani_takvimi_poster_a4', a3: 'ani_takvimi_poster' },
      'askin-kalbi-i̇simli-ve-sarkili-poster-tablo': { a5: 'askin_kalbi_poster_a5', a4: 'askin_kalbi_poster_a4', a3: 'askin_kalbi_poster' },
    };
    var POSTER_SIZE_DIMS_MM = { a5: [148, 210], a4: [210, 297], a3: [297, 420] };
    function _applyPosterSizeFromVariant(variant) {
      var sizeMap = POSTER_SIZE_TEMPLATE_MAP[productType];
      if (!sizeMap || !variant) return;
      var title = (variant.title || variant.name || '').toLowerCase();
      var sizeKey = 'a3';
      if (title.indexOf('15x21') !== -1) sizeKey = 'a5';
      else if (title.indexOf('21x30') !== -1) sizeKey = 'a4';
      var newTemplateId = sizeMap[sizeKey];
      var dims = POSTER_SIZE_DIMS_MM[sizeKey];
      if (newTemplateId !== photoTemplateId) {
        photoTemplateId = newTemplateId;
        backendSlotDims = null;
        backendSlotDimsPromise = null;
      }
      triggerBtn.setAttribute('data-photo-template-id', photoTemplateId);
      triggerBtn.setAttribute('data-card-w', dims[0]);
      triggerBtn.setAttribute('data-card-h', dims[1]);
    }

    /* MAX_SLOTS'u data-slots-map + verilen varyant id'sinden hesaplayip
       uygular. Pubsub olayi Dawn'in KENDI, guvenilir/anlik varyant bildirim
       mekanizmasidir (tam varyant nesnesini dogrudan tasir) — bu yuzden
       DOM'dan (gizli "id" input'unun .value'su) tekrar okumaya calismak
       yerine PUBSUB'IN VERDIGI variant.id DOGRUDAN kullanilir; input tabanli
       DOM-mutation/`change` yontemi (asagida, sadece pubsub yoksa devrede)
       ayrica su an DOM'da GERCEKTEN bulunan input'u HER SEFERINDE yeniden
       sorgular (querySelector), cunku bazi temalar varyant degisince ilgili
       form bolumunu tamamen yeniden render edip eski input referansini
       "kopukbir dugum" haline getirebiliyor — o zaman eski deger sonsuza
       kadar okunur, MAX_SLOTS hep eski varyantta "takili" kalirdi. */
    function _applyMaxSlotsFromVariantId(vId, onDone) {
      if (productType === 'netflix-poster-tablo' || !vId) { if (onDone) onDone(); return; }
      var mapStr = triggerBtn.getAttribute('data-slots-map');
      if (!mapStr) { if (onDone) onDone(); return; }
      try {
        var map = JSON.parse(mapStr.replace(/&quot;/g, '"'));
        if (map[String(vId)] !== undefined) {
          var prevMax = MAX_SLOTS;
          MAX_SLOTS = parseInt(map[String(vId)]) || MAX_SLOTS;
          var lbl = q('#iz-bld-max-label', modalEl);
          if (lbl) lbl.textContent = MAX_SLOTS;
          if (isGroupedFlow() && MAX_SLOTS !== prevMax) {
            resetGroupedAssignmentSession(onDone);
            return;
          }
        }
      } catch (err) {}
      if (onDone) onDone();
    }

    function _applyVariantSlotCount(variant) {
      if (!variant) return;
      if (productType === 'muzik-tablosu') detectPaperSizeFromTitle(variant.title || variant.name || '');
      _applyPosterSizeFromVariant(variant);
      /* netflix-poster-tablo ve google-arama-poster-tablo'nun "Boy"/"Boyut"
         secenegi bir miktar degil, fiziksel baski boyu — bu urunlerde "Adet"
         secenegi hic olmadigi icin asagidaki genel data-slots-map (miktar)
         haritasi, varyant basligindaki sayiyi ("15x21" -> 15) yanlislikla
         foto sayisi saniyordu. Bu urunler HER ZAMAN sabit sayida foto
         aldigi icin (netflix: 1, google poster: 5) haritayi hic kullanma. */
      if (FIXED_SLOT_COUNT_PRODUCT_TYPES.indexOf(productType) !== -1) return;
      _applyMaxSlotsFromVariantId(variant.id);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        _applyVariantSlotCount(payload && payload.data && payload.data.variant);
      });
    }
    /* Yedek: pubsub bir sekilde yuklenmemisse yine de native "id" input'unun
       degisimini dinler — ama input'u her tetiklenmede DOM'dan TAZE sorgular
       (yukarida acikland gibi, baslangicta yakalanan referans temanin
       yeniden render etmesiyle kopabilir). */
    function _applyFromLiveInputValue(onDone) {
      if (FIXED_SLOT_COUNT_PRODUCT_TYPES.indexOf(productType) !== -1) { if (onDone) onDone(); return; }
      var liveInput = (formEl && formEl.querySelector('[name="id"]')) || variantIdInput;
      _applyMaxSlotsFromVariantId(liveInput && liveInput.value, onDone);
    }
    if (variantIdInput) {
      new MutationObserver(function () { _applyFromLiveInputValue(); }).observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
      variantIdInput.addEventListener('change', function () { _applyFromLiveInputValue(); });
    }
    if (formEl) {
      formEl.addEventListener('change', function () { _applyFromLiveInputValue(); });
    }

    buildModal();
    showPhase('upload');

    /* Google Fonts <link> etiketi sayfa yuklenisini yavaslatmamak icin
       "media=print, yuklenince all'a cevir" numarasiyla ASENKRON yukleniyor
       (bkz. iz-builder.liquid) — yani canvas'in ILK cizimi, font henuz
       tarayiciya inmeden, TARAYICININ YEDEK (fallback) fontuyla olculup
       sarilmis olabilir. Font asil indiginde metin GERCEK (genelde daha
       genis) glifleriyle yeniden cizilir ama satir kirilma noktalari eski
       (yedek fonta gore hesaplanmis) kalir — bu da "Hikayeniz" gibi coklu
       satirli metinlerin kutudan tasip alt satira gecmemesi gibi, font
       yuklenme zamanlamasina bagli, tutarsiz bir goruntuye yol acabiliyordu.
       Fontlar GERCEKTEN yuklendiginde (document.fonts.ready) o an ekranda
       aktif olan canvas'i doğru metriklerle yeniden ciziyoruz. */
    if (window.document && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (phaseEls.editor && phaseEls.editor.style.display !== 'none') renderPosterEditorCanvas();
        if (phaseEls.group && phaseEls.group.style.display !== 'none') renderGroupCanvas();
        if (phaseEls.final && phaseEls.final.style.display !== 'none') renderFinal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
